import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  TimeInHm: string;
  Upload: any;
};

export type AcceptPaymentRequestInput = {
  /**
   * When type is SIGNATURE, this should be the user's id signed with user's biometric key.
   * When it's VERIFICATION_CODE, the wallet PIN should be sent.
   */
  authenticationCode: Scalars['String'];
  id: Scalars['ID'];
  type: AuthenticationType;
};

export type Actor = Admin | Courier | Customer | Merchant;

export type AddProductToWishlistInput = {
  productId: Scalars['ID'];
  wishlistId: Scalars['ID'];
};

export type Address = {
  __typename?: 'Address';
  estateName?: Maybe<Scalars['String']>;
  floorNumber?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location: Location;
  /** Name is the person name to whom the delivery should be done to */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<PhoneNumber>;
  pickup?: Maybe<Scalars['Boolean']>;
  remark?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  coordinates: GeoCoordinatesInput;
  estateName?: InputMaybe<Scalars['String']>;
  floorNumber?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  location: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  remark?: InputMaybe<Scalars['String']>;
};

export type Admin = {
  __typename?: 'Admin';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  roles: Array<Role>;
  user?: Maybe<User>;
};

export type Aml = {
  __typename?: 'Aml';
  /** Get AML/CFT status of a user */
  refinitivCase: RefinitivCase;
  verified: Scalars['Boolean'];
};

export enum ApprovalState {
  Approved = 'APPROVED',
  ChangesRequired = 'CHANGES_REQUIRED',
  NotInReview = 'NOT_IN_REVIEW',
  Rejected = 'REJECTED',
  ReviewPending = 'REVIEW_PENDING'
}

export enum AuthProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE'
}

export enum AuthenticationType {
  Signature = 'SIGNATURE',
  VerificationCode = 'VERIFICATION_CODE'
}

export type Bill = {
  __typename?: 'Bill';
  accountNumber: Scalars['String'];
  amount: Money;
  dueDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BillTransaction = Transaction & {
  __typename?: 'BillTransaction';
  amount: Money;
  biller: Biller;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  /** The accountNumber that the user is paying for */
  externalAccount?: Maybe<ExternalAccount>;
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Should be a phone payment method */
  issuer?: Maybe<Actor>;
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export enum Biller {
  Dstv = 'DSTV',
  Gotv = 'GOTV',
  NairobiWater = 'NAIROBI_WATER',
  Zukutv = 'ZUKUTV',
  ZukuInternet = 'ZUKU_INTERNET'
}

export type BillingInfoInput = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  administrativeArea: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locality: Scalars['String'];
  phone: PhoneNumberInput;
  postalCode: Scalars['String'];
};

export type BiometricsTokenInput = {
  token: Scalars['String'];
};

export type ByRegistrationNumber = {
  postalAddress: Scalars['String'];
  postalCode: Scalars['String'];
  regNo: Scalars['String'];
};

export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Aura = 'AURA',
  Carta = 'CARTA',
  CartesBancaires = 'CARTES_BANCAIRES',
  CarteBlanche = 'CARTE_BLANCHE',
  ChinaUnionpay = 'CHINA_UNIONPAY',
  Dankort = 'DANKORT',
  Delta = 'DELTA',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Elo = 'ELO',
  EncodedAccountNumber = 'ENCODED_ACCOUNT_NUMBER',
  Enroute = 'ENROUTE',
  Hipercard = 'HIPERCARD',
  Jal = 'JAL',
  Jcb = 'JCB',
  MaestroInternational = 'MAESTRO_INTERNATIONAL',
  MaestroUkDomestic = 'MAESTRO_UK_DOMESTIC',
  Mastercard = 'MASTERCARD',
  Uatp = 'UATP',
  Visa = 'VISA',
  VisaElectron = 'VISA_ELECTRON'
}

export type CategorizedMerchants = {
  __typename?: 'CategorizedMerchants';
  category: MerchantCategory;
  merchants?: Maybe<Array<Merchant>>;
};

export type ChangeMerchantApprovalStateInput = {
  message?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ApprovalState>;
};

export type ChangeMerchantDocumentStatusInput = {
  documentId: Scalars['ID'];
  /** A statement indicating the reason for a document's status change. */
  reason?: InputMaybe<Scalars['String']>;
  status: DocumentStatus;
};

export type ChangeOrdersStatusInput = {
  courierId?: InputMaybe<Scalars['String']>;
  /** Add a reason if the merchant decides to cancel the order or orders */
  ids: Array<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  status: OrderStatus;
};

export type Chat = {
  __typename?: 'Chat';
  chatType: ChatType;
  id: Scalars['ID'];
  lastMessage?: Maybe<Message>;
  members: Array<Actor>;
  unreadMessagesCount: Scalars['Int'];
};

export type ChatEdge = {
  __typename?: 'ChatEdge';
  cursor: Scalars['ID'];
  node: Chat;
};

export enum ChatType {
  Group = 'GROUP',
  Private = 'PRIVATE',
  Support = 'SUPPORT'
}

export type ChatsCursor = {
  __typename?: 'ChatsCursor';
  edges: Array<ChatEdge>;
  pageInfo: PageInfo;
};

/** Identity document country */
export enum Country {
  Ethiopia = 'ETHIOPIA',
  Ghana = 'GHANA',
  Kenya = 'KENYA',
  Nigeria = 'NIGERIA'
}

export type Courier = {
  __typename?: 'Courier';
  addresses?: Maybe<Array<Address>>;
  agreedToTerms: Scalars['Boolean'];
  assignedDeliveries?: Maybe<Array<Delivery>>;
  avatar?: Maybe<Image>;
  courierType?: Maybe<CourierType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentDelivery?: Maybe<Delivery>;
  currentPosition?: Maybe<GeoCoordinates>;
  id?: Maybe<Scalars['ID']>;
  licensePlate?: Maybe<Scalars['String']>;
  online: Scalars['Boolean'];
  onlineStatusChangedAt?: Maybe<Scalars['DateTime']>;
  requireBiometrics: Scalars['Boolean'];
  roles: Array<Role>;
  tag?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  vehicleType?: Maybe<VehicleType>;
  wallet?: Maybe<Wallet>;
};

export type CourierCount = {
  __typename?: 'CourierCount';
  all: Scalars['Int'];
  drivers: Scalars['Int'];
  riders: Scalars['Int'];
};

export type CourierCursor = {
  __typename?: 'CourierCursor';
  edges: Array<CourierEdge>;
  pageInfo: PageInfo;
};

export type CourierCursorInput = {
  courierType?: InputMaybe<CourierType>;
  cursor: CursorInput;
  deliveryInProgress?: InputMaybe<Scalars['Boolean']>;
  online?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filters all couriers that have logged availability within
   * the following since -
   * (now -  since) <= availabilityStatusChangedAt
   */
  onlineSince?: InputMaybe<Scalars['Int']>;
  /**
   * Admin can search couriers by either mobile number / email address / name / cashtag
   * while others by name only
   */
  search?: InputMaybe<Scalars['String']>;
  walletStatus?: InputMaybe<Array<WalletActivationStatus>>;
};

export type CourierEdge = {
  __typename?: 'CourierEdge';
  cursor: Scalars['ID'];
  node: Courier;
};

export type CourierLastLocationInput = {
  currentPosition?: InputMaybe<GeoCoordinatesInput>;
};

export type CourierSelectionInput = {
  deliveryInProgress?: InputMaybe<Scalars['Boolean']>;
  online?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filters all couriers that have logged availability within
   * the following since -
   * (now -  since) <= availabilityStatusChangedAt
   */
  onlineSince?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum CourierType {
  Driver = 'DRIVER',
  Rider = 'RIDER'
}

export type CourierUpdateInput = {
  avatar?: InputMaybe<Scalars['ID']>;
  courierType?: InputMaybe<CourierType>;
  currentPosition?: InputMaybe<GeoCoordinatesInput>;
  licensePlate?: InputMaybe<Scalars['String']>;
  online?: InputMaybe<Scalars['Boolean']>;
  requireBiometrics?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<SettingsInput>;
  vehicleType?: InputMaybe<VehicleType>;
};

export type CourierWithDistance = {
  __typename?: 'CourierWithDistance';
  courier: Courier;
  distanceToPickUpInMeters: Scalars['Int'];
};

export type CouriersList = {
  __typename?: 'CouriersList';
  couriers: Array<Courier>;
  totalCount: Scalars['Int'];
};

export type CouriersSearchResult = {
  __typename?: 'CouriersSearchResult';
  couriers: Array<Courier>;
  totalCount: Scalars['Int'];
};

export type CreateInviteInput = {
  /** This is required for now, but once more ways to invite a person are created it should be optional */
  transfer: TransferCreditInput;
};

export type CreateMerchantDocumentInput = {
  documentType: DocumentType;
  mediaId: Scalars['ID'];
};

export type CreateReelInput = {
  mediaId: Scalars['ID'];
  merchantId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateWishlistInput = {
  name: Scalars['String'];
};

/** Card details. */
export type CreditCardInput = {
  cardNumber: Scalars['String'];
  cvv: Scalars['String'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  type: CardType;
};

export type CreditCardPaymentMethod = PaymentMethod & {
  __typename?: 'CreditCardPaymentMethod';
  id: Scalars['ID'];
  last4Digits: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<PaymentProvider>;
  type: CardType;
};

export enum CurrencyCode {
  /** Kenyan Shilling (KES). */
  Kes = 'KES'
}

export type CursorInput = {
  /** Going forward */
  after?: InputMaybe<Scalars['ID']>;
  /** Going backwards */
  before?: InputMaybe<Scalars['ID']>;
  /** Most be positive integer */
  first?: InputMaybe<Scalars['Int']>;
  /** Most be positive integer */
  last?: InputMaybe<Scalars['Int']>;
};

export type Customer = {
  __typename?: 'Customer';
  addresses?: Maybe<Array<Address>>;
  agreedToTerms: Scalars['Boolean'];
  avatar?: Maybe<Image>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentAddress?: Maybe<Address>;
  id?: Maybe<Scalars['ID']>;
  /** Require biometrics for operations like sending money and buying things */
  requireBiometrics: Scalars['Boolean'];
  roles: Array<Role>;
  settings: Settings;
  tag?: Maybe<Scalars['String']>;
  transactionsCount: Scalars['Int'];
  user?: Maybe<User>;
  wallet?: Maybe<Wallet>;
};

export type CustomerCount = {
  __typename?: 'CustomerCount';
  all: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
  verified: Scalars['Int'];
};

export type CustomerCursor = {
  __typename?: 'CustomerCursor';
  edges: Array<CustomerEdge>;
  pageInfo: PageInfo;
};

export type CustomerCursorInput = {
  cursor: CursorInput;
  /**
   * Admin can search customers by either mobile number / email address / name / cashtag
   * while others by name only
   */
  search?: InputMaybe<Scalars['String']>;
  walletStatus?: InputMaybe<Array<WalletActivationStatus>>;
};

export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  cursor: Scalars['ID'];
  node: Customer;
};

export type CustomerSelectionInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  walletStatus?: InputMaybe<Array<WalletActivationStatus>>;
};

export type CustomerUpdateInput = {
  avatar?: InputMaybe<Scalars['ID']>;
  currentAddressId?: InputMaybe<Scalars['ID']>;
  requireBiometrics?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<SettingsInput>;
};

export type CustomersList = {
  __typename?: 'CustomersList';
  customers: Array<Customer>;
  totalCount: Scalars['Int'];
};

export type CustomersSearchResult = {
  __typename?: 'CustomersSearchResult';
  customers: Array<Customer>;
  totalCount: Scalars['Int'];
};

export type CybersourceDepositInput = {
  billingInfo: BillingInfoInput;
  creditCard: CreditCardInput;
  money: MoneyInput;
};

export type CybersourceDeviceCollectionJwt = CybersourceJwt & {
  __typename?: 'CybersourceDeviceCollectionJwt';
  jwt: Scalars['String'];
  ref: Scalars['ID'];
};

export type CybersourceJwt = {
  jwt: Scalars['String'];
  ref: Scalars['ID'];
};

export type CybersourceStepupJwt = CybersourceJwt & {
  __typename?: 'CybersourceStepupJwt';
  jwt: Scalars['String'];
  md: Scalars['ID'];
  ref: Scalars['ID'];
};

export type DailySpend = {
  __typename?: 'DailySpend';
  highestEver: HighestEver;
  spentToday: Money;
};

export type DateInterval = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

/** Input the predefined date presets which translate to DateInterval(date_interval) */
export enum DatePreset {
  AllTime = 'ALL_TIME',
  Last_4Months = 'LAST_4_MONTHS',
  Last_7Days = 'LAST_7_DAYS',
  LastYear = 'LAST_YEAR',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY'
}

export enum DebitOrCredit {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type DeliveriesList = {
  __typename?: 'DeliveriesList';
  deliveries: Array<Delivery>;
  totalCount: Scalars['Int'];
};

export type DeliveriesSearchResult = {
  __typename?: 'DeliveriesSearchResult';
  deliveries: Array<Delivery>;
  totalCount: Scalars['Int'];
};

export type Delivery = {
  __typename?: 'Delivery';
  courier?: Maybe<Courier>;
  customer: Customer;
  dropOff: Address;
  id: Scalars['ID'];
  orderBatch: OrderBatch;
  pickUp: Address;
  status: DeliveryStatus;
};

export type DeliveryActivity = {
  __typename?: 'DeliveryActivity';
  count: Scalars['Int'];
  timeSeriesInterval: TimeSeriesInterval;
};

export type DeliveryActivityInput = {
  date?: InputMaybe<DateInterval>;
  datePreset?: InputMaybe<DatePreset>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  timeSeriesConfig: TimeSeriesConfigInput;
};

export type DeliveryFilterInput = {
  courierIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<DeliveryStatus>>;
};

export type DeliveryRequest = {
  __typename?: 'DeliveryRequest';
  /** User that assigned the request to the courier. */
  admin: Admin;
  availableUntil: Scalars['DateTime'];
  courier: Courier;
  delivery: Delivery;
  id: Scalars['ID'];
};

export type DeliveryRequestInput = {
  courierId: Scalars['ID'];
  deliveryId: Scalars['ID'];
};

export type DeliverySelectionInput = {
  /** Filter by couriers */
  courierIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by date */
  date?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Filter by delivery status */
  status?: InputMaybe<Array<DeliveryStatus>>;
};

export enum DeliveryStatus {
  Cancelled = 'CANCELLED',
  CourierConfirmationPending = 'COURIER_CONFIRMATION_PENDING',
  Done = 'DONE',
  DropOff = 'DROP_OFF',
  PickUp = 'PICK_UP',
  Unassigned = 'UNASSIGNED'
}

export type DeliveryStatusUpdate = Event & {
  __typename?: 'DeliveryStatusUpdate';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  orderBatch: OrderBatch;
  type: EventType;
};

export type DepositInput = {
  money: MoneyInput;
  /** Use this field if you don't want to save the payment method. */
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  /** Use this field if you need to access a saved payment method. */
  savedPaymentMethodId?: InputMaybe<Scalars['ID']>;
};

export type DistanceFilterInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  radiusInMetres?: InputMaybe<Scalars['Int']>;
};

export enum DocumentStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export enum DocumentType {
  Cr12 = 'CR12',
  Directors = 'DIRECTORS',
  IncorporationCertificate = 'INCORPORATION_CERTIFICATE',
  KraPin = 'KRA_PIN',
  PartnershipDeed = 'PARTNERSHIP_DEED',
  RegistrationCertificate = 'REGISTRATION_CERTIFICATE'
}

export type EarningsAmount = {
  __typename?: 'EarningsAmount';
  failed: Money;
  pending: Money;
  total: Money;
};

export type EarningsAmountInput = {
  datePreset?: InputMaybe<DatePreset>;
  transactionStatus?: InputMaybe<TransactionStatus>;
};

export type Error = {
  type: ErrorTypes;
};

export enum ErrorTypes {
  AccountLocked = 'ACCOUNT_LOCKED',
  /** Used when a transaction results in excess of a wallet limit */
  AmountLimitExceeded = 'AMOUNT_LIMIT_EXCEEDED',
  AuthenticationCodeFailed = 'AUTHENTICATION_CODE_FAILED',
  BiometricsVerificationFailed = 'BIOMETRICS_VERIFICATION_FAILED',
  /** Maps all errors from Cybersource */
  CybersourceError = 'CYBERSOURCE_ERROR',
  DailyLimitExceeded = 'DAILY_LIMIT_EXCEEDED',
  DeliveryCreationFailed = 'DELIVERY_CREATION_FAILED',
  DuplicateAddressLocation = 'DUPLICATE_ADDRESS_LOCATION',
  /** Returned when a wishlist name is duplicated */
  DuplicateWishlistName = 'DUPLICATE_WISHLIST_NAME',
  InsufficientCredit = 'INSUFFICIENT_CREDIT',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidOtp = 'INVALID_OTP',
  /** Used when depositing or withdrawing using MPESA, if the number is not registered on MPESA mobile money platform */
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  InvalidSameRecipient = 'INVALID_SAME_RECIPIENT',
  MultipleMerchantProduct = 'MULTIPLE_MERCHANT_PRODUCT',
  NotAuthorized = 'NOT_AUTHORIZED',
  /** Used during purchase, this relates to product not being available for purchase */
  NotAvailable = 'NOT_AVAILABLE',
  NotFound = 'NOT_FOUND',
  NotRegistered = 'NOT_REGISTERED',
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  PaymentMethodProcessingFailed = 'PAYMENT_METHOD_PROCESSING_FAILED',
  /** Protected field: Only Admins and owners can access the field */
  ProtectedField = 'PROTECTED_FIELD',
  /** Service error, please retry */
  ServerError = 'SERVER_ERROR',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  /** Something wrong happened during a transaction */
  TransactionFailed = 'TRANSACTION_FAILED',
  ValidationError = 'VALIDATION_ERROR',
  /** Used when user has not activated their wallet */
  WalletInactive = 'WALLET_INACTIVE',
  WalletLimitExceeded = 'WALLET_LIMIT_EXCEEDED',
  /** Used when user enters a wrong wallet PIN */
  WrongWalletPin = 'WRONG_WALLET_PIN'
}

export type Event = {
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  type: EventType;
};

export enum EventType {
  DeliveryStatusUpdate = 'DELIVERY_STATUS_UPDATE',
  PaymentRequest = 'PAYMENT_REQUEST',
  SystemNotification = 'SYSTEM_NOTIFICATION',
  Transaction = 'TRANSACTION'
}

export type EventsInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** If this is provided, only return events of types included here. */
  type?: InputMaybe<Array<InputMaybe<EventType>>>;
};

export type EventsList = {
  __typename?: 'EventsList';
  events: Array<Event>;
  totalCount: Scalars['Int'];
};

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  accountNumber: Scalars['String'];
};

export type ExternalAccountInput = {
  accountNumber: Scalars['String'];
};

export type FetchBillInput = {
  accountNumber: Scalars['String'];
  biller: Biller;
};

export type FreeMoneyDevPaymentMethod = PaymentMethod & {
  __typename?: 'FreeMoneyDevPaymentMethod';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum Fulfillment {
  Delivery = 'DELIVERY',
  None = 'NONE'
}

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type GeoCoordinatesInput = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type HighestEver = {
  __typename?: 'HighestEver';
  totalAmount: Money;
  transactionDate: Scalars['DateTime'];
};

export type IdentificationNumberLog = KycVerificationLog & {
  __typename?: 'IdentificationNumberLog';
  citizenship?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  insertedAt: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type IdentificationNumberLogs = {
  __typename?: 'IdentificationNumberLogs';
  logs: Array<Maybe<IdentificationNumberLog>>;
  verified: Scalars['Boolean'];
};

export type Image = {
  __typename?: 'Image';
  id?: Maybe<Scalars['ID']>;
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
};

export type IndividualInput = {
  kraPinId: Scalars['ID'];
};

export type InformaKyb = {
  __typename?: 'InformaKyb';
  businessName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  informaStatus?: Maybe<Scalars['String']>;
  kraPin?: Maybe<Scalars['String']>;
  partners?: Maybe<Array<Maybe<Partner>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type InformaKybInput = {
  byRegistrationNumber?: InputMaybe<ByRegistrationNumber>;
  getIndividualKraPinByIdNumber?: InputMaybe<Scalars['String']>;
  refetch?: InputMaybe<Scalars['Boolean']>;
};

/** Just details about a bank provider */
export type InterswitchBank = {
  __typename?: 'InterswitchBank';
  id: Scalars['ID'];
  logo?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
};

export type InterswitchBankAccountInput = {
  bankAccountNumber: Scalars['String'];
  interswitchBankId: Scalars['ID'];
  name: Scalars['String'];
};

/** Respresents a stored bank account */
export type InterswitchBankAccountPaymentMethod = PaymentMethod & {
  __typename?: 'InterswitchBankAccountPaymentMethod';
  bankAccountNumber: Scalars['String'];
  id: Scalars['ID'];
  interswitchBank?: Maybe<InterswitchBank>;
  name?: Maybe<Scalars['String']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  code: Scalars['String'];
  sender: Customer;
};

export type KycVerificationLog = {
  code: Scalars['String'];
  insertedAt: Scalars['DateTime'];
  message: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

/**
 * It is composed of the following 4 types:
 *
 *   1. Aml
 *   2. IdentificationNumber
 *   3. PhoneNumber
 *   4. Liveness.
 *
 *   Each type has a `verified` boolean field and includes `logs` to show the trail of verification events leading up to the current `verified` state.
 */
export type KycVerificationStatus = {
  __typename?: 'KycVerificationStatus';
  aml?: Maybe<Aml>;
  identificationNumberLogs?: Maybe<IdentificationNumberLogs>;
  livenessLogs?: Maybe<LivenessLogs>;
  matchScore: Scalars['Int'];
  phoneNumberLogs?: Maybe<PhoneNumberLogs>;
};

export type KycVerificationStatusInput = {
  userId: Scalars['ID'];
};

export type KycVerificationStatusUpdateInput = {
  identificationNumberVerified?: InputMaybe<Scalars['Boolean']>;
  livenessVerified?: InputMaybe<Scalars['Boolean']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']>;
  reason: Scalars['String'];
};

export type LimitedCompanyInput = {
  cr12Id: Scalars['ID'];
  directorsIds: Array<Scalars['ID']>;
  incorporationCertificateId: Scalars['ID'];
  kraPinId: Scalars['ID'];
};

export type LivenessLog = KycVerificationLog & {
  __typename?: 'LivenessLog';
  code: Scalars['String'];
  insertedAt: Scalars['DateTime'];
  message: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type LivenessLogs = {
  __typename?: 'LivenessLogs';
  logs: Array<Maybe<LivenessLog>>;
  verified: Scalars['Boolean'];
};

export type LoadCreditTransaction = Transaction & {
  __typename?: 'LoadCreditTransaction';
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
  receiver?: Maybe<Actor>;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export type LoadWalletInput = {
  money: MoneyInput;
  paymentMethodId: Scalars['ID'];
};

/**
 * This is a type in case we want to segment the location into
 * multiple fields like city, street, apartment
 */
export type Location = {
  __typename?: 'Location';
  coordinates: GeoCoordinates;
  formattedAddress: Scalars['String'];
};

export type Login = {
  __typename?: 'Login';
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<Actor>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginWithCodeInput = {
  code: Scalars['String'];
  handle?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
};

export type LoginWithProviderInput = {
  invitationToken?: InputMaybe<Scalars['String']>;
  provider: AuthProvider;
  token: Scalars['String'];
};

export type LogoutInput = {
  refreshToken: Scalars['String'];
};

export type Media = {
  __typename?: 'Media';
  contentType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type MemberStatistics = {
  __typename?: 'MemberStatistics';
  courierCount: CourierCount;
  customerCount: CustomerCount;
  merchantCount: MerchantCount;
};

/** Type of Business. Merchant should only select one business type */
export type Merchant = {
  __typename?: 'Merchant';
  addresses?: Maybe<Array<Address>>;
  agreedToTerms: Scalars['Boolean'];
  allowPayingDirectly?: Maybe<Scalars['Boolean']>;
  applicantsName?: Maybe<Scalars['String']>;
  approvalMessage?: Maybe<Scalars['String']>;
  approvalState?: Maybe<ApprovalState>;
  coverImage?: Maybe<Image>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  /** Merchant KYC Fields */
  idType?: Maybe<VerificationId>;
  informaKyb?: Maybe<InformaKyb>;
  logo?: Maybe<Image>;
  merchantCategories?: Maybe<Array<MerchantCategory>>;
  merchantDocuments?: Maybe<Array<MerchantDocument>>;
  merchantType?: Maybe<MerchantType>;
  name?: Maybe<Scalars['String']>;
  operatingTime?: Maybe<OperatingTime>;
  phone?: Maybe<PhoneNumber>;
  productCategories?: Maybe<Array<ProductCategory>>;
  products: ProductList;
  rating?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  selection?: Maybe<Array<MerchantSelection>>;
  settings: Settings;
  shortDescription?: Maybe<Scalars['String']>;
  showTutorial?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  wallet?: Maybe<Wallet>;
  website?: Maybe<Scalars['String']>;
};


/** Type of Business. Merchant should only select one business type */
export type MerchantInformaKybArgs = {
  input?: InputMaybe<InformaKybInput>;
};


/** Type of Business. Merchant should only select one business type */
export type MerchantProductsArgs = {
  input?: InputMaybe<ProductSelectionInput>;
};

export type MerchantCategory = {
  __typename?: 'MerchantCategory';
  children?: Maybe<Array<MerchantCategory>>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  name: Scalars['String'];
  parent?: Maybe<MerchantCategory>;
};


export type MerchantCategoryChildrenArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type MerchantCategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
  imageId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};

export type MerchantCount = {
  __typename?: 'MerchantCount';
  all: Scalars['Int'];
  approved: Scalars['Int'];
  pending: Scalars['Int'];
  rejected: Scalars['Int'];
};

export type MerchantCursor = {
  __typename?: 'MerchantCursor';
  edges: Array<MerchantEdge>;
  pageInfo: PageInfo;
};

export type MerchantCursorInput = {
  /** Filter by approval state */
  approvalStates?: InputMaybe<Array<ApprovalState>>;
  cursor: CursorInput;
  /** Filter by merchant category */
  merchantCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by name */
  name?: InputMaybe<Scalars['String']>;
  /** Filter by product category */
  productCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Admin can search merchants by either mobile number / email address / name
   * while others by name only
   */
  search?: InputMaybe<Scalars['String']>;
  /** Filter by selection */
  selection?: InputMaybe<Array<MerchantSelection>>;
};

export type MerchantDocument = {
  __typename?: 'MerchantDocument';
  documentType?: Maybe<DocumentType>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mediaId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']>;
  status?: Maybe<DocumentStatus>;
  /** Protected field: Only Admins can access */
  url?: Maybe<Scalars['String']>;
};

export type MerchantDocumentsInput = {
  /** Admin can get merchant documents by providing merchantId */
  merchantId?: InputMaybe<Scalars['ID']>;
  /** Filter by document status */
  status?: InputMaybe<DocumentStatus>;
};

export type MerchantEdge = {
  __typename?: 'MerchantEdge';
  cursor: Scalars['ID'];
  node: Merchant;
};

export type MerchantFilterInput = {
  merchantSelection?: InputMaybe<Array<MerchantSelection>>;
};

export type MerchantOnboardingInput = {
  agreedToTerms?: InputMaybe<Scalars['Boolean']>;
  allowPayingDirectly?: InputMaybe<Scalars['Boolean']>;
  applicantsName?: InputMaybe<Scalars['String']>;
  coverImage?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  idType?: InputMaybe<VerificationId>;
  logo?: InputMaybe<Scalars['ID']>;
  merchantCategories?: InputMaybe<Array<Scalars['ID']>>;
  merchantType?: InputMaybe<MerchantTypeInput>;
  /** the name of the business */
  name?: InputMaybe<Scalars['String']>;
  operatingTime?: InputMaybe<OperatingTimeInput>;
  /** the phone number of the associated user */
  phone?: InputMaybe<PhoneNumberInput>;
  selection?: InputMaybe<Array<MerchantSelection>>;
  settings?: InputMaybe<SettingsInput>;
  shortDescription?: InputMaybe<Scalars['String']>;
  showTutorial?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export enum MerchantSelection {
  AllowsDirectPayments = 'ALLOWS_DIRECT_PAYMENTS',
  Discounts = 'DISCOUNTS',
  Featured = 'FEATURED',
  HighRated = 'HIGH_RATED',
  Nearby = 'NEARBY',
  Popular = 'POPULAR'
}

export type MerchantSelectionInput = {
  /** Filter by approval state */
  approvalStates?: InputMaybe<Array<ApprovalState>>;
  /** Filter by merchant category */
  merchantCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by name */
  name?: InputMaybe<Scalars['String']>;
  /** Pagination */
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Filter by product category */
  productCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by selection */
  selection?: InputMaybe<Array<MerchantSelection>>;
};

export enum MerchantType {
  Individual = 'INDIVIDUAL',
  LimitedCompany = 'LIMITED_COMPANY',
  Partnership = 'PARTNERSHIP',
  SoleProprietor = 'SOLE_PROPRIETOR'
}

export type MerchantTypeInput = {
  individual?: InputMaybe<IndividualInput>;
  limitedCompany?: InputMaybe<LimitedCompanyInput>;
  partnership?: InputMaybe<PartnershipInput>;
  soleProprietor?: InputMaybe<SoleProprietorInput>;
};

/** Updates the merchant profile */
export type MerchantUpdateInput = {
  allowPayingDirectly?: InputMaybe<Scalars['Boolean']>;
  coverImage?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  /** business email */
  email?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['ID']>;
  merchantCategories?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  operatingTime?: InputMaybe<OperatingTimeInput>;
  /** business phone */
  phone?: InputMaybe<PhoneNumberInput>;
  selection?: InputMaybe<Array<MerchantSelection>>;
  settings?: InputMaybe<SettingsInput>;
  shortDescription?: InputMaybe<Scalars['String']>;
  showTutorial?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
};

export type MerchantWithDistance = {
  __typename?: 'MerchantWithDistance';
  distanceInMeters: Scalars['Int'];
  merchant: Merchant;
};

export type MerchantsList = {
  __typename?: 'MerchantsList';
  merchants: Array<Merchant>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MerchantsSearchResult = {
  __typename?: 'MerchantsSearchResult';
  merchants: Array<Merchant>;
  totalCount: Scalars['Int'];
};

export type Message = {
  __typename?: 'Message';
  author: Actor;
  date: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  edited: Scalars['Boolean'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  media?: Maybe<Media>;
  text: Scalars['String'];
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['ID'];
  node: Message;
};

export type MessagesCursor = {
  __typename?: 'MessagesCursor';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
};

export type Money = {
  __typename?: 'Money';
  amountInCents: Scalars['Int'];
  currencyCode: CurrencyCode;
};

export type MoneyInput = {
  amountInCents: Scalars['Int'];
  currencyCode: CurrencyCode;
};

export type NewMessage = {
  __typename?: 'NewMessage';
  chatId: Scalars['ID'];
  message: Message;
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  email: Scalars['Boolean'];
  phoneCall: Scalars['Boolean'];
  pushNotification: Scalars['Boolean'];
  textMessage: Scalars['Boolean'];
};

export type NotificationChannelInput = {
  email?: InputMaybe<Scalars['Boolean']>;
  phoneCall?: InputMaybe<Scalars['Boolean']>;
  pushNotification?: InputMaybe<Scalars['Boolean']>;
  textMessage?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  account: NotificationChannel;
  general: NotificationChannel;
  promotionalMessages: NotificationChannel;
  reminders: NotificationChannel;
};

export type NotificationSettingsInput = {
  account?: InputMaybe<NotificationChannelInput>;
  general?: InputMaybe<NotificationChannelInput>;
  promotionalMessages?: InputMaybe<NotificationChannelInput>;
  reminders?: InputMaybe<NotificationChannelInput>;
};

export type OperatingTime = {
  __typename?: 'OperatingTime';
  fr?: Maybe<Array<Maybe<TimeInterval>>>;
  mo?: Maybe<Array<Maybe<TimeInterval>>>;
  sa?: Maybe<Array<Maybe<TimeInterval>>>;
  su?: Maybe<Array<Maybe<TimeInterval>>>;
  th?: Maybe<Array<Maybe<TimeInterval>>>;
  tu?: Maybe<Array<Maybe<TimeInterval>>>;
  we?: Maybe<Array<Maybe<TimeInterval>>>;
};

export type OperatingTimeInput = {
  fr?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  mo?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  sa?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  su?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  th?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  tu?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
  we?: InputMaybe<Array<InputMaybe<TimeIntervalInput>>>;
};

export type Order = {
  __typename?: 'Order';
  batches: Array<OrderBatch>;
  buyer: Customer;
  date: Scalars['DateTime'];
  deliveryDeadline?: Maybe<Scalars['DateTime']>;
  fulfillment: OrderFulfillment;
  id: Scalars['ID'];
  referenceNumber: Scalars['String'];
};

export type OrderBatch = {
  __typename?: 'OrderBatch';
  buyer: Customer;
  createdAt: Scalars['DateTime'];
  delivery?: Maybe<Delivery>;
  deliveryDeadline?: Maybe<Scalars['DateTime']>;
  fulfillment: OrderFulfillment;
  id: Scalars['ID'];
  items: Array<OrderListItem>;
  merchant: Merchant;
  /** Payment details */
  payment?: Maybe<OrderBatchTransaction>;
  pickup?: Maybe<Pickup>;
  /** Cancelation reason */
  reason?: Maybe<Scalars['String']>;
  /** Human-readable number that orders can be referenced with. Unique for each merchant. */
  referenceNumber: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  /** Last updated status */
  status: OrderStatus;
  totalCost: Money;
  /** Detailed tracking information */
  tracking: Array<OrderTracking>;
};

export type OrderBatchCursor = {
  __typename?: 'OrderBatchCursor';
  edges: Array<OrderBatchEdge>;
  pageInfo: PageInfo;
};

export type OrderBatchEdge = {
  __typename?: 'OrderBatchEdge';
  cursor: Scalars['ID'];
  node: OrderBatch;
};

export type OrderBatchTransaction = Transaction & {
  __typename?: 'OrderBatchTransaction';
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  orderBatch: OrderBatch;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export type OrderBatchesInput = {
  cursor: CursorInput;
  status?: InputMaybe<Array<OrderStatus>>;
};

export type OrderFilterInput = {
  delivery?: InputMaybe<DeliveryFilterInput>;
  /** Enable filtering by fulfillment type */
  fulfillment?: InputMaybe<OrderFulfillment>;
  pickup?: InputMaybe<PickupFilterInput>;
};

export enum OrderFulfillment {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type OrderInput = {
  address: AddressInput;
  /**
   * When type is SIGNATURE, this should be the user's id signed with user's biometric key.
   * When it's VERIFICATION_CODE, the wallet PIN should be sent.
   */
  authenticationCode: Scalars['String'];
  deliveryDeadline?: InputMaybe<Scalars['DateTime']>;
  fulfillment: OrderFulfillment;
  items: Array<OrderListItemInput>;
  remark?: InputMaybe<Scalars['String']>;
  type: AuthenticationType;
};

export type OrderListItem = {
  __typename?: 'OrderListItem';
  count: Scalars['Int'];
  variant: ProductVariant;
};

export type OrderListItemInput = {
  count: Scalars['Int'];
  variantId: Scalars['ID'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InDelivery = 'IN_DELIVERY',
  New = 'NEW'
}

export type OrderTracking = {
  __typename?: 'OrderTracking';
  status?: Maybe<DeliveryStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnProductsSearchResult = {
  __typename?: 'OwnProductsSearchResult';
  products: Array<Product>;
  totalCount: Scalars['Int'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['ID'];
  entries: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  pages: Scalars['Int'];
  startCursor: Scalars['ID'];
};

export type Partner = {
  __typename?: 'Partner';
  idNumber?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PartnershipInput = {
  directorsIds: Array<Scalars['ID']>;
  kraPinId: Scalars['ID'];
  partnershipDeedId: Scalars['ID'];
  registrationCertificateId: Scalars['ID'];
};

export type PayBillInput = {
  accountNumber: Scalars['String'];
  amount: MoneyInput;
  /**
   * When type is SIGNATURE, this should be the user's id signed with user's biometric key.
   * When it's VERIFICATION_CODE, the wallet PIN should be sent.
   */
  authenticationCode: Scalars['String'];
  biller: Biller;
  type: AuthenticationType;
};

export type PaymentMethod = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/**
 * Exactly one of phone or creditCard or interswitchBankAccount should always be set.
 * When input type unions arrive into GraphQL, it should be changed.
 */
export type PaymentMethodInput = {
  creditCard?: InputMaybe<CreditCardInput>;
  interswitchBankAccount?: InputMaybe<InterswitchBankAccountInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  CreditCard = 'CREDIT_CARD',
  Cybersource = 'CYBERSOURCE',
  FreeMoneyDev = 'FREE_MONEY_DEV',
  InterswitchBank = 'INTERSWITCH_BANK',
  Phone = 'PHONE'
}

export enum PaymentProvider {
  Cybersource = 'CYBERSOURCE'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  amount: Money;
  createdAt: Scalars['DateTime'];
  fulfilled: Scalars['Boolean'];
  id: Scalars['ID'];
  issuer: Actor;
  receiver: Actor;
  remark?: Maybe<Scalars['String']>;
  revoked: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type PaymentRequestEvent = Event & {
  __typename?: 'PaymentRequestEvent';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  paymentRequest: PaymentRequest;
  type: EventType;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type PhoneNumberInput = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type PhoneNumberLog = KycVerificationLog & {
  __typename?: 'PhoneNumberLog';
  code: Scalars['String'];
  insertedAt: Scalars['DateTime'];
  message: Scalars['String'];
  personSearchType: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLogs = {
  __typename?: 'PhoneNumberLogs';
  logs: Array<Maybe<PhoneNumberLog>>;
  verified: Scalars['Boolean'];
};

export type PhoneNumberPaymentMethod = PaymentMethod & {
  __typename?: 'PhoneNumberPaymentMethod';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone: PhoneNumber;
};

export type Pickup = {
  __typename?: 'Pickup';
  address: Address;
  status: PickupStatus;
};

export type PickupFilterInput = {
  address?: InputMaybe<AddressInput>;
  status?: InputMaybe<Array<PickupStatus>>;
};

export enum PickupStatus {
  Collecting = 'COLLECTING',
  Created = 'CREATED',
  Done = 'DONE',
  Ready = 'READY'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Playback = {
  __typename?: 'Playback';
  dash: Scalars['String'];
  hls: Scalars['String'];
};

export type Product = {
  __typename?: 'Product';
  active?: Maybe<Scalars['Boolean']>;
  categories: Array<ProductCategory>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fulfillment?: Maybe<Fulfillment>;
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Field no longer supported */
  images?: Maybe<Array<Maybe<Image>>>;
  merchant?: Maybe<Merchant>;
  options?: Maybe<Array<Maybe<ProductOption>>>;
  restricted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<ProductVariant>>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  active?: Maybe<Scalars['Boolean']>;
  children?: Maybe<Array<ProductCategory>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<ProductCategory>;
  products?: Maybe<ProductList>;
};

export type ProductCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};

export type ProductCursor = {
  __typename?: 'ProductCursor';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductCursorInput = {
  /** Show products for specified categories */
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  cursor: CursorInput;
  /** Show products for specified merchant */
  merchantId?: InputMaybe<Scalars['ID']>;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['ID'];
  node: Product;
};

export type ProductFilterInput = {
  maximumPrice?: InputMaybe<MoneyInput>;
  minimumPrice?: InputMaybe<MoneyInput>;
  minimumReviewScore?: InputMaybe<Scalars['Int']>;
  sortOptions?: InputMaybe<ProductSortOptionsInput>;
};

export type ProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillment?: InputMaybe<Fulfillment>;
  id?: InputMaybe<Scalars['ID']>;
  /** @deprecated Field no longer supported */
  images?: InputMaybe<Array<Scalars['ID']>>;
  options?: InputMaybe<Array<ProductOptionInput>>;
  title?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<ProductVariantInput>>;
};

export type ProductList = {
  __typename?: 'ProductList';
  items: Array<Maybe<Product>>;
  total: Scalars['Int'];
};

export type ProductOption = {
  __typename?: 'ProductOption';
  /** id will be 1, 2, 3 (based on options) */
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductSelectionInput = {
  /** Show products for specified categories */
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProductSortOptionsInput = {
  price?: InputMaybe<SortByDirection>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  default?: Maybe<Scalars['Boolean']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Image>>;
  option?: Maybe<Array<Maybe<SelectedOption>>>;
  price?: Maybe<Money>;
  product?: Maybe<Product>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductVariantInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<Scalars['ID']>>;
  option?: InputMaybe<Array<InputMaybe<SelectedOptionInput>>>;
  price?: InputMaybe<MoneyInput>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PushNotificationTokenInput = {
  platform: Platform;
  token: Scalars['String'];
};

export type ReactToDeliveryRequestInput = {
  accept: Scalars['Boolean'];
  deliveryId: Scalars['ID'];
};

export type RecentTransactionsInput = {
  /** Filter by dates */
  date?: InputMaybe<DateInterval>;
};

export type Reel = {
  __typename?: 'Reel';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  liked: Scalars['Boolean'];
  likes: Scalars['Int'];
  link: Playback;
  merchant: Merchant;
  name: Scalars['String'];
  products: Array<Product>;
  reason?: Maybe<Scalars['String']>;
  restricted?: Maybe<Scalars['Boolean']>;
  shares: Scalars['Int'];
  status: ReelStatus;
  thumbnail: Thumbnail;
  viewed: Scalars['Boolean'];
  views: Scalars['Int'];
};

export type ReelEdge = {
  __typename?: 'ReelEdge';
  cursor: Scalars['ID'];
  node: Reel;
};

export enum ReelStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type ReelsCursor = {
  __typename?: 'ReelsCursor';
  edges: Array<ReelEdge>;
  pageInfo: PageInfo;
};

export type ReelsSelectionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<CursorInput>;
  merchantId?: InputMaybe<Scalars['ID']>;
  /** If you want to randomise the results */
  randomise?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<ReelsSortOptionsInput>;
};

export type ReelsSortOptionsInput = {
  /** Sort reels based on the date inserted */
  insertedAt?: InputMaybe<SortByDirection>;
};

export type RefinitivCase = {
  __typename?: 'RefinitivCase';
  caseId: Scalars['ID'];
  caseSystemId: Scalars['ID'];
  results: Array<RefinitivScreeningResult>;
};

export type RefinitivScreeningResult = {
  __typename?: 'RefinitivScreeningResult';
  category: Scalars['String'];
  gender: Scalars['String'];
  matchScore: Scalars['Float'];
  nationality: Scalars['String'];
  primaryName: Scalars['String'];
  referenceId: Scalars['ID'];
  resultId: Scalars['ID'];
  riskCategories: Array<Scalars['String']>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type RefundTransaction = Transaction & {
  __typename?: 'RefundTransaction';
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  orderBatch: OrderBatch;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export type RemoveProductFromWishlistInput = {
  productId: Scalars['ID'];
  wishlistId: Scalars['ID'];
};

export type RequestLoginCodeInput = {
  agreedToTerms?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
};

export type RequestPaymentInput = {
  amount: MoneyInput;
  remark?: InputMaybe<Scalars['String']>;
  target: UserIdentifier;
};

export type RequestWalletActivationForMerchantInput = {
  cashtag: Scalars['String'];
  phone: PhoneNumberInput;
};

export type RequestWalletActivationInput = {
  cashtag: Scalars['String'];
  country: Country;
  idNumber: Scalars['String'];
  /** Image ids */
  idPhotos: Array<Scalars['ID']>;
  idType: VerificationId;
  name: Scalars['String'];
  phone: PhoneNumberInput;
};

export type RestrictProductInput = {
  id: Scalars['ID'];
  reason: Scalars['String'];
  restricted: Scalars['Boolean'];
};

export type Review = {
  __typename?: 'Review';
  author?: Maybe<Customer>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  score?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type ReviewInput = {
  orderBatchId: Scalars['ID'];
  score: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
};

export enum Role {
  Admin = 'ADMIN',
  Courier = 'COURIER',
  /** Default Role */
  Customer = 'CUSTOMER',
  /** Merchant */
  Merchant = 'MERCHANT'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept and process payment request */
  acceptPaymentRequest?: Maybe<Transaction>;
  addOrUpdateAddresses: Array<Address>;
  addOrUpdateBiometricsToken?: Maybe<Scalars['Boolean']>;
  /** Add or update a category, based on whether its ID is provided */
  addOrUpdateMerchantCategory: MerchantCategory;
  /** Add or update product */
  addOrUpdateProduct?: Maybe<Product>;
  /** Add or update a category, based on whether its ID is provided */
  addOrUpdateProductCategory: ProductCategory;
  addOrUpdatePushNotificationToken?: Maybe<Scalars['Boolean']>;
  /** Adds a new payment method */
  addPaymentMethod?: Maybe<PaymentMethod>;
  /** Add a product to a wish list */
  addProductToWishlist?: Maybe<Scalars['Boolean']>;
  /** Write review */
  addReview?: Maybe<Review>;
  changeCustomerWalletState?: Maybe<WalletActivation>;
  /** Can only be used if you have admin privileges */
  changeMerchantApprovalState?: Maybe<Merchant>;
  /** Can only be used if you have admin privileges */
  changeMerchantDocumentStatus: MerchantDocument;
  changeMultipleMerchantsApprovalState: Array<Merchant>;
  /** Change status for multiple orders */
  changeOrdersStatus?: Maybe<Scalars['Boolean']>;
  checkCardEnrollment: CybersourceStepupJwt;
  createChat: Chat;
  /** Create an invite. Only supports creating one with a transfer input for now. */
  createInvite: Invitation;
  createMerchantDocument: MerchantDocument;
  /** Make a purchase from a merchant */
  createOrder?: Maybe<Order>;
  createReel: Reel;
  /** Create a new wish list to save a product */
  createWishlist?: Maybe<Wishlist>;
  deleteMessage: Message;
  deleteReel: Scalars['Boolean'];
  deleteWishlist?: Maybe<Scalars['Boolean']>;
  /** Add credit using a payment method */
  deposit: Transaction;
  depositWithCybersource: CybersourceDeviceCollectionJwt;
  editMessage: Message;
  /**
   * Allows favoriting a merchant. Favorite merchants show up
   * first in selections that they are eligible for.
   */
  favoriteMerchant?: Maybe<Scalars['Boolean']>;
  inviteCouriers: Scalars['Boolean'];
  /** Load wallet */
  loadWallet?: Maybe<Scalars['Boolean']>;
  /** Lock or unlock merchant/customer/courier */
  lockUsers?: Maybe<Scalars['Boolean']>;
  /** User login */
  login?: Maybe<Login>;
  /** Login with code */
  loginWithCode?: Maybe<Login>;
  loginWithCodeForCourier?: Maybe<Login>;
  loginWithCodeForMerchant?: Maybe<Login>;
  /** Login or register with External Provider */
  loginWithProvider?: Maybe<Login>;
  /** Logout */
  logout?: Maybe<Scalars['Boolean']>;
  /** Merchant login or registration with external provider */
  merchantLoginWithProvider?: Maybe<Login>;
  merchantOnboarding?: Maybe<Merchant>;
  /** Merchant registration */
  merchantSignup?: Maybe<Actor>;
  /** Pay a bill */
  payBill: Transaction;
  reactToDeliveryRequest?: Maybe<Scalars['Boolean']>;
  readMessages: Array<Message>;
  /** Refresh Token */
  refreshToken?: Maybe<Login>;
  removeAddresses?: Maybe<Scalars['Boolean']>;
  /** Remove a merchant category */
  removeMerchantCategory: Scalars['Boolean'];
  /** Removes a payement method */
  removePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Remove a product */
  removeProduct?: Maybe<Scalars['Boolean']>;
  /** Remove a product category */
  removeProductCategory?: Maybe<Scalars['Boolean']>;
  /** Removes a product from a wish list */
  removeProductFromWishlist?: Maybe<Scalars['Boolean']>;
  /** Delete review */
  removeReview?: Maybe<Scalars['Boolean']>;
  /** Request login code */
  requestLoginCode?: Maybe<Scalars['Boolean']>;
  requestLoginCodeForCourier?: Maybe<Scalars['Boolean']>;
  requestLoginCodeForMerchant?: Maybe<Scalars['Boolean']>;
  requestOtpForWithdraw: Scalars['Boolean'];
  /** Request a payment from a user. */
  requestPayment?: Maybe<Scalars['Boolean']>;
  /** Request activation of wallet */
  requestWalletActivation?: Maybe<WalletActivation>;
  /** Request activation of wallet for merchant */
  requestWalletActivationForMerchant?: Maybe<WalletActivation>;
  /** Restrict a product from admin's portal */
  restrictProduct?: Maybe<Product>;
  /** Revoke one of your requests. */
  revokeRequest?: Maybe<Scalars['Boolean']>;
  /** Save a bill */
  saveBill: Scalars['Boolean'];
  /** Send a delivery request to a courier. Only available for admins. */
  sendDeliveryRequest?: Maybe<Scalars['Boolean']>;
  sendMessage: Message;
  /**
   * Sends a verification code to the preregistered phone number linked to the current user's account.
   * Note that if the current user and app are for a merchant, the code will be sent to the phone number linked to the merchant's profile;
   * thereby ignoring the phone number in the parent user.
   */
  sendVerificationCode: Scalars['Boolean'];
  /** Sets the activation PIN */
  setWalletPin?: Maybe<Scalars['Boolean']>;
  shareReel: Scalars['Boolean'];
  /** User registration */
  signup?: Maybe<Actor>;
  startDelivery: Scalars['Boolean'];
  toggleLikeReel: Scalars['Boolean'];
  /** Transfer credit to another user */
  transferCredit: TransferTransaction;
  updateChatMembers: Chat;
  /** Update the last location position of the courier */
  updateCourierLastLocation?: Maybe<Scalars['Boolean']>;
  updateCourierOnlineStatus: Scalars['Boolean'];
  /** Update the delivery status */
  updateDeliveryStatus?: Maybe<Scalars['Boolean']>;
  updateMerchant?: Maybe<Merchant>;
  updateMultipleMerchantsSelections: Array<Merchant>;
  /** Updates a payment method */
  updatePaymentMethod?: Maybe<Scalars['Boolean']>;
  updatePickupStatus: Scalars['Boolean'];
  updateReel: Reel;
  /** Update review */
  updateReview?: Maybe<Scalars['Boolean']>;
  /**
   * Update user info. If the user sending the request
   * has sufficient privileges (cashia admin), he can update
   * other users' info by supplying the ID here, otherwise
   * it just updates the sender's info.
   */
  updateUser?: Maybe<Actor>;
  /** Update admins's password. Only admins can use this mutation */
  updateUserPassword?: Maybe<Actor>;
  uploadMedia?: Maybe<Media>;
  uploadReel: Media;
  /** Verifies a phone number */
  verifyPhone?: Maybe<Scalars['Boolean']>;
  /** Verifies a user's wallet PIN */
  verifyPinOrSignature?: Maybe<Scalars['Boolean']>;
  /** Mark this reel as viewed by the current user */
  viewReel: Scalars['Boolean'];
  /** Withdraw credit from a wallet to a phone number */
  withdraw: Transaction;
};


export type RootMutationTypeAcceptPaymentRequestArgs = {
  input: AcceptPaymentRequestInput;
};


export type RootMutationTypeAddOrUpdateAddressesArgs = {
  input: Array<AddressInput>;
};


export type RootMutationTypeAddOrUpdateBiometricsTokenArgs = {
  input: BiometricsTokenInput;
};


export type RootMutationTypeAddOrUpdateMerchantCategoryArgs = {
  input?: InputMaybe<MerchantCategoryInput>;
};


export type RootMutationTypeAddOrUpdateProductArgs = {
  input?: InputMaybe<ProductInput>;
};


export type RootMutationTypeAddOrUpdateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type RootMutationTypeAddOrUpdatePushNotificationTokenArgs = {
  input: PushNotificationTokenInput;
};


export type RootMutationTypeAddPaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type RootMutationTypeAddProductToWishlistArgs = {
  input: AddProductToWishlistInput;
};


export type RootMutationTypeAddReviewArgs = {
  input: ReviewInput;
};


export type RootMutationTypeChangeCustomerWalletStateArgs = {
  id?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
  state?: InputMaybe<WalletActivationStatus>;
};


export type RootMutationTypeChangeMerchantApprovalStateArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<ChangeMerchantApprovalStateInput>;
};


export type RootMutationTypeChangeMerchantDocumentStatusArgs = {
  input: ChangeMerchantDocumentStatusInput;
};


export type RootMutationTypeChangeMultipleMerchantsApprovalStateArgs = {
  ids: Array<Scalars['ID']>;
  input?: InputMaybe<ChangeMerchantApprovalStateInput>;
};


export type RootMutationTypeChangeOrdersStatusArgs = {
  input: ChangeOrdersStatusInput;
};


export type RootMutationTypeCheckCardEnrollmentArgs = {
  ref: Scalars['ID'];
};


export type RootMutationTypeCreateChatArgs = {
  memberIds: Array<Scalars['ID']>;
};


export type RootMutationTypeCreateInviteArgs = {
  input: CreateInviteInput;
};


export type RootMutationTypeCreateMerchantDocumentArgs = {
  input: CreateMerchantDocumentInput;
};


export type RootMutationTypeCreateOrderArgs = {
  input: OrderInput;
};


export type RootMutationTypeCreateReelArgs = {
  input: CreateReelInput;
};


export type RootMutationTypeCreateWishlistArgs = {
  input: CreateWishlistInput;
};


export type RootMutationTypeDeleteMessageArgs = {
  messageId: Scalars['ID'];
};


export type RootMutationTypeDeleteReelArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteWishlistArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDepositArgs = {
  input?: InputMaybe<DepositInput>;
};


export type RootMutationTypeDepositWithCybersourceArgs = {
  input: CybersourceDepositInput;
};


export type RootMutationTypeEditMessageArgs = {
  messageId: Scalars['ID'];
  text: Scalars['String'];
};


export type RootMutationTypeFavoriteMerchantArgs = {
  favorite: Scalars['Boolean'];
  merchantId: Scalars['ID'];
};


export type RootMutationTypeInviteCouriersArgs = {
  emails: Array<Scalars['String']>;
};


export type RootMutationTypeLoadWalletArgs = {
  input: LoadWalletInput;
  userId: Scalars['ID'];
};


export type RootMutationTypeLockUsersArgs = {
  ids: Array<Scalars['ID']>;
  locked: Scalars['Boolean'];
};


export type RootMutationTypeLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type RootMutationTypeLoginWithCodeArgs = {
  input?: InputMaybe<LoginWithCodeInput>;
};


export type RootMutationTypeLoginWithCodeForCourierArgs = {
  input?: InputMaybe<LoginWithCodeInput>;
};


export type RootMutationTypeLoginWithCodeForMerchantArgs = {
  input?: InputMaybe<LoginWithCodeInput>;
};


export type RootMutationTypeLoginWithProviderArgs = {
  input?: InputMaybe<LoginWithProviderInput>;
};


export type RootMutationTypeLogoutArgs = {
  input?: InputMaybe<LogoutInput>;
};


export type RootMutationTypeMerchantLoginWithProviderArgs = {
  input?: InputMaybe<LoginWithProviderInput>;
};


export type RootMutationTypeMerchantOnboardingArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: MerchantOnboardingInput;
};


export type RootMutationTypeMerchantSignupArgs = {
  input?: InputMaybe<SignupInput>;
};


export type RootMutationTypePayBillArgs = {
  input: PayBillInput;
};


export type RootMutationTypeReactToDeliveryRequestArgs = {
  input: ReactToDeliveryRequestInput;
};


export type RootMutationTypeReadMessagesArgs = {
  messageIds: Array<Scalars['ID']>;
};


export type RootMutationTypeRefreshTokenArgs = {
  input?: InputMaybe<RefreshTokenInput>;
};


export type RootMutationTypeRemoveAddressesArgs = {
  ids: Array<Scalars['ID']>;
};


export type RootMutationTypeRemoveMerchantCategoryArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRemovePaymentMethodArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRemoveProductArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRemoveProductCategoryArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRemoveProductFromWishlistArgs = {
  input: RemoveProductFromWishlistInput;
};


export type RootMutationTypeRemoveReviewArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRequestLoginCodeArgs = {
  input?: InputMaybe<RequestLoginCodeInput>;
};


export type RootMutationTypeRequestLoginCodeForCourierArgs = {
  input?: InputMaybe<RequestLoginCodeInput>;
};


export type RootMutationTypeRequestLoginCodeForMerchantArgs = {
  input?: InputMaybe<RequestLoginCodeInput>;
};


export type RootMutationTypeRequestPaymentArgs = {
  input: RequestPaymentInput;
};


export type RootMutationTypeRequestWalletActivationArgs = {
  input: RequestWalletActivationInput;
};


export type RootMutationTypeRequestWalletActivationForMerchantArgs = {
  input: RequestWalletActivationForMerchantInput;
};


export type RootMutationTypeRestrictProductArgs = {
  input?: InputMaybe<RestrictProductInput>;
};


export type RootMutationTypeRevokeRequestArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeSaveBillArgs = {
  input: SaveBillInput;
};


export type RootMutationTypeSendDeliveryRequestArgs = {
  input: DeliveryRequestInput;
};


export type RootMutationTypeSendMessageArgs = {
  input: SendMessageInput;
};


export type RootMutationTypeSendVerificationCodeArgs = {
  input?: InputMaybe<SendVerificationCodeInput>;
};


export type RootMutationTypeSetWalletPinArgs = {
  input: SetWalletPinInput;
};


export type RootMutationTypeShareReelArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeSignupArgs = {
  input?: InputMaybe<SignupInput>;
};


export type RootMutationTypeStartDeliveryArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeToggleLikeReelArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeTransferCreditArgs = {
  input: TransferCreditInput;
};


export type RootMutationTypeUpdateChatMembersArgs = {
  input: UpdateChatMembersInput;
};


export type RootMutationTypeUpdateCourierLastLocationArgs = {
  input: CourierLastLocationInput;
};


export type RootMutationTypeUpdateCourierOnlineStatusArgs = {
  online: Scalars['Boolean'];
};


export type RootMutationTypeUpdateDeliveryStatusArgs = {
  id: Scalars['ID'];
  status: DeliveryStatus;
};


export type RootMutationTypeUpdateMerchantArgs = {
  id: Scalars['ID'];
  input: MerchantUpdateInput;
};


export type RootMutationTypeUpdateMultipleMerchantsSelectionsArgs = {
  ids: Array<Scalars['ID']>;
  selections: Array<MerchantSelection>;
};


export type RootMutationTypeUpdatePaymentMethodArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<PaymentMethodInput>;
};


export type RootMutationTypeUpdatePickupStatusArgs = {
  id: Scalars['ID'];
  status: PickupStatus;
};


export type RootMutationTypeUpdateReelArgs = {
  id: Scalars['ID'];
  input: UpdateReelInput;
};


export type RootMutationTypeUpdateReviewArgs = {
  id: Scalars['ID'];
  input: ReviewInput;
};


export type RootMutationTypeUpdateUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateUserInput>;
};


export type RootMutationTypeUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type RootMutationTypeUploadMediaArgs = {
  file: Scalars['Upload'];
};


export type RootMutationTypeUploadReelArgs = {
  file: Scalars['Upload'];
};


export type RootMutationTypeVerifyPhoneArgs = {
  input: VerifyPhoneInput;
};


export type RootMutationTypeVerifyPinOrSignatureArgs = {
  input: VerifyPinOrSignatureInput;
};


export type RootMutationTypeViewReelArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeWithdrawArgs = {
  input?: InputMaybe<WithdrawInput>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Show current balance */
  balance: Array<Maybe<Money>>;
  /**
   * Get availible chats for user
   * https://graphql.org/learn/pagination/
   */
  chats: ChatsCursor;
  courier: Courier;
  /** Load couriers search results */
  courierSearch?: Maybe<CouriersSearchResult>;
  /** Gets all couriers */
  couriers: CouriersList;
  /**
   * Get couriers closest to delivery pick up point.
   * Query takes delivery ID and radius in meters as arguments.
   */
  couriersNearDelivery: Array<CourierWithDistance>;
  /** Get all Couriers with cursor based pagination */
  couriersWithCursorPagination: CourierCursor;
  /** Get a single customer */
  customer: Customer;
  /** Load customers search results */
  customerSearch?: Maybe<CustomersSearchResult>;
  /** Get all customers */
  customers?: Maybe<CustomersList>;
  /** Get all customers with cursor based pagination */
  customersWithCursorPagination: CustomerCursor;
  /** Get all deliveries */
  deliveries: DeliveriesList;
  /** Get a specific delivery details */
  delivery: Delivery;
  /** Count of deliveries per interval (in a Time Series format) */
  deliveryActivity: Array<DeliveryActivity>;
  deliveryByOrderId: Delivery;
  /** Get delivery requests that are sent to you (the courier) */
  deliveryRequests: Array<DeliveryRequest>;
  /** Load deliveries search results */
  deliverySearch?: Maybe<DeliveriesSearchResult>;
  /** Payments that the user is asked to do. */
  duePaymentRequests: Array<PaymentRequest>;
  /** total earnings */
  earnings: EarningsAmount;
  /** This is needed to import the error type into the Graphql docs [for Absinthee] */
  error?: Maybe<ValidationError>;
  events: EventsList;
  /** FetchBill, gets the bills details i.e */
  fetchBill: Bill;
  /** FetchSavedBills, gets the saved bills details i.e */
  fetchSavedBills: Array<Maybe<SavedBill>>;
  geoCoordinatesToLocation: Array<Location>;
  /** Get User's KYC verification status */
  getKycVerificationStatus: KycVerificationStatus;
  /** Provides a complete list of all bank providers that we support under Interswitch */
  interswitchBankProviders: Array<InterswitchBank>;
  /** Get an invitation by code */
  invitation: Invitation;
  /**
   * Checks if biometrics is valid for a device, and if false is returned client is suppose to reset biometrics on the device.
   * As an input the public key (token) needs to be sent for verifying the biometrics token.
   */
  isBiometricsValid: Scalars['Boolean'];
  isCashtagAvailable: Scalars['Boolean'];
  /**
   * Checks if a wallet has already been registered with a phone number, that a user has already signed up with.
   * Returns false if not registered which means the phone number is available for linking to a wallet
   * true if registered and unavailable
   */
  isWalletRegistered: Scalars['Boolean'];
  /** Payments that were issued by the user. */
  issuedPaymentRequests: Array<Maybe<PaymentRequest>>;
  /** Get current user */
  me?: Maybe<Actor>;
  /** count merchants, customers, drivers and riders */
  memberStatistics: MemberStatistics;
  /** Get a single merchant */
  merchant?: Maybe<Merchant>;
  /** List all available merchant categories */
  merchantCategories: Array<MerchantCategory>;
  /** Get merchant category with its children and which you can filter by children's active status */
  merchantCategory?: Maybe<MerchantCategory>;
  /** Get all documents for a certain merchant */
  merchantDocuments: Array<MerchantDocument>;
  /** Load merchants search results */
  merchantSearch?: Maybe<MerchantsSearchResult>;
  /** Get merchants */
  merchants?: Maybe<MerchantsList>;
  /** Same as merchants but the results are grouped by merchant's category. */
  merchantsByCategory?: Maybe<Array<CategorizedMerchants>>;
  /** Get all merchants with cursor based pagination */
  merchantsWithCursorPagination: MerchantCursor;
  messages: MessagesCursor;
  /** Customers can get the merchants closest to them */
  nearbyMerchants: Array<MerchantWithDistance>;
  order: Order;
  /** get orderbatches of a merchant with cursor based pagination */
  orderBatches: OrderBatchCursor;
  /** Load 20 most recent purchases */
  orders: Array<Maybe<Order>>;
  /** Load search results of merchant's own products */
  ownProductsSearch?: Maybe<OwnProductsSearchResult>;
  /** Currently active payment methods */
  paymentMethods: Array<Maybe<PaymentMethod>>;
  /** Load single product */
  product?: Maybe<Product>;
  /** List all available product categories */
  productCategories: Array<ProductCategory>;
  /** Load all active products */
  products: ProductList;
  /** Load all products with cursor based pagination */
  productsWithCursorPagination: ProductCursor;
  /** Load filtered transactions */
  recentTransactions: Array<Transaction>;
  recentlyPurchasedFromMerchants: Array<Merchant>;
  reel: Reel;
  reels: ReelsCursor;
  /** Load search results */
  search?: Maybe<SearchResult>;
  /** Search order by ID, merchant name or products */
  searchOrders: SearchOrdersResult;
  /** Load reels search results */
  searchReels: ReelsCursor;
  transaction?: Maybe<Transaction>;
  transactionActivity: Array<TransactionActivity>;
  /** Return transaction charge given a payment method and amount */
  transactionCharge?: Maybe<Money>;
  transactions: TransactionsList;
  /** Check if a user is a registered Cashia user */
  userRegistrationStatus?: Maybe<Actor>;
  /** Get all users */
  users?: Maybe<Array<Maybe<Actor>>>;
  /** Load a user's wish lists */
  wishlists: Array<Wishlist>;
};


export type RootQueryTypeChatsArgs = {
  input?: InputMaybe<CursorInput>;
};


export type RootQueryTypeCourierArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeCourierSearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeCouriersArgs = {
  input?: InputMaybe<CourierSelectionInput>;
};


export type RootQueryTypeCouriersNearDeliveryArgs = {
  deliveryId: Scalars['ID'];
  radiusInMeters: Scalars['Int'];
};


export type RootQueryTypeCouriersWithCursorPaginationArgs = {
  input: CourierCursorInput;
};


export type RootQueryTypeCustomerArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeCustomerSearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeCustomersArgs = {
  input?: InputMaybe<CustomerSelectionInput>;
};


export type RootQueryTypeCustomersWithCursorPaginationArgs = {
  input: CustomerCursorInput;
};


export type RootQueryTypeDeliveriesArgs = {
  input?: InputMaybe<DeliverySelectionInput>;
};


export type RootQueryTypeDeliveryArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeDeliveryActivityArgs = {
  input?: InputMaybe<DeliveryActivityInput>;
};


export type RootQueryTypeDeliveryByOrderIdArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeDeliverySearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeEarningsArgs = {
  input?: InputMaybe<EarningsAmountInput>;
};


export type RootQueryTypeEventsArgs = {
  input?: InputMaybe<EventsInput>;
};


export type RootQueryTypeFetchBillArgs = {
  input: FetchBillInput;
};


export type RootQueryTypeGeoCoordinatesToLocationArgs = {
  input: GeoCoordinatesInput;
};


export type RootQueryTypeGetKycVerificationStatusArgs = {
  input?: InputMaybe<KycVerificationStatusInput>;
};


export type RootQueryTypeInvitationArgs = {
  code: Scalars['String'];
};


export type RootQueryTypeIsBiometricsValidArgs = {
  input: BiometricsTokenInput;
};


export type RootQueryTypeIsCashtagAvailableArgs = {
  cashtag: Scalars['String'];
};


export type RootQueryTypeIsWalletRegisteredArgs = {
  phone: PhoneNumberInput;
};


export type RootQueryTypeMerchantArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeMerchantCategoryArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeMerchantDocumentsArgs = {
  input?: InputMaybe<MerchantDocumentsInput>;
};


export type RootQueryTypeMerchantSearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeMerchantsArgs = {
  input?: InputMaybe<MerchantSelectionInput>;
};


export type RootQueryTypeMerchantsByCategoryArgs = {
  input?: InputMaybe<MerchantSelectionInput>;
};


export type RootQueryTypeMerchantsWithCursorPaginationArgs = {
  input: MerchantCursorInput;
};


export type RootQueryTypeMessagesArgs = {
  chatId: Scalars['ID'];
  input?: InputMaybe<CursorInput>;
};


export type RootQueryTypeNearbyMerchantsArgs = {
  currentPosition: GeoCoordinatesInput;
};


export type RootQueryTypeOrderArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeOrderBatchesArgs = {
  input: OrderBatchesInput;
};


export type RootQueryTypeOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type RootQueryTypeOwnProductsSearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeProductArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeProductCategoriesArgs = {
  merchantId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeProductsArgs = {
  input?: InputMaybe<ProductSelectionInput>;
};


export type RootQueryTypeProductsWithCursorPaginationArgs = {
  input: ProductCursorInput;
};


export type RootQueryTypeRecentTransactionsArgs = {
  input?: InputMaybe<RecentTransactionsInput>;
};


export type RootQueryTypeRecentlyPurchasedFromMerchantsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeReelArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeReelsArgs = {
  input?: InputMaybe<ReelsSelectionInput>;
};


export type RootQueryTypeSearchArgs = {
  searchQuery: SearchQueryInput;
};


export type RootQueryTypeSearchOrdersArgs = {
  input: SearchOrderInput;
};


export type RootQueryTypeSearchReelsArgs = {
  searchQuery: SearchReelsInput;
};


export type RootQueryTypeTransactionArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeTransactionActivityArgs = {
  input?: InputMaybe<TransactionActivityInput>;
};


export type RootQueryTypeTransactionChargeArgs = {
  input?: InputMaybe<TransactionChargeInput>;
};


export type RootQueryTypeTransactionsArgs = {
  input?: InputMaybe<TransactionSelectionInput>;
};


export type RootQueryTypeUserRegistrationStatusArgs = {
  input: UserRegistrationStatusInput;
};


export type RootQueryTypeWishlistsArgs = {
  productId?: InputMaybe<Scalars['ID']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  newChat: ChatsCursor;
  newMessage: MessagesCursor;
  /** Async transactions notifications arising from payment processing are sent to this topic. */
  transactionUpdate: Transaction;
};


export type RootSubscriptionTypeNewChatArgs = {
  input?: InputMaybe<CursorInput>;
};


export type RootSubscriptionTypeNewMessageArgs = {
  chatId: Scalars['ID'];
  input?: InputMaybe<CursorInput>;
};


export type RootSubscriptionTypeTransactionUpdateArgs = {
  input: TransactionUpdateInput;
};

export type SaveBillInput = {
  accountNumber: Scalars['String'];
  amount: MoneyInput;
  biller: Biller;
  intervalInDays: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type SavedBill = {
  __typename?: 'SavedBill';
  accountNumber: Scalars['String'];
  amount: Money;
  biller: Biller;
  dueDate: Scalars['DateTime'];
  name: Scalars['String'];
};

export type SearchOrderInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Search by merchant name, order ID or products */
  query: Scalars['String'];
};

export type SearchOrdersResult = {
  __typename?: 'SearchOrdersResult';
  orders: Array<Order>;
  totalCount: Scalars['Int'];
};

export type SearchQueryInput = {
  distance?: InputMaybe<DistanceFilterInput>;
  merchantFilter?: InputMaybe<MerchantFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  productFilter?: InputMaybe<ProductFilterInput>;
  /** Search for all text occurrences like the name, description, etc. */
  text?: InputMaybe<Scalars['String']>;
};

export type SearchReelsInput = {
  cursor?: InputMaybe<CursorInput>;
  merchantId: Scalars['ID'];
  text: Scalars['String'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  merchants: Array<Merchant>;
  products: Array<Product>;
  totalCount: Scalars['Int'];
};

export type SelectedOption = {
  __typename?: 'SelectedOption';
  /** name refers to the ProductOption name */
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SelectedOptionInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type SendMessageInput = {
  chatId: Scalars['ID'];
  mediaId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

export type SendVerificationCodeInput = {
  phone: PhoneNumberInput;
};

export type SetWalletPinInput = {
  idNumber: Scalars['String'];
  idType: VerificationId;
  pin: Scalars['String'];
};

export type Settings = {
  __typename?: 'Settings';
  notifications?: Maybe<NotificationSettings>;
};

export type SettingsInput = {
  notifications?: InputMaybe<NotificationSettingsInput>;
};

export type SignupInput = {
  agreedToTerms: Scalars['Boolean'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<PhoneNumberInput>;
};

export type SoleProprietorInput = {
  kraPinId: Scalars['ID'];
  registrationCertificateId: Scalars['ID'];
};

export enum SortByDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SystemNotification = Event & {
  __typename?: 'SystemNotification';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  message: Scalars['String'];
  type: EventType;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
};

export type TimeInterval = {
  __typename?: 'TimeInterval';
  from?: Maybe<Scalars['TimeInHm']>;
  to?: Maybe<Scalars['TimeInHm']>;
};

export type TimeIntervalInput = {
  from?: InputMaybe<Scalars['TimeInHm']>;
  to?: InputMaybe<Scalars['TimeInHm']>;
};

export type TimeSeriesConfigInput = {
  period: TimeSeriesPeriod;
  step?: Scalars['Int'];
};

/** Represents a time period or segment within a time series dataset. */
export type TimeSeriesInterval = {
  __typename?: 'TimeSeriesInterval';
  /** Used to specify the start time of the interval, marking the beginning of the time period you want to query or analyze. */
  end: Scalars['DateTime'];
  /** Used to specify the end time of the interval, indicating the conclusion of the time period you want to query or analyze */
  start: Scalars['DateTime'];
};

/** denotes the size of the TimeSeriesInterval(s) */
export enum TimeSeriesPeriod {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS',
  Seconds = 'SECONDS',
  Years = 'YEARS'
}

export type Transaction = {
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export type TransactionActivity = {
  __typename?: 'TransactionActivity';
  sum: Money;
  timeSeriesInterval: TimeSeriesInterval;
};

export type TransactionActivityInput = {
  /** object to provide the `start` and `end` DateTime values. Can be switched for `DatePreset` and should not be specified when `DatePreset` is specified */
  date?: InputMaybe<DateInterval>;
  /** enum to provide the `DatePreset` value. Can be switched for `Date` (type `DateInterval`) and should not be specified when `Date` is specified */
  datePreset?: InputMaybe<DatePreset>;
  entryType?: InputMaybe<DebitOrCredit>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** enum to specify the state of transaction you want returned. If this key / value is not provided, the sum returned will include all states of transactions */
  status?: InputMaybe<TransactionStatus>;
  timeSeriesConfig: TimeSeriesConfigInput;
  /** enum list to specify the type(s) of transaction you want returned. If this key / value is not provided, the sum returned will include all types of transactions */
  type?: InputMaybe<Array<TransactionType>>;
  /** provide wallet's id to narrow down the search */
  walletId?: InputMaybe<Scalars['ID']>;
};

export type TransactionChargeInput = {
  amount: MoneyInput;
  paymentMethod: PaymentMethodInput;
};

export type TransactionError = Error & {
  __typename?: 'TransactionError';
  reason: Scalars['String'];
  type: ErrorTypes;
};

export type TransactionEvent = Event & {
  __typename?: 'TransactionEvent';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  transaction: Transaction;
  type: EventType;
};

export type TransactionSelectionInput = {
  /** Filter by dates and status */
  date?: InputMaybe<DateInterval>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Admin can filter by role of the user ie customer, merchant & ect */
  role?: InputMaybe<Role>;
  /** Admin can filter by roleID of the user ie customerID, merchantID & ect */
  roleId?: InputMaybe<Scalars['ID']>;
  /** Search by handle, phone number, name or reference number */
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TransactionStatus>;
};

export enum TransactionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/** Enum list of Transaction types */
export enum TransactionType {
  Bill = 'BILL',
  LoadCredit = 'LOAD_CREDIT',
  Order = 'ORDER',
  Refund = 'REFUND',
  Transfer = 'TRANSFER',
  Withdraw = 'WITHDRAW'
}

/** Provide either Id or Ref, if both are provided, the id will take precedence */
export type TransactionUpdateInput = {
  id?: InputMaybe<Scalars['ID']>;
  ref?: InputMaybe<Scalars['ID']>;
};

export type TransactionsList = {
  __typename?: 'TransactionsList';
  totalCount: Scalars['Int'];
  transactions: Array<Transaction>;
};

export type TransferCreditInput = {
  /**
   * When type is SIGNATURE, this should be the user's id signed with user's biometric key.
   * When it's VERIFICATION_CODE, the wallet PIN should be sent.
   */
  authenticationCode: Scalars['String'];
  credit: MoneyInput;
  externalAccount?: InputMaybe<ExternalAccountInput>;
  note?: InputMaybe<Scalars['String']>;
  receiver: UserIdentifier;
  type: AuthenticationType;
};

export type TransferTransaction = Transaction & {
  __typename?: 'TransferTransaction';
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  externalAccount?: Maybe<ExternalAccount>;
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuer: Actor;
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  receiver: Actor;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

export type UpdateChatMembersInput = {
  chatId: Scalars['ID'];
  memberIds: Array<Scalars['ID']>;
};

export type UpdateReelInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  merchantId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  reason?: InputMaybe<Scalars['String']>;
  restricted?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  courier?: InputMaybe<CourierUpdateInput>;
  customer?: InputMaybe<CustomerUpdateInput>;
  email?: InputMaybe<Scalars['String']>;
  identificationNumber?: InputMaybe<Scalars['String']>;
  /** Of the 4 Cashia User KYC verifications statuses, 3 can be manually approved / rejected by an admin: IdentificationNumber, PhoneNumber, Liveness. */
  kycVerificationStatus?: InputMaybe<KycVerificationStatusUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
  tag?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String'];
  /** Only admins can change their password */
  password: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  agreedToTerms?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  identificationNumber?: Maybe<Scalars['String']>;
  identificationType?: Maybe<Scalars['String']>;
  kycVerificationStatus?: Maybe<KycVerificationStatus>;
  locked: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<PhoneNumber>;
};

/**
 * This type is used to identify the user in the system.
 * Exactly one of the parameters should always be set.
 * Once union input types arrive into GraphQL it should be replaced.
 */
export type UserIdentifier = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<PhoneNumberInput>;
  tag?: InputMaybe<Scalars['String']>;
};

/**
 * This type is used to check if a user is a registered Cashia user.
 * Either one of a phone number or cashia tag should always be set.
 */
export type UserRegistrationStatusInput = {
  handle?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneNumberInput>;
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  key: Scalars['String'];
  /** Should give details sometimes. Example: a @cashia tag is already taken. */
  message?: Maybe<Scalars['String']>;
  type: ErrorTypes;
};

export enum VehicleType {
  Lorry = 'LORRY',
  Motorbike = 'MOTORBIKE',
  Pickup = 'PICKUP',
  Van = 'VAN'
}

/** Type of identity verification document */
export enum VerificationId {
  AlienCard = 'ALIEN_CARD',
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export type VerifyPhoneInput = {
  code: Scalars['String'];
};

export type VerifyPinOrSignatureInput = {
  pin?: InputMaybe<Scalars['String']>;
  /** This is required when the user logs in with set biometrics */
  signature?: InputMaybe<Scalars['String']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  activation?: Maybe<WalletActivation>;
  credit?: Maybe<Money>;
  dailySpend: DailySpend;
  holds: Array<WalletHold>;
  id?: Maybe<Scalars['ID']>;
  totalHeld?: Maybe<Money>;
  /** Sum of transactions per interval (in a Time Series format) */
  transactionActivity: Array<TransactionActivity>;
};


export type WalletTransactionActivityArgs = {
  input?: InputMaybe<TransactionActivityInput>;
};

/** WalletActivation is an Entity for a wallet activation request */
export type WalletActivation = {
  __typename?: 'WalletActivation';
  cashtag?: Maybe<Scalars['String']>;
  country: Country;
  /** Protected field: Only Admins can access */
  idNumber?: Maybe<Scalars['String']>;
  idPhotos: Array<Scalars['ID']>;
  idType?: Maybe<VerificationId>;
  name?: Maybe<Scalars['String']>;
  phone: PhoneNumber;
  reason?: Maybe<Scalars['String']>;
  status: WalletActivationStatus;
};

/** This defines the status of an activation request */
export enum WalletActivationStatus {
  /** Status when either verification starts, phone verification or identity */
  InProgress = 'IN_PROGRESS',
  /** The default status */
  Pending = 'PENDING',
  /** Status when all forms of verifications are completed */
  Verified = 'VERIFIED'
}

export type WalletHold = {
  __typename?: 'WalletHold';
  credit: Money;
  /**
   * This can be used for the reason of why the money are held.
   * It's just a string for now, but can be improved later if we have UI for it planned.
   */
  remark?: Maybe<Scalars['String']>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Products saved to this wish list */
  products: Array<Product>;
};

export type WithdrawInput = {
  /**
   * When type is SIGNATURE, this should be the user's id signed with user's biometric key.
   * When it's VERIFICATION_CODE, the wallet PIN should be sent.
   */
  authenticationCode: Scalars['String'];
  money: MoneyInput;
  /** Use this field if you don't want to save the payment method. */
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  /** Use this field if you need to access a saved payment method. Should be used in isolation */
  savedPaymentMethodId?: InputMaybe<Scalars['ID']>;
  type: AuthenticationType;
};

export type WithdrawTransaction = Transaction & {
  __typename?: 'WithdrawTransaction';
  amount: Money;
  charge?: Maybe<Money>;
  date: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuer?: Maybe<Actor>;
  /** From system */
  message?: Maybe<Scalars['String']>;
  /** From customer */
  note?: Maybe<Scalars['String']>;
  /** Should be a phone payment method */
  paymentMethod: PaymentMethod;
  /** Human-readable number that transactions can be referenced with */
  referenceNumber: Scalars['String'];
  status: TransactionStatus;
};

type ActorFieldsAdminFragment = { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null };

type ActorFieldsCourierFragment = { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null };

type ActorFieldsCustomerFragment = { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null };

type ActorFieldsMerchantFragment = { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } };

export type ActorFieldsFragment = ActorFieldsAdminFragment | ActorFieldsCourierFragment | ActorFieldsCustomerFragment | ActorFieldsMerchantFragment;

export type AddressFieldsFragment = { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } };

export type LocationFieldsFragment = { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } };

export type GeoCoordinatesFieldsFragment = { __typename?: 'GeoCoordinates', lat: number, long: number };

export type CourierFieldsFragment = { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null };

export type CourierCursorFieldsFragment = { __typename?: 'CourierCursor', edges: Array<{ __typename?: 'CourierEdge', cursor: string, node: { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type CourierSearchFieldsFragment = { __typename?: 'Courier', id?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null };

export type CustomerFieldsFragment = { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null };

export type CustomerCursorFieldsFragment = { __typename?: 'CustomerCursor', edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node: { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type CustomerSearchFieldsFragment = { __typename?: 'Customer', id?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null };

export type DeliveriesListFieldsFragment = { __typename?: 'DeliveriesList', totalCount: number, deliveries: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> };

export type DeliveryFieldsFragment = { __typename?: 'Delivery', status: DeliveryStatus };

export type DeliveryActivityFieldsFragment = { __typename?: 'DeliveryActivity', count: number, timeSeriesInterval: { __typename?: 'TimeSeriesInterval', end: any, start: any } };

export type EarningsAmountFieldsFragment = { __typename?: 'EarningsAmount', total: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, pending: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, failed: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

export type ImageFieldsFragment = { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null };

export type KycVerificationStatusFieldsFragment = { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null };

export type MeFieldsFragment = { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null };

export type MediaFieldsFragment = { __typename?: 'Media', id?: string | null, url?: string | null, contentType?: string | null };

export type MemberStatisticsFieldsFragment = { __typename?: 'MemberStatistics', merchantCount: { __typename?: 'MerchantCount', all: number, approved: number, pending: number, rejected: number }, customerCount: { __typename?: 'CustomerCount', all: number, inProgress: number, pending: number, verified: number }, courierCount: { __typename?: 'CourierCount', all: number, drivers: number, riders: number } };

export type MerchantFieldsFragment = { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } };

export type MerchantCategoriesFieldsFragment = { __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null };

export type MerchantCategoryFieldsFragment = { __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null };

export type MerchantCursorFieldsFragment = { __typename?: 'MerchantCursor', edges: Array<{ __typename?: 'MerchantEdge', cursor: string, node: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type MerchantDocumentFieldsFragment = { __typename?: 'MerchantDocument', id?: string | null, mediaId?: string | null, fileName?: string | null, reason?: string | null, size?: number | null, status?: DocumentStatus | null, url?: string | null, documentType?: DocumentType | null };

export type MerchantScreenInfoFieldsFragment = { __typename?: 'Merchant', name?: string | null, rating?: number | null, description?: string | null, favorite?: boolean | null, shortDescription?: string | null, allowPayingDirectly?: boolean | null, website?: string | null, tag?: string | null, email?: string | null, idType?: VerificationId | null, idNumber?: string | null, applicantsName?: string | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, selection?: Array<MerchantSelection> | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, productCategories?: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }> | null, reviews?: Array<{ __typename?: 'Review', id?: string | null, score?: number | null, text?: string | null, createdAt?: any | null, author?: { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null } | null> | null, products: { __typename?: 'ProductList', total: number, items: Array<{ __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null } | null> }, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } };

export type MerchantSearchFieldsFragment = { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } };

export type MoneyFieldsFragment = { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode };

export type NestedMerchantCategoryFieldsFragment = { __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null }> | null };

export type NotificationChannelFieldsFragment = { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean };

export type NotificationSettingsFieldsFragment = { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } };

export type OperatingTimeFieldsFragment = { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number };

type PaymentMethodsFieldsCreditCardPaymentMethodFragment = { __typename?: 'CreditCardPaymentMethod', last4Digits: string, provider?: PaymentProvider | null, type: CardType, id: string, name?: string | null };

type PaymentMethodsFieldsFreeMoneyDevPaymentMethodFragment = { __typename?: 'FreeMoneyDevPaymentMethod', id: string, name?: string | null };

type PaymentMethodsFieldsInterswitchBankAccountPaymentMethodFragment = { __typename?: 'InterswitchBankAccountPaymentMethod', bankAccountNumber: string, id: string, name?: string | null, interswitchBank?: { __typename?: 'InterswitchBank', id: string, name?: string | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null };

type PaymentMethodsFieldsPhoneNumberPaymentMethodFragment = { __typename?: 'PhoneNumberPaymentMethod', name?: string | null, id: string, phone: { __typename?: 'PhoneNumber', countryCode: string, number: string } };

export type PaymentMethodsFieldsFragment = PaymentMethodsFieldsCreditCardPaymentMethodFragment | PaymentMethodsFieldsFreeMoneyDevPaymentMethodFragment | PaymentMethodsFieldsInterswitchBankAccountPaymentMethodFragment | PaymentMethodsFieldsPhoneNumberPaymentMethodFragment;

export type PhoneNumberFieldsFragment = { __typename?: 'PhoneNumber', countryCode: string, number: string };

export type ProductFieldsFragment = { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null };

export type OptionFieldsFragment = { __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null };

export type SelectedOptionFieldsFragment = { __typename?: 'SelectedOption', name?: string | null, value?: string | null };

export type ProductCategoryFieldsFragment = { __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null };

export type ProductCursorFieldsFragment = { __typename?: 'ProductCursor', edges: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type ProductListFieldsFragment = { __typename?: 'ProductList', total: number, items: Array<{ __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null } | null> };

export type ProductVariantFieldsFragment = { __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null };

export type ProductWithVariantsFieldsFragment = { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null };

export type ReelFieldsFragment = { __typename?: 'Reel', id: string, name: string, status: ReelStatus, likes: number, shares: number, restricted?: boolean | null, reason?: string | null, views: number, active: boolean, link: { __typename?: 'Playback', hls: string }, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null }, products: Array<{ __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null }>, thumbnail: { __typename?: 'Thumbnail', small?: string | null, medium?: string | null, large?: string | null } };

export type CreateReelFieldsFragment = { __typename?: 'Reel', id: string, name: string, status: ReelStatus, likes: number, shares: number, views: number, active: boolean, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null }, products: Array<{ __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null }> };

export type ReelsProductFieldsFragment = { __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null };

export type RefinitivcaseFieldsFragment = { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> };

export type RefinitivScreeningResultFieldsFragment = { __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number };

export type ReviewFieldsFragment = { __typename?: 'Review', id?: string | null, score?: number | null, text?: string | null, createdAt?: any | null, author?: { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null };

export type SettingsFieldsFragment = { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null };

export type TimeIntervalFieldsFragment = { __typename?: 'TimeInterval', from?: string | null, to?: string | null };

export type TimeSeriesIntervalFieldsFragment = { __typename?: 'TimeSeriesInterval', start: any, end: any };

export type TransactionActivityFieldsFragment = { __typename?: 'TransactionActivity', sum: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, timeSeriesInterval: { __typename?: 'TimeSeriesInterval', start: any, end: any } };

type TransactionsFieldsBillTransactionFragment = { __typename?: 'BillTransaction', biller: Biller, id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, externalAccount?: { __typename?: 'ExternalAccount', accountNumber: string } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

type TransactionsFieldsLoadCreditTransactionFragment = { __typename?: 'LoadCreditTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, paymentMethod: { __typename?: 'CreditCardPaymentMethod', last4Digits: string, provider?: PaymentProvider | null, type: CardType, id: string, name?: string | null } | { __typename?: 'FreeMoneyDevPaymentMethod', id: string, name?: string | null } | { __typename?: 'InterswitchBankAccountPaymentMethod', bankAccountNumber: string, id: string, name?: string | null, interswitchBank?: { __typename?: 'InterswitchBank', id: string, name?: string | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null } | { __typename?: 'PhoneNumberPaymentMethod', name?: string | null, id: string, phone: { __typename?: 'PhoneNumber', countryCode: string, number: string } }, loadReceiver?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

type TransactionsFieldsOrderBatchTransactionFragment = { __typename?: 'OrderBatchTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, orderBatch: { __typename?: 'OrderBatch', id: string, referenceNumber: string, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }, buyer: { __typename?: 'Customer', user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

type TransactionsFieldsRefundTransactionFragment = { __typename?: 'RefundTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, orderBatch: { __typename?: 'OrderBatch', id: string, referenceNumber: string, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

type TransactionsFieldsTransferTransactionFragment = { __typename?: 'TransferTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, transferReceiver: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }, transferIssuer: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }, externalAccount?: { __typename?: 'ExternalAccount', accountNumber: string } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

type TransactionsFieldsWithdrawTransactionFragment = { __typename?: 'WithdrawTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, paymentMethod: { __typename?: 'CreditCardPaymentMethod', last4Digits: string, provider?: PaymentProvider | null, type: CardType, id: string, name?: string | null } | { __typename?: 'FreeMoneyDevPaymentMethod', id: string, name?: string | null } | { __typename?: 'InterswitchBankAccountPaymentMethod', bankAccountNumber: string, id: string, name?: string | null, interswitchBank?: { __typename?: 'InterswitchBank', id: string, name?: string | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null } | { __typename?: 'PhoneNumberPaymentMethod', name?: string | null, id: string, phone: { __typename?: 'PhoneNumber', countryCode: string, number: string } }, withdrawIssuer?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

export type TransactionsFieldsFragment = TransactionsFieldsBillTransactionFragment | TransactionsFieldsLoadCreditTransactionFragment | TransactionsFieldsOrderBatchTransactionFragment | TransactionsFieldsRefundTransactionFragment | TransactionsFieldsTransferTransactionFragment | TransactionsFieldsWithdrawTransactionFragment;

export type UserFieldsFragment = { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null };

export type WalletFieldsFragment = { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null };

export type WalletHoldFieldsFragment = { __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } };

export type WalletActivationFieldsFragment = { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null };

export type AddOrUpdateMerchantCategoryMutationVariables = Exact<{
  input?: InputMaybe<MerchantCategoryInput>;
}>;


export type AddOrUpdateMerchantCategoryMutation = { __typename?: 'RootMutationType', addOrUpdateMerchantCategory: { __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null } };

export type AddOrUpdateProductMutationVariables = Exact<{
  input?: InputMaybe<ProductInput>;
}>;


export type AddOrUpdateProductMutation = { __typename?: 'RootMutationType', addOrUpdateProduct?: { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null } | null };

export type ChangeCustomerWalletStateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
  state?: InputMaybe<WalletActivationStatus>;
}>;


export type ChangeCustomerWalletStateMutation = { __typename?: 'RootMutationType', changeCustomerWalletState?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null };

export type ChangeMerchantApprovalStateMutationVariables = Exact<{
  id: Scalars['ID'];
  changeMerchantApprovalStateInput?: InputMaybe<ChangeMerchantApprovalStateInput>;
}>;


export type ChangeMerchantApprovalStateMutation = { __typename?: 'RootMutationType', changeMerchantApprovalState?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null };

export type ChangeMerchantDocumentStatusMutationVariables = Exact<{
  input: ChangeMerchantDocumentStatusInput;
}>;


export type ChangeMerchantDocumentStatusMutation = { __typename?: 'RootMutationType', changeMerchantDocumentStatus: { __typename?: 'MerchantDocument', id?: string | null, mediaId?: string | null, fileName?: string | null, reason?: string | null, size?: number | null, status?: DocumentStatus | null, url?: string | null, documentType?: DocumentType | null } };

export type RemoveProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveProductMutation = { __typename?: 'RootMutationType', removeProduct?: boolean | null };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'RootMutationType', refreshToken?: { __typename?: 'Login', accessToken?: string | null, refreshToken?: string | null } | null };

export type UpdateMerchantMutationVariables = Exact<{
  id: Scalars['ID'];
  merchantUpdateInput: MerchantUpdateInput;
}>;


export type UpdateMerchantMutation = { __typename?: 'RootMutationType', updateMerchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null };

export type UpdateReelMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateReelInput;
}>;


export type UpdateReelMutation = { __typename?: 'RootMutationType', updateReel: { __typename?: 'Reel', id: string, name: string, status: ReelStatus, likes: number, shares: number, restricted?: boolean | null, reason?: string | null, views: number, active: boolean, link: { __typename?: 'Playback', hls: string }, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null }, products: Array<{ __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null }>, thumbnail: { __typename?: 'Thumbnail', small?: string | null, medium?: string | null, large?: string | null } } };

export type UpdateUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'RootMutationType', updateUser?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null };

export type UploadMediaMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadMediaMutation = { __typename?: 'RootMutationType', uploadMedia?: { __typename?: 'Media', id?: string | null, url?: string | null, contentType?: string | null } | null };

export type CourierQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourierQuery = { __typename?: 'RootQueryType', courier: { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } };

export type CourierSearchQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type CourierSearchQuery = { __typename?: 'RootQueryType', courierSearch?: { __typename?: 'CouriersSearchResult', couriers: Array<{ __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null }> } | null };

export type CouriersWithCursorPaginationQueryVariables = Exact<{
  input: CourierCursorInput;
}>;


export type CouriersWithCursorPaginationQuery = { __typename?: 'RootQueryType', couriersWithCursorPagination: { __typename?: 'CourierCursor', edges: Array<{ __typename?: 'CourierEdge', cursor: string, node: { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type CustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerQuery = { __typename?: 'RootQueryType', customer: { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } };

export type CustomerSearchQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type CustomerSearchQuery = { __typename?: 'RootQueryType', customerSearch?: { __typename?: 'CustomersSearchResult', customers: Array<{ __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> } | null };

export type CustomersWithCursorPaginationQueryVariables = Exact<{
  input: CustomerCursorInput;
}>;


export type CustomersWithCursorPaginationQuery = { __typename?: 'RootQueryType', customersWithCursorPagination: { __typename?: 'CustomerCursor', edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node: { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type DeliveriesQueryVariables = Exact<{
  input?: InputMaybe<DeliverySelectionInput>;
}>;


export type DeliveriesQuery = { __typename?: 'RootQueryType', deliveries: { __typename?: 'DeliveriesList', totalCount: number, deliveries: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> } };

export type DeliveryActivityQueryVariables = Exact<{
  input?: InputMaybe<DeliveryActivityInput>;
}>;


export type DeliveryActivityQuery = { __typename?: 'RootQueryType', deliveryActivity: Array<{ __typename?: 'DeliveryActivity', count: number, timeSeriesInterval: { __typename?: 'TimeSeriesInterval', end: any, start: any } }> };

export type EarningsQueryVariables = Exact<{
  input?: InputMaybe<EarningsAmountInput>;
}>;


export type EarningsQuery = { __typename?: 'RootQueryType', earnings: { __typename?: 'EarningsAmount', total: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, pending: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, failed: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } };

export type GeoCoordinatesToLocationQueryVariables = Exact<{
  input: GeoCoordinatesInput;
}>;


export type GeoCoordinatesToLocationQuery = { __typename?: 'RootQueryType', geoCoordinatesToLocation: Array<{ __typename?: 'Location', formattedAddress: string }> };

export type GetKycVerificationStatusQueryVariables = Exact<{
  input?: InputMaybe<KycVerificationStatusInput>;
}>;


export type GetKycVerificationStatusQuery = { __typename?: 'RootQueryType', getKycVerificationStatus: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } };

export type GetReelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReelQuery = { __typename?: 'RootQueryType', reel: { __typename?: 'Reel', id: string, name: string, status: ReelStatus, likes: number, shares: number, restricted?: boolean | null, reason?: string | null, views: number, active: boolean, link: { __typename?: 'Playback', hls: string }, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null }, products: Array<{ __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null }>, thumbnail: { __typename?: 'Thumbnail', small?: string | null, medium?: string | null, large?: string | null } } };

export type GetReelsQueryVariables = Exact<{
  input: ReelsSelectionInput;
}>;


export type GetReelsQuery = { __typename?: 'RootQueryType', reels: { __typename?: 'ReelsCursor', edges: Array<{ __typename?: 'ReelEdge', cursor: string, node: { __typename?: 'Reel', id: string, name: string, status: ReelStatus, likes: number, shares: number, restricted?: boolean | null, reason?: string | null, views: number, active: boolean, link: { __typename?: 'Playback', hls: string }, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null }, products: Array<{ __typename?: 'Product', id?: string | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null }>, thumbnail: { __typename?: 'Thumbnail', small?: string | null, medium?: string | null, large?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type InformaKybQueryVariables = Exact<{
  id: Scalars['ID'];
  input?: InputMaybe<InformaKybInput>;
}>;


export type InformaKybQuery = { __typename?: 'RootQueryType', merchant?: { __typename?: 'Merchant', informaKyb?: { __typename?: 'InformaKyb', status?: string | null, informaStatus?: string | null, registrationNumber?: string | null, registrationDate?: string | null, postalAddress?: string | null, physicalAddress?: string | null, phoneNumber?: string | null, kraPin?: string | null, email?: string | null, businessName?: string | null, partners?: Array<{ __typename?: 'Partner', name?: string | null, idType?: string | null, idNumber?: string | null } | null> | null } | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null };

export type MemberStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberStatisticsQuery = { __typename?: 'RootQueryType', memberStatistics: { __typename?: 'MemberStatistics', merchantCount: { __typename?: 'MerchantCount', all: number, approved: number, pending: number, rejected: number }, customerCount: { __typename?: 'CustomerCount', all: number, inProgress: number, pending: number, verified: number }, courierCount: { __typename?: 'CourierCount', all: number, drivers: number, riders: number } } };

export type MerchantCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MerchantCategoriesQuery = { __typename?: 'RootQueryType', merchantCategories: Array<{ __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null }> };

export type MerchantCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MerchantCategoryQuery = { __typename?: 'RootQueryType', merchantCategory?: { __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null } | null };

export type MerchantDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MerchantDetailsQuery = { __typename?: 'RootQueryType', merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null };

export type MerchantDocsInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MerchantDocsInfoQuery = { __typename?: 'RootQueryType', merchant?: { __typename?: 'Merchant', merchantType?: MerchantType | null, idType?: VerificationId | null, idNumber?: string | null, merchantDocuments?: Array<{ __typename?: 'MerchantDocument', id?: string | null, mediaId?: string | null, fileName?: string | null, reason?: string | null, size?: number | null, status?: DocumentStatus | null, url?: string | null, documentType?: DocumentType | null }> | null } | null };

export type MerchantDocumentsQueryVariables = Exact<{
  input?: InputMaybe<MerchantDocumentsInput>;
}>;


export type MerchantDocumentsQuery = { __typename?: 'RootQueryType', merchantDocuments: Array<{ __typename?: 'MerchantDocument', id?: string | null, mediaId?: string | null, fileName?: string | null, reason?: string | null, size?: number | null, status?: DocumentStatus | null, url?: string | null, documentType?: DocumentType | null }> };

export type MerchantSearchQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type MerchantSearchQuery = { __typename?: 'RootQueryType', merchantSearch?: { __typename?: 'MerchantsSearchResult', merchants: Array<{ __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }> } | null };

export type MerchantsWithCursorPaginationQueryVariables = Exact<{
  input: MerchantCursorInput;
}>;


export type MerchantsWithCursorPaginationQuery = { __typename?: 'RootQueryType', merchantsWithCursorPagination: { __typename?: 'MerchantCursor', edges: Array<{ __typename?: 'MerchantEdge', cursor: string, node: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type NestedMerchantCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type NestedMerchantCategoryQuery = { __typename?: 'RootQueryType', merchantCategory?: { __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null }> | null } | null };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'RootQueryType', product?: { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null } | null };

export type ProductsWithCursorPaginationQueryVariables = Exact<{
  input: ProductCursorInput;
}>;


export type ProductsWithCursorPaginationQuery = { __typename?: 'RootQueryType', productsWithCursorPagination: { __typename?: 'ProductCursor', edges: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id?: string | null, active?: boolean | null, deleted: boolean, deletedAt?: any | null, fulfillment?: Fulfillment | null, title?: string | null, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string }> | null }>, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null> | null, merchant?: { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, options?: Array<{ __typename?: 'ProductOption', id?: string | null, name?: string | null, values?: Array<string | null> | null, position?: number | null } | null> | null, variants?: Array<{ __typename?: 'ProductVariant', id?: string | null, description?: string | null, default?: boolean | null, sku?: string | null, title?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null }> | null, option?: Array<{ __typename?: 'SelectedOption', name?: string | null, value?: string | null } | null> | null, product?: { __typename?: 'Product', id?: string | null, title?: string | null, active?: boolean | null } | null, price?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetSearchQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type GetSearchQuery = { __typename?: 'RootQueryType', search?: { __typename?: 'SearchResult', merchants: Array<{ __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }> } | null };

export type TransactionActivityQueryVariables = Exact<{
  input?: InputMaybe<TransactionActivityInput>;
}>;


export type TransactionActivityQuery = { __typename?: 'RootQueryType', transactionActivity: Array<{ __typename?: 'TransactionActivity', sum: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, timeSeriesInterval: { __typename?: 'TimeSeriesInterval', start: any, end: any } }> };

export type TransactionsQueryVariables = Exact<{
  input?: InputMaybe<TransactionSelectionInput>;
}>;


export type TransactionsQuery = { __typename?: 'RootQueryType', transactions: { __typename?: 'TransactionsList', totalCount: number, transactions: Array<{ __typename?: 'BillTransaction', biller: Biller, id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, externalAccount?: { __typename?: 'ExternalAccount', accountNumber: string } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } | { __typename?: 'LoadCreditTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, paymentMethod: { __typename?: 'CreditCardPaymentMethod', last4Digits: string, provider?: PaymentProvider | null, type: CardType, id: string, name?: string | null } | { __typename?: 'FreeMoneyDevPaymentMethod', id: string, name?: string | null } | { __typename?: 'InterswitchBankAccountPaymentMethod', bankAccountNumber: string, id: string, name?: string | null, interswitchBank?: { __typename?: 'InterswitchBank', id: string, name?: string | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null } | { __typename?: 'PhoneNumberPaymentMethod', name?: string | null, id: string, phone: { __typename?: 'PhoneNumber', countryCode: string, number: string } }, loadReceiver?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } | { __typename?: 'OrderBatchTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, orderBatch: { __typename?: 'OrderBatch', id: string, referenceNumber: string, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }, buyer: { __typename?: 'Customer', user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } | { __typename?: 'RefundTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, orderBatch: { __typename?: 'OrderBatch', id: string, referenceNumber: string, merchant: { __typename?: 'Merchant', id?: string | null, name?: string | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } }, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } | { __typename?: 'TransferTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, transferReceiver: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }, transferIssuer: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } }, externalAccount?: { __typename?: 'ExternalAccount', accountNumber: string } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } | { __typename?: 'WithdrawTransaction', id: string, date: any, message?: string | null, note?: string | null, status: TransactionStatus, referenceNumber: string, paymentMethod: { __typename?: 'CreditCardPaymentMethod', last4Digits: string, provider?: PaymentProvider | null, type: CardType, id: string, name?: string | null } | { __typename?: 'FreeMoneyDevPaymentMethod', id: string, name?: string | null } | { __typename?: 'InterswitchBankAccountPaymentMethod', bankAccountNumber: string, id: string, name?: string | null, interswitchBank?: { __typename?: 'InterswitchBank', id: string, name?: string | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | null } | { __typename?: 'PhoneNumberPaymentMethod', name?: string | null, id: string, phone: { __typename?: 'PhoneNumber', countryCode: string, number: string } }, withdrawIssuer?: { __typename?: 'Admin', id?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null } | { __typename?: 'Courier', id?: string | null, tag?: string | null, online: boolean, createdAt?: any | null, licensePlate?: string | null, courierType?: CourierType | null, vehicleType?: VehicleType | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentPosition?: { __typename?: 'GeoCoordinates', lat: number, long: number } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, assignedDeliveries?: Array<{ __typename?: 'Delivery', status: DeliveryStatus }> | null, currentDelivery?: { __typename?: 'Delivery', status: DeliveryStatus } | null } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant', id?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, website?: string | null, email?: string | null, rating?: number | null, tag?: string | null, createdAt?: any | null, approvalState?: ApprovalState | null, approvalMessage?: string | null, showTutorial?: boolean | null, applicantsName?: string | null, idNumber?: string | null, idType?: VerificationId | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }> | null, operatingTime?: { __typename?: 'OperatingTime', mo?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, tu?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, we?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, th?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, fr?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, sa?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null, su?: Array<{ __typename?: 'TimeInterval', from?: string | null, to?: string | null } | null> | null } | null, logo?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, coverImage?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, merchantCategories?: Array<{ __typename?: 'MerchantCategory', id: string, name: string, children?: Array<{ __typename?: 'MerchantCategory', id: string, name: string }> | null, image?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null }> | null, settings: { __typename?: 'Settings', notifications?: { __typename?: 'NotificationSettings', account: { __typename?: 'NotificationChannel', email: boolean, pushNotification: boolean, textMessage: boolean, phoneCall: boolean } } | null } } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }> } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'RootQueryType', users?: Array<{ __typename?: 'Admin' } | { __typename?: 'Courier' } | { __typename?: 'Customer', id?: string | null, roles: Array<Role>, createdAt?: any | null, tag?: string | null, transactionsCount: number, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, createdAt?: any | null, locked: boolean, identificationType?: string | null, identificationNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, kycVerificationStatus?: { __typename?: 'KycVerificationStatus', matchScore: number, aml?: { __typename?: 'Aml', verified: boolean, refinitivCase: { __typename?: 'RefinitivCase', caseId: string, caseSystemId: string, results: Array<{ __typename?: 'RefinitivScreeningResult', referenceId: string, resultId: string, category: string, gender: string, primaryName: string, riskCategories: Array<string>, nationality: string, matchScore: number }> } } | null, identificationNumberLogs?: { __typename?: 'IdentificationNumberLogs', verified: boolean, logs: Array<{ __typename?: 'IdentificationNumberLog', citizenship?: string | null, code: string, dateOfBirth?: any | null, firstName?: string | null, gender?: string | null, idNumber?: string | null, insertedAt: any, lastName?: string | null, message: string, middleName?: string | null, status?: number | null } | null> } | null, livenessLogs?: { __typename?: 'LivenessLogs', verified: boolean, logs: Array<{ __typename?: 'LivenessLog', code: string, insertedAt: any, message: string, status?: number | null } | null> } | null, phoneNumberLogs?: { __typename?: 'PhoneNumberLogs', verified: boolean, logs: Array<{ __typename?: 'PhoneNumberLog', code: string, insertedAt: any, message: string, personSearchType: string, status?: number | null } | null> } | null } | null } | null, wallet?: { __typename?: 'Wallet', id?: string | null, credit?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null, holds: Array<{ __typename?: 'WalletHold', remark?: string | null, credit: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } }>, activation?: { __typename?: 'WalletActivation', status: WalletActivationStatus, idNumber?: string | null } | null } | null, currentAddress?: { __typename?: 'Address', id: string, name?: string | null, remark?: string | null, pickup?: boolean | null, estateName?: string | null, houseNumber?: string | null, floorNumber?: string | null, phone?: { __typename?: 'PhoneNumber', countryCode: string, number: string } | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, avatar?: { __typename?: 'Image', id?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null } | { __typename?: 'Merchant' } | null> | null };

export const PhoneNumberFieldsFragmentDoc = gql`
    fragment phoneNumberFields on PhoneNumber {
  countryCode
  number
}
    `;
export const RefinitivScreeningResultFieldsFragmentDoc = gql`
    fragment refinitivScreeningResultFields on RefinitivScreeningResult {
  referenceId
  resultId
  category
  gender
  primaryName
  riskCategories
  nationality
  matchScore
}
    `;
export const RefinitivcaseFieldsFragmentDoc = gql`
    fragment refinitivcaseFields on RefinitivCase {
  caseId
  caseSystemId
  results {
    ...refinitivScreeningResultFields
  }
}
    ${RefinitivScreeningResultFieldsFragmentDoc}`;
export const KycVerificationStatusFieldsFragmentDoc = gql`
    fragment kycVerificationStatusFields on KycVerificationStatus {
  matchScore
  aml {
    verified
    refinitivCase {
      ...refinitivcaseFields
    }
  }
  identificationNumberLogs {
    verified
    logs {
      citizenship
      code
      dateOfBirth
      firstName
      gender
      idNumber
      insertedAt
      lastName
      message
      middleName
      status
    }
  }
  livenessLogs {
    verified
    logs {
      code
      insertedAt
      message
      status
    }
  }
  phoneNumberLogs {
    verified
    logs {
      code
      insertedAt
      message
      personSearchType
      status
    }
  }
}
    ${RefinitivcaseFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  name
  email
  phone {
    ...phoneNumberFields
  }
  createdAt
  locked
  identificationType
  identificationNumber
  kycVerificationStatus {
    ...kycVerificationStatusFields
  }
}
    ${PhoneNumberFieldsFragmentDoc}
${KycVerificationStatusFieldsFragmentDoc}`;
export const MoneyFieldsFragmentDoc = gql`
    fragment moneyFields on Money {
  amountInCents
  currencyCode
}
    `;
export const WalletHoldFieldsFragmentDoc = gql`
    fragment walletHoldFields on WalletHold {
  remark
  credit {
    ...moneyFields
  }
}
    ${MoneyFieldsFragmentDoc}`;
export const WalletActivationFieldsFragmentDoc = gql`
    fragment walletActivationFields on WalletActivation {
  status
  idNumber
}
    `;
export const WalletFieldsFragmentDoc = gql`
    fragment walletFields on Wallet {
  id
  credit {
    ...moneyFields
  }
  holds {
    ...walletHoldFields
  }
  activation {
    ...walletActivationFields
  }
}
    ${MoneyFieldsFragmentDoc}
${WalletHoldFieldsFragmentDoc}
${WalletActivationFieldsFragmentDoc}`;
export const GeoCoordinatesFieldsFragmentDoc = gql`
    fragment geoCoordinatesFields on GeoCoordinates {
  lat
  long
}
    `;
export const ImageFieldsFragmentDoc = gql`
    fragment imageFields on Image {
  id
  small
  medium
  large
}
    `;
export const DeliveryFieldsFragmentDoc = gql`
    fragment deliveryFields on Delivery {
  status
}
    `;
export const CourierFieldsFragmentDoc = gql`
    fragment courierFields on Courier {
  id
  user {
    ...userFields
  }
  wallet {
    ...walletFields
  }
  currentPosition {
    ...geoCoordinatesFields
  }
  tag
  avatar {
    ...imageFields
  }
  online
  createdAt
  licensePlate
  courierType
  vehicleType
  assignedDeliveries {
    ...deliveryFields
  }
  currentDelivery {
    ...deliveryFields
  }
}
    ${UserFieldsFragmentDoc}
${WalletFieldsFragmentDoc}
${GeoCoordinatesFieldsFragmentDoc}
${ImageFieldsFragmentDoc}
${DeliveryFieldsFragmentDoc}`;
export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  hasNextPage
  hasPrevPage
  startCursor
  endCursor
  entries
  pages
}
    `;
export const CourierCursorFieldsFragmentDoc = gql`
    fragment courierCursorFields on CourierCursor {
  edges {
    cursor
    node {
      ...courierFields
    }
  }
  pageInfo {
    ...pageInfoFields
  }
}
    ${CourierFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;
export const CourierSearchFieldsFragmentDoc = gql`
    fragment courierSearchFields on Courier {
  id
  user {
    ...userFields
  }
  avatar {
    ...imageFields
  }
}
    ${UserFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;
export const LocationFieldsFragmentDoc = gql`
    fragment locationFields on Location {
  formattedAddress
  coordinates {
    ...geoCoordinatesFields
  }
}
    ${GeoCoordinatesFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  id
  name
  phone {
    ...phoneNumberFields
  }
  location {
    ...locationFields
  }
  remark
  pickup
  estateName
  houseNumber
  floorNumber
}
    ${PhoneNumberFieldsFragmentDoc}
${LocationFieldsFragmentDoc}`;
export const CustomerFieldsFragmentDoc = gql`
    fragment customerFields on Customer {
  id
  user {
    ...userFields
  }
  roles
  createdAt
  wallet {
    ...walletFields
  }
  currentAddress {
    ...addressFields
  }
  tag
  avatar {
    ...imageFields
  }
  transactionsCount
}
    ${UserFieldsFragmentDoc}
${WalletFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;
export const CustomerCursorFieldsFragmentDoc = gql`
    fragment customerCursorFields on CustomerCursor {
  edges {
    cursor
    node {
      ...customerFields
    }
  }
  pageInfo {
    ...pageInfoFields
  }
}
    ${CustomerFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;
export const CustomerSearchFieldsFragmentDoc = gql`
    fragment customerSearchFields on Customer {
  id
  user {
    ...userFields
  }
  avatar {
    ...imageFields
  }
}
    ${UserFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;
export const DeliveriesListFieldsFragmentDoc = gql`
    fragment deliveriesListFields on DeliveriesList {
  totalCount
  deliveries {
    ...deliveryFields
  }
}
    ${DeliveryFieldsFragmentDoc}`;
export const DeliveryActivityFieldsFragmentDoc = gql`
    fragment deliveryActivityFields on DeliveryActivity {
  count
  timeSeriesInterval {
    end
    start
  }
}
    `;
export const EarningsAmountFieldsFragmentDoc = gql`
    fragment earningsAmountFields on EarningsAmount {
  total {
    ...moneyFields
  }
  pending {
    ...moneyFields
  }
  failed {
    ...moneyFields
  }
}
    ${MoneyFieldsFragmentDoc}`;
export const MediaFieldsFragmentDoc = gql`
    fragment mediaFields on Media {
  id
  url
  contentType
}
    `;
export const MemberStatisticsFieldsFragmentDoc = gql`
    fragment memberStatisticsFields on MemberStatistics {
  merchantCount {
    all
    approved
    pending
    rejected
  }
  customerCount {
    all
    inProgress
    pending
    verified
  }
  courierCount {
    all
    drivers
    riders
  }
}
    `;
export const MerchantCategoriesFieldsFragmentDoc = gql`
    fragment merchantCategoriesFields on MerchantCategory {
  id
  name
  image {
    ...imageFields
  }
  children {
    id
    name
    image {
      ...imageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export const TimeIntervalFieldsFragmentDoc = gql`
    fragment timeIntervalFields on TimeInterval {
  from
  to
}
    `;
export const OperatingTimeFieldsFragmentDoc = gql`
    fragment operatingTimeFields on OperatingTime {
  mo {
    ...timeIntervalFields
  }
  tu {
    ...timeIntervalFields
  }
  we {
    ...timeIntervalFields
  }
  th {
    ...timeIntervalFields
  }
  fr {
    ...timeIntervalFields
  }
  sa {
    ...timeIntervalFields
  }
  su {
    ...timeIntervalFields
  }
}
    ${TimeIntervalFieldsFragmentDoc}`;
export const MerchantCategoryFieldsFragmentDoc = gql`
    fragment merchantCategoryFields on MerchantCategory {
  id
  name
  children {
    id
    name
  }
  image {
    ...imageFields
  }
}
    ${ImageFieldsFragmentDoc}`;
export const NotificationChannelFieldsFragmentDoc = gql`
    fragment notificationChannelFields on NotificationChannel {
  email
  pushNotification
  textMessage
  phoneCall
}
    `;
export const NotificationSettingsFieldsFragmentDoc = gql`
    fragment notificationSettingsFields on NotificationSettings {
  account {
    ...notificationChannelFields
  }
}
    ${NotificationChannelFieldsFragmentDoc}`;
export const MerchantFieldsFragmentDoc = gql`
    fragment merchantFields on Merchant {
  id
  name
  user {
    ...userFields
  }
  description
  shortDescription
  website
  phone {
    ...phoneNumberFields
  }
  email
  rating
  tag
  createdAt
  wallet {
    ...walletFields
  }
  addresses {
    ...addressFields
  }
  operatingTime {
    ...operatingTimeFields
  }
  logo {
    ...imageFields
  }
  coverImage {
    ...imageFields
  }
  merchantCategories {
    ...merchantCategoryFields
  }
  approvalState
  approvalMessage
  showTutorial
  applicantsName
  idNumber
  idType
  settings {
    notifications {
      ...notificationSettingsFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${WalletFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${OperatingTimeFieldsFragmentDoc}
${ImageFieldsFragmentDoc}
${MerchantCategoryFieldsFragmentDoc}
${NotificationSettingsFieldsFragmentDoc}`;
export const MerchantCursorFieldsFragmentDoc = gql`
    fragment merchantCursorFields on MerchantCursor {
  edges {
    cursor
    node {
      ...merchantFields
    }
  }
  pageInfo {
    ...pageInfoFields
  }
}
    ${MerchantFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;
export const MerchantDocumentFieldsFragmentDoc = gql`
    fragment merchantDocumentFields on MerchantDocument {
  id
  mediaId
  fileName
  reason
  size
  status
  url
  documentType
}
    `;
export const ProductCategoryFieldsFragmentDoc = gql`
    fragment productCategoryFields on ProductCategory {
  id
  name
  children {
    id
    name
  }
}
    `;
export const ReviewFieldsFragmentDoc = gql`
    fragment reviewFields on Review {
  id
  author {
    ...customerFields
  }
  score
  text
  createdAt
}
    ${CustomerFieldsFragmentDoc}`;
export const OptionFieldsFragmentDoc = gql`
    fragment optionFields on ProductOption {
  id
  name
  values
  position
}
    `;
export const SelectedOptionFieldsFragmentDoc = gql`
    fragment selectedOptionFields on SelectedOption {
  name
  value
}
    `;
export const ProductVariantFieldsFragmentDoc = gql`
    fragment productVariantFields on ProductVariant {
  id
  description
  default
  images {
    ...imageFields
  }
  option {
    ...selectedOptionFields
  }
  product {
    id
    title
    active
  }
  price {
    ...moneyFields
  }
  sku
  title
}
    ${ImageFieldsFragmentDoc}
${SelectedOptionFieldsFragmentDoc}
${MoneyFieldsFragmentDoc}`;
export const ProductFieldsFragmentDoc = gql`
    fragment productFields on Product {
  id
  categories {
    ...productCategoryFields
  }
  active
  deleted
  deletedAt
  fulfillment
  images {
    ...imageFields
  }
  merchant {
    ...merchantFields
  }
  options {
    ...optionFields
  }
  title
  variants {
    ...productVariantFields
  }
}
    ${ProductCategoryFieldsFragmentDoc}
${ImageFieldsFragmentDoc}
${MerchantFieldsFragmentDoc}
${OptionFieldsFragmentDoc}
${ProductVariantFieldsFragmentDoc}`;
export const ProductWithVariantsFieldsFragmentDoc = gql`
    fragment productWithVariantsFields on Product {
  ...productFields
  variants {
    ...productVariantFields
  }
}
    ${ProductFieldsFragmentDoc}
${ProductVariantFieldsFragmentDoc}`;
export const ProductListFieldsFragmentDoc = gql`
    fragment productListFields on ProductList {
  total
  items {
    ...productWithVariantsFields
  }
}
    ${ProductWithVariantsFieldsFragmentDoc}`;
export const SettingsFieldsFragmentDoc = gql`
    fragment settingsFields on Settings {
  notifications {
    ...notificationSettingsFields
  }
}
    ${NotificationSettingsFieldsFragmentDoc}`;
export const MerchantScreenInfoFieldsFragmentDoc = gql`
    fragment merchantScreenInfoFields on Merchant {
  name
  wallet {
    ...walletFields
  }
  merchantCategories {
    ...merchantCategoryFields
  }
  productCategories {
    ...productCategoryFields
  }
  rating
  reviews {
    ...reviewFields
  }
  products {
    ...productListFields
  }
  operatingTime {
    ...operatingTimeFields
  }
  description
  favorite
  shortDescription
  allowPayingDirectly
  logo {
    ...imageFields
  }
  coverImage {
    ...imageFields
  }
  website
  addresses {
    ...addressFields
  }
  tag
  phone {
    ...phoneNumberFields
  }
  email
  idType
  idNumber
  applicantsName
  approvalState
  approvalMessage
  showTutorial
  selection
  settings {
    ...settingsFields
  }
}
    ${WalletFieldsFragmentDoc}
${MerchantCategoryFieldsFragmentDoc}
${ProductCategoryFieldsFragmentDoc}
${ReviewFieldsFragmentDoc}
${ProductListFieldsFragmentDoc}
${OperatingTimeFieldsFragmentDoc}
${ImageFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${SettingsFieldsFragmentDoc}`;
export const MerchantSearchFieldsFragmentDoc = gql`
    fragment merchantSearchFields on Merchant {
  ...merchantFields
}
    ${MerchantFieldsFragmentDoc}`;
export const NestedMerchantCategoryFieldsFragmentDoc = gql`
    fragment nestedMerchantCategoryFields on MerchantCategory {
  id
  name
  children(active: $active) {
    id
    name
    children(active: $active) {
      id
      name
    }
  }
}
    `;
export const ProductCursorFieldsFragmentDoc = gql`
    fragment productCursorFields on ProductCursor {
  edges {
    cursor
    node {
      ...productFields
    }
  }
  pageInfo {
    ...pageInfoFields
  }
}
    ${ProductFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;
export const ReelsProductFieldsFragmentDoc = gql`
    fragment reelsProductFields on Product {
  id
  title
  variants {
    ...productVariantFields
  }
}
    ${ProductVariantFieldsFragmentDoc}`;
export const ReelFieldsFragmentDoc = gql`
    fragment reelFields on Reel {
  id
  name
  link {
    hls
  }
  merchant {
    id
    name
  }
  status
  likes
  shares
  restricted
  reason
  views
  active
  products {
    ...reelsProductFields
  }
  thumbnail {
    small
    medium
    large
  }
}
    ${ReelsProductFieldsFragmentDoc}`;
export const CreateReelFieldsFragmentDoc = gql`
    fragment createReelFields on Reel {
  id
  name
  merchant {
    id
    name
  }
  status
  likes
  shares
  views
  active
  products {
    ...reelsProductFields
  }
}
    ${ReelsProductFieldsFragmentDoc}`;
export const TimeSeriesIntervalFieldsFragmentDoc = gql`
    fragment timeSeriesIntervalFields on TimeSeriesInterval {
  start
  end
}
    `;
export const TransactionActivityFieldsFragmentDoc = gql`
    fragment transactionActivityFields on TransactionActivity {
  sum {
    ...moneyFields
  }
  timeSeriesInterval {
    ...timeSeriesIntervalFields
  }
}
    ${MoneyFieldsFragmentDoc}
${TimeSeriesIntervalFieldsFragmentDoc}`;
export const PaymentMethodsFieldsFragmentDoc = gql`
    fragment paymentMethodsFields on PaymentMethod {
  id
  name
  ... on CreditCardPaymentMethod {
    last4Digits
    provider
    type
  }
  ... on InterswitchBankAccountPaymentMethod {
    bankAccountNumber
    interswitchBank {
      id
      name
      logo {
        ...imageFields
      }
    }
  }
  ... on PhoneNumberPaymentMethod {
    name
    phone {
      ...phoneNumberFields
    }
  }
}
    ${ImageFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}`;
export const MeFieldsFragmentDoc = gql`
    fragment meFields on Admin {
  id
  user {
    ...userFields
  }
  createdAt
}
    ${UserFieldsFragmentDoc}`;
export const ActorFieldsFragmentDoc = gql`
    fragment actorFields on Actor {
  ...customerFields
  ...merchantFields
  ...meFields
  ...courierFields
}
    ${CustomerFieldsFragmentDoc}
${MerchantFieldsFragmentDoc}
${MeFieldsFragmentDoc}
${CourierFieldsFragmentDoc}`;
export const TransactionsFieldsFragmentDoc = gql`
    fragment transactionsFields on Transaction {
  id
  date
  amount {
    ...moneyFields
  }
  message
  note
  status
  referenceNumber
  ... on LoadCreditTransaction {
    paymentMethod {
      ...paymentMethodsFields
    }
    loadReceiver: receiver {
      ...actorFields
    }
  }
  ... on WithdrawTransaction {
    paymentMethod {
      ...paymentMethodsFields
    }
    withdrawIssuer: issuer {
      ...actorFields
    }
  }
  ... on TransferTransaction {
    transferReceiver: receiver {
      ...actorFields
    }
    transferIssuer: issuer {
      ...actorFields
    }
    externalAccount {
      accountNumber
    }
  }
  ... on OrderBatchTransaction {
    orderBatch: orderBatch {
      id
      referenceNumber
      merchant {
        id
        name
        user {
          ...userFields
        }
        logo {
          ...imageFields
        }
      }
      buyer {
        user {
          ...userFields
        }
        avatar {
          ...imageFields
        }
      }
    }
  }
  ... on RefundTransaction {
    orderBatch: orderBatch {
      id
      referenceNumber
      merchant {
        id
        name
        user {
          ...userFields
        }
        logo {
          ...imageFields
        }
      }
    }
  }
  ... on BillTransaction {
    externalAccount {
      accountNumber
    }
    biller
  }
}
    ${MoneyFieldsFragmentDoc}
${PaymentMethodsFieldsFragmentDoc}
${ActorFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;
export const AddOrUpdateMerchantCategoryDocument = gql`
    mutation AddOrUpdateMerchantCategory($input: MerchantCategoryInput) {
  addOrUpdateMerchantCategory(input: $input) {
    ...merchantCategoriesFields
  }
}
    ${MerchantCategoriesFieldsFragmentDoc}`;
export type AddOrUpdateMerchantCategoryMutationFn = Apollo.MutationFunction<AddOrUpdateMerchantCategoryMutation, AddOrUpdateMerchantCategoryMutationVariables>;

/**
 * __useAddOrUpdateMerchantCategoryMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateMerchantCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateMerchantCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateMerchantCategoryMutation, { data, loading, error }] = useAddOrUpdateMerchantCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrUpdateMerchantCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddOrUpdateMerchantCategoryMutation, AddOrUpdateMerchantCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrUpdateMerchantCategoryMutation, AddOrUpdateMerchantCategoryMutationVariables>(AddOrUpdateMerchantCategoryDocument, options);
      }
export type AddOrUpdateMerchantCategoryMutationHookResult = ReturnType<typeof useAddOrUpdateMerchantCategoryMutation>;
export type AddOrUpdateMerchantCategoryMutationResult = Apollo.MutationResult<AddOrUpdateMerchantCategoryMutation>;
export type AddOrUpdateMerchantCategoryMutationOptions = Apollo.BaseMutationOptions<AddOrUpdateMerchantCategoryMutation, AddOrUpdateMerchantCategoryMutationVariables>;
export const AddOrUpdateProductDocument = gql`
    mutation AddOrUpdateProduct($input: ProductInput) {
  addOrUpdateProduct(input: $input) {
    ...productFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export type AddOrUpdateProductMutationFn = Apollo.MutationFunction<AddOrUpdateProductMutation, AddOrUpdateProductMutationVariables>;

/**
 * __useAddOrUpdateProductMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateProductMutation, { data, loading, error }] = useAddOrUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<AddOrUpdateProductMutation, AddOrUpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrUpdateProductMutation, AddOrUpdateProductMutationVariables>(AddOrUpdateProductDocument, options);
      }
export type AddOrUpdateProductMutationHookResult = ReturnType<typeof useAddOrUpdateProductMutation>;
export type AddOrUpdateProductMutationResult = Apollo.MutationResult<AddOrUpdateProductMutation>;
export type AddOrUpdateProductMutationOptions = Apollo.BaseMutationOptions<AddOrUpdateProductMutation, AddOrUpdateProductMutationVariables>;
export const ChangeCustomerWalletStateDocument = gql`
    mutation ChangeCustomerWalletState($id: ID, $reason: String!, $state: WalletActivationStatus) {
  changeCustomerWalletState(id: $id, reason: $reason, state: $state) {
    ...walletActivationFields
  }
}
    ${WalletActivationFieldsFragmentDoc}`;
export type ChangeCustomerWalletStateMutationFn = Apollo.MutationFunction<ChangeCustomerWalletStateMutation, ChangeCustomerWalletStateMutationVariables>;

/**
 * __useChangeCustomerWalletStateMutation__
 *
 * To run a mutation, you first call `useChangeCustomerWalletStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCustomerWalletStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCustomerWalletStateMutation, { data, loading, error }] = useChangeCustomerWalletStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useChangeCustomerWalletStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCustomerWalletStateMutation, ChangeCustomerWalletStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCustomerWalletStateMutation, ChangeCustomerWalletStateMutationVariables>(ChangeCustomerWalletStateDocument, options);
      }
export type ChangeCustomerWalletStateMutationHookResult = ReturnType<typeof useChangeCustomerWalletStateMutation>;
export type ChangeCustomerWalletStateMutationResult = Apollo.MutationResult<ChangeCustomerWalletStateMutation>;
export type ChangeCustomerWalletStateMutationOptions = Apollo.BaseMutationOptions<ChangeCustomerWalletStateMutation, ChangeCustomerWalletStateMutationVariables>;
export const ChangeMerchantApprovalStateDocument = gql`
    mutation ChangeMerchantApprovalState($id: ID!, $changeMerchantApprovalStateInput: ChangeMerchantApprovalStateInput) {
  changeMerchantApprovalState(id: $id, input: $changeMerchantApprovalStateInput) {
    ...merchantFields
  }
}
    ${MerchantFieldsFragmentDoc}`;
export type ChangeMerchantApprovalStateMutationFn = Apollo.MutationFunction<ChangeMerchantApprovalStateMutation, ChangeMerchantApprovalStateMutationVariables>;

/**
 * __useChangeMerchantApprovalStateMutation__
 *
 * To run a mutation, you first call `useChangeMerchantApprovalStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMerchantApprovalStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMerchantApprovalStateMutation, { data, loading, error }] = useChangeMerchantApprovalStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changeMerchantApprovalStateInput: // value for 'changeMerchantApprovalStateInput'
 *   },
 * });
 */
export function useChangeMerchantApprovalStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMerchantApprovalStateMutation, ChangeMerchantApprovalStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMerchantApprovalStateMutation, ChangeMerchantApprovalStateMutationVariables>(ChangeMerchantApprovalStateDocument, options);
      }
export type ChangeMerchantApprovalStateMutationHookResult = ReturnType<typeof useChangeMerchantApprovalStateMutation>;
export type ChangeMerchantApprovalStateMutationResult = Apollo.MutationResult<ChangeMerchantApprovalStateMutation>;
export type ChangeMerchantApprovalStateMutationOptions = Apollo.BaseMutationOptions<ChangeMerchantApprovalStateMutation, ChangeMerchantApprovalStateMutationVariables>;
export const ChangeMerchantDocumentStatusDocument = gql`
    mutation ChangeMerchantDocumentStatus($input: ChangeMerchantDocumentStatusInput!) {
  changeMerchantDocumentStatus(input: $input) {
    ...merchantDocumentFields
  }
}
    ${MerchantDocumentFieldsFragmentDoc}`;
export type ChangeMerchantDocumentStatusMutationFn = Apollo.MutationFunction<ChangeMerchantDocumentStatusMutation, ChangeMerchantDocumentStatusMutationVariables>;

/**
 * __useChangeMerchantDocumentStatusMutation__
 *
 * To run a mutation, you first call `useChangeMerchantDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMerchantDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMerchantDocumentStatusMutation, { data, loading, error }] = useChangeMerchantDocumentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMerchantDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMerchantDocumentStatusMutation, ChangeMerchantDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMerchantDocumentStatusMutation, ChangeMerchantDocumentStatusMutationVariables>(ChangeMerchantDocumentStatusDocument, options);
      }
export type ChangeMerchantDocumentStatusMutationHookResult = ReturnType<typeof useChangeMerchantDocumentStatusMutation>;
export type ChangeMerchantDocumentStatusMutationResult = Apollo.MutationResult<ChangeMerchantDocumentStatusMutation>;
export type ChangeMerchantDocumentStatusMutationOptions = Apollo.BaseMutationOptions<ChangeMerchantDocumentStatusMutation, ChangeMerchantDocumentStatusMutationVariables>;
export const RemoveProductDocument = gql`
    mutation RemoveProduct($id: ID!) {
  removeProduct(id: $id)
}
    `;
export type RemoveProductMutationFn = Apollo.MutationFunction<RemoveProductMutation, RemoveProductMutationVariables>;

/**
 * __useRemoveProductMutation__
 *
 * To run a mutation, you first call `useRemoveProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductMutation, { data, loading, error }] = useRemoveProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductMutation, RemoveProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductMutation, RemoveProductMutationVariables>(RemoveProductDocument, options);
      }
export type RemoveProductMutationHookResult = ReturnType<typeof useRemoveProductMutation>;
export type RemoveProductMutationResult = Apollo.MutationResult<RemoveProductMutation>;
export type RemoveProductMutationOptions = Apollo.BaseMutationOptions<RemoveProductMutation, RemoveProductMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const UpdateMerchantDocument = gql`
    mutation UpdateMerchant($id: ID!, $merchantUpdateInput: MerchantUpdateInput!) {
  updateMerchant(id: $id, input: $merchantUpdateInput) {
    ...merchantFields
  }
}
    ${MerchantFieldsFragmentDoc}`;
export type UpdateMerchantMutationFn = Apollo.MutationFunction<UpdateMerchantMutation, UpdateMerchantMutationVariables>;

/**
 * __useUpdateMerchantMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantMutation, { data, loading, error }] = useUpdateMerchantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      merchantUpdateInput: // value for 'merchantUpdateInput'
 *   },
 * });
 */
export function useUpdateMerchantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantMutation, UpdateMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantMutation, UpdateMerchantMutationVariables>(UpdateMerchantDocument, options);
      }
export type UpdateMerchantMutationHookResult = ReturnType<typeof useUpdateMerchantMutation>;
export type UpdateMerchantMutationResult = Apollo.MutationResult<UpdateMerchantMutation>;
export type UpdateMerchantMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantMutation, UpdateMerchantMutationVariables>;
export const UpdateReelDocument = gql`
    mutation UpdateReel($id: ID!, $input: UpdateReelInput!) {
  updateReel(id: $id, input: $input) {
    ...reelFields
  }
}
    ${ReelFieldsFragmentDoc}`;
export type UpdateReelMutationFn = Apollo.MutationFunction<UpdateReelMutation, UpdateReelMutationVariables>;

/**
 * __useUpdateReelMutation__
 *
 * To run a mutation, you first call `useUpdateReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReelMutation, { data, loading, error }] = useUpdateReelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReelMutation, UpdateReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReelMutation, UpdateReelMutationVariables>(UpdateReelDocument, options);
      }
export type UpdateReelMutationHookResult = ReturnType<typeof useUpdateReelMutation>;
export type UpdateReelMutationResult = Apollo.MutationResult<UpdateReelMutation>;
export type UpdateReelMutationOptions = Apollo.BaseMutationOptions<UpdateReelMutation, UpdateReelMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID, $input: UpdateUserInput) {
  updateUser(id: $id, input: $input) {
    ...actorFields
  }
}
    ${ActorFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UploadMediaDocument = gql`
    mutation UploadMedia($file: Upload!) {
  uploadMedia(file: $file) {
    id
    url
    contentType
  }
}
    `;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const CourierDocument = gql`
    query Courier($id: ID!) {
  courier(id: $id) {
    ...courierFields
  }
}
    ${CourierFieldsFragmentDoc}`;

/**
 * __useCourierQuery__
 *
 * To run a query within a React component, call `useCourierQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourierQuery(baseOptions: Apollo.QueryHookOptions<CourierQuery, CourierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourierQuery, CourierQueryVariables>(CourierDocument, options);
      }
export function useCourierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourierQuery, CourierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourierQuery, CourierQueryVariables>(CourierDocument, options);
        }
export type CourierQueryHookResult = ReturnType<typeof useCourierQuery>;
export type CourierLazyQueryHookResult = ReturnType<typeof useCourierLazyQuery>;
export type CourierQueryResult = Apollo.QueryResult<CourierQuery, CourierQueryVariables>;
export const CourierSearchDocument = gql`
    query courierSearch($text: String) {
  courierSearch(searchQuery: {text: $text}) {
    couriers {
      ...courierFields
    }
  }
}
    ${CourierFieldsFragmentDoc}`;

/**
 * __useCourierSearchQuery__
 *
 * To run a query within a React component, call `useCourierSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourierSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourierSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCourierSearchQuery(baseOptions?: Apollo.QueryHookOptions<CourierSearchQuery, CourierSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourierSearchQuery, CourierSearchQueryVariables>(CourierSearchDocument, options);
      }
export function useCourierSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourierSearchQuery, CourierSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourierSearchQuery, CourierSearchQueryVariables>(CourierSearchDocument, options);
        }
export type CourierSearchQueryHookResult = ReturnType<typeof useCourierSearchQuery>;
export type CourierSearchLazyQueryHookResult = ReturnType<typeof useCourierSearchLazyQuery>;
export type CourierSearchQueryResult = Apollo.QueryResult<CourierSearchQuery, CourierSearchQueryVariables>;
export const CouriersWithCursorPaginationDocument = gql`
    query CouriersWithCursorPagination($input: CourierCursorInput!) {
  couriersWithCursorPagination(input: $input) {
    ...courierCursorFields
  }
}
    ${CourierCursorFieldsFragmentDoc}`;

/**
 * __useCouriersWithCursorPaginationQuery__
 *
 * To run a query within a React component, call `useCouriersWithCursorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouriersWithCursorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouriersWithCursorPaginationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouriersWithCursorPaginationQuery(baseOptions: Apollo.QueryHookOptions<CouriersWithCursorPaginationQuery, CouriersWithCursorPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouriersWithCursorPaginationQuery, CouriersWithCursorPaginationQueryVariables>(CouriersWithCursorPaginationDocument, options);
      }
export function useCouriersWithCursorPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouriersWithCursorPaginationQuery, CouriersWithCursorPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouriersWithCursorPaginationQuery, CouriersWithCursorPaginationQueryVariables>(CouriersWithCursorPaginationDocument, options);
        }
export type CouriersWithCursorPaginationQueryHookResult = ReturnType<typeof useCouriersWithCursorPaginationQuery>;
export type CouriersWithCursorPaginationLazyQueryHookResult = ReturnType<typeof useCouriersWithCursorPaginationLazyQuery>;
export type CouriersWithCursorPaginationQueryResult = Apollo.QueryResult<CouriersWithCursorPaginationQuery, CouriersWithCursorPaginationQueryVariables>;
export const CustomerDocument = gql`
    query Customer($id: ID!) {
  customer(id: $id) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CustomerSearchDocument = gql`
    query customerSearch($text: String) {
  customerSearch(searchQuery: {text: $text}) {
    customers {
      ...customerFields
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useCustomerSearchQuery__
 *
 * To run a query within a React component, call `useCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCustomerSearchQuery(baseOptions?: Apollo.QueryHookOptions<CustomerSearchQuery, CustomerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSearchQuery, CustomerSearchQueryVariables>(CustomerSearchDocument, options);
      }
export function useCustomerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSearchQuery, CustomerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSearchQuery, CustomerSearchQueryVariables>(CustomerSearchDocument, options);
        }
export type CustomerSearchQueryHookResult = ReturnType<typeof useCustomerSearchQuery>;
export type CustomerSearchLazyQueryHookResult = ReturnType<typeof useCustomerSearchLazyQuery>;
export type CustomerSearchQueryResult = Apollo.QueryResult<CustomerSearchQuery, CustomerSearchQueryVariables>;
export const CustomersWithCursorPaginationDocument = gql`
    query CustomersWithCursorPagination($input: CustomerCursorInput!) {
  customersWithCursorPagination(input: $input) {
    ...customerCursorFields
  }
}
    ${CustomerCursorFieldsFragmentDoc}`;

/**
 * __useCustomersWithCursorPaginationQuery__
 *
 * To run a query within a React component, call `useCustomersWithCursorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersWithCursorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersWithCursorPaginationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomersWithCursorPaginationQuery(baseOptions: Apollo.QueryHookOptions<CustomersWithCursorPaginationQuery, CustomersWithCursorPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersWithCursorPaginationQuery, CustomersWithCursorPaginationQueryVariables>(CustomersWithCursorPaginationDocument, options);
      }
export function useCustomersWithCursorPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersWithCursorPaginationQuery, CustomersWithCursorPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersWithCursorPaginationQuery, CustomersWithCursorPaginationQueryVariables>(CustomersWithCursorPaginationDocument, options);
        }
export type CustomersWithCursorPaginationQueryHookResult = ReturnType<typeof useCustomersWithCursorPaginationQuery>;
export type CustomersWithCursorPaginationLazyQueryHookResult = ReturnType<typeof useCustomersWithCursorPaginationLazyQuery>;
export type CustomersWithCursorPaginationQueryResult = Apollo.QueryResult<CustomersWithCursorPaginationQuery, CustomersWithCursorPaginationQueryVariables>;
export const DeliveriesDocument = gql`
    query deliveries($input: DeliverySelectionInput) {
  deliveries(input: $input) {
    ...deliveriesListFields
  }
}
    ${DeliveriesListFieldsFragmentDoc}`;

/**
 * __useDeliveriesQuery__
 *
 * To run a query within a React component, call `useDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
      }
export function useDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
        }
export type DeliveriesQueryHookResult = ReturnType<typeof useDeliveriesQuery>;
export type DeliveriesLazyQueryHookResult = ReturnType<typeof useDeliveriesLazyQuery>;
export type DeliveriesQueryResult = Apollo.QueryResult<DeliveriesQuery, DeliveriesQueryVariables>;
export const DeliveryActivityDocument = gql`
    query deliveryActivity($input: DeliveryActivityInput) {
  deliveryActivity(input: $input) {
    ...deliveryActivityFields
  }
}
    ${DeliveryActivityFieldsFragmentDoc}`;

/**
 * __useDeliveryActivityQuery__
 *
 * To run a query within a React component, call `useDeliveryActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryActivityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliveryActivityQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryActivityQuery, DeliveryActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryActivityQuery, DeliveryActivityQueryVariables>(DeliveryActivityDocument, options);
      }
export function useDeliveryActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryActivityQuery, DeliveryActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryActivityQuery, DeliveryActivityQueryVariables>(DeliveryActivityDocument, options);
        }
export type DeliveryActivityQueryHookResult = ReturnType<typeof useDeliveryActivityQuery>;
export type DeliveryActivityLazyQueryHookResult = ReturnType<typeof useDeliveryActivityLazyQuery>;
export type DeliveryActivityQueryResult = Apollo.QueryResult<DeliveryActivityQuery, DeliveryActivityQueryVariables>;
export const EarningsDocument = gql`
    query earnings($input: EarningsAmountInput) {
  earnings(input: $input) {
    ...earningsAmountFields
  }
}
    ${EarningsAmountFieldsFragmentDoc}`;

/**
 * __useEarningsQuery__
 *
 * To run a query within a React component, call `useEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarningsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEarningsQuery(baseOptions?: Apollo.QueryHookOptions<EarningsQuery, EarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EarningsQuery, EarningsQueryVariables>(EarningsDocument, options);
      }
export function useEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EarningsQuery, EarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EarningsQuery, EarningsQueryVariables>(EarningsDocument, options);
        }
export type EarningsQueryHookResult = ReturnType<typeof useEarningsQuery>;
export type EarningsLazyQueryHookResult = ReturnType<typeof useEarningsLazyQuery>;
export type EarningsQueryResult = Apollo.QueryResult<EarningsQuery, EarningsQueryVariables>;
export const GeoCoordinatesToLocationDocument = gql`
    query GeoCoordinatesToLocation($input: GeoCoordinatesInput!) {
  geoCoordinatesToLocation(input: $input) {
    formattedAddress
  }
}
    `;

/**
 * __useGeoCoordinatesToLocationQuery__
 *
 * To run a query within a React component, call `useGeoCoordinatesToLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoCoordinatesToLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoCoordinatesToLocationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeoCoordinatesToLocationQuery(baseOptions: Apollo.QueryHookOptions<GeoCoordinatesToLocationQuery, GeoCoordinatesToLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoCoordinatesToLocationQuery, GeoCoordinatesToLocationQueryVariables>(GeoCoordinatesToLocationDocument, options);
      }
export function useGeoCoordinatesToLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoCoordinatesToLocationQuery, GeoCoordinatesToLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoCoordinatesToLocationQuery, GeoCoordinatesToLocationQueryVariables>(GeoCoordinatesToLocationDocument, options);
        }
export type GeoCoordinatesToLocationQueryHookResult = ReturnType<typeof useGeoCoordinatesToLocationQuery>;
export type GeoCoordinatesToLocationLazyQueryHookResult = ReturnType<typeof useGeoCoordinatesToLocationLazyQuery>;
export type GeoCoordinatesToLocationQueryResult = Apollo.QueryResult<GeoCoordinatesToLocationQuery, GeoCoordinatesToLocationQueryVariables>;
export const GetKycVerificationStatusDocument = gql`
    query GetKycVerificationStatus($input: KycVerificationStatusInput) {
  getKycVerificationStatus(input: $input) {
    ...kycVerificationStatusFields
  }
}
    ${KycVerificationStatusFieldsFragmentDoc}`;

/**
 * __useGetKycVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetKycVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycVerificationStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetKycVerificationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetKycVerificationStatusQuery, GetKycVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKycVerificationStatusQuery, GetKycVerificationStatusQueryVariables>(GetKycVerificationStatusDocument, options);
      }
export function useGetKycVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKycVerificationStatusQuery, GetKycVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKycVerificationStatusQuery, GetKycVerificationStatusQueryVariables>(GetKycVerificationStatusDocument, options);
        }
export type GetKycVerificationStatusQueryHookResult = ReturnType<typeof useGetKycVerificationStatusQuery>;
export type GetKycVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetKycVerificationStatusLazyQuery>;
export type GetKycVerificationStatusQueryResult = Apollo.QueryResult<GetKycVerificationStatusQuery, GetKycVerificationStatusQueryVariables>;
export const GetReelDocument = gql`
    query getReel($id: ID!) {
  reel(id: $id) {
    ...reelFields
  }
}
    ${ReelFieldsFragmentDoc}`;

/**
 * __useGetReelQuery__
 *
 * To run a query within a React component, call `useGetReelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReelQuery(baseOptions: Apollo.QueryHookOptions<GetReelQuery, GetReelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelQuery, GetReelQueryVariables>(GetReelDocument, options);
      }
export function useGetReelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelQuery, GetReelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelQuery, GetReelQueryVariables>(GetReelDocument, options);
        }
export type GetReelQueryHookResult = ReturnType<typeof useGetReelQuery>;
export type GetReelLazyQueryHookResult = ReturnType<typeof useGetReelLazyQuery>;
export type GetReelQueryResult = Apollo.QueryResult<GetReelQuery, GetReelQueryVariables>;
export const GetReelsDocument = gql`
    query getReels($input: ReelsSelectionInput!) {
  reels(input: $input) {
    edges {
      cursor
      node {
        ...reelFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${ReelFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useGetReelsQuery__
 *
 * To run a query within a React component, call `useGetReelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelsQuery(baseOptions: Apollo.QueryHookOptions<GetReelsQuery, GetReelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelsQuery, GetReelsQueryVariables>(GetReelsDocument, options);
      }
export function useGetReelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelsQuery, GetReelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelsQuery, GetReelsQueryVariables>(GetReelsDocument, options);
        }
export type GetReelsQueryHookResult = ReturnType<typeof useGetReelsQuery>;
export type GetReelsLazyQueryHookResult = ReturnType<typeof useGetReelsLazyQuery>;
export type GetReelsQueryResult = Apollo.QueryResult<GetReelsQuery, GetReelsQueryVariables>;
export const InformaKybDocument = gql`
    query InformaKyb($id: ID!, $input: InformaKybInput) {
  merchant(id: $id) {
    informaKyb(input: $input) {
      status
      informaStatus
      registrationNumber
      registrationDate
      postalAddress
      physicalAddress
      phoneNumber
      kraPin
      email
      businessName
      partners {
        name
        idType
        idNumber
      }
    }
  }
}
    `;

/**
 * __useInformaKybQuery__
 *
 * To run a query within a React component, call `useInformaKybQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformaKybQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformaKybQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInformaKybQuery(baseOptions: Apollo.QueryHookOptions<InformaKybQuery, InformaKybQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InformaKybQuery, InformaKybQueryVariables>(InformaKybDocument, options);
      }
export function useInformaKybLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InformaKybQuery, InformaKybQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InformaKybQuery, InformaKybQueryVariables>(InformaKybDocument, options);
        }
export type InformaKybQueryHookResult = ReturnType<typeof useInformaKybQuery>;
export type InformaKybLazyQueryHookResult = ReturnType<typeof useInformaKybLazyQuery>;
export type InformaKybQueryResult = Apollo.QueryResult<InformaKybQuery, InformaKybQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...actorFields
  }
}
    ${ActorFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MemberStatisticsDocument = gql`
    query MemberStatistics {
  memberStatistics {
    ...memberStatisticsFields
  }
}
    ${MemberStatisticsFieldsFragmentDoc}`;

/**
 * __useMemberStatisticsQuery__
 *
 * To run a query within a React component, call `useMemberStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<MemberStatisticsQuery, MemberStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberStatisticsQuery, MemberStatisticsQueryVariables>(MemberStatisticsDocument, options);
      }
export function useMemberStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberStatisticsQuery, MemberStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberStatisticsQuery, MemberStatisticsQueryVariables>(MemberStatisticsDocument, options);
        }
export type MemberStatisticsQueryHookResult = ReturnType<typeof useMemberStatisticsQuery>;
export type MemberStatisticsLazyQueryHookResult = ReturnType<typeof useMemberStatisticsLazyQuery>;
export type MemberStatisticsQueryResult = Apollo.QueryResult<MemberStatisticsQuery, MemberStatisticsQueryVariables>;
export const MerchantCategoriesDocument = gql`
    query MerchantCategories {
  merchantCategories {
    ...merchantCategoriesFields
  }
}
    ${MerchantCategoriesFieldsFragmentDoc}`;

/**
 * __useMerchantCategoriesQuery__
 *
 * To run a query within a React component, call `useMerchantCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchantCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<MerchantCategoriesQuery, MerchantCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCategoriesQuery, MerchantCategoriesQueryVariables>(MerchantCategoriesDocument, options);
      }
export function useMerchantCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCategoriesQuery, MerchantCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCategoriesQuery, MerchantCategoriesQueryVariables>(MerchantCategoriesDocument, options);
        }
export type MerchantCategoriesQueryHookResult = ReturnType<typeof useMerchantCategoriesQuery>;
export type MerchantCategoriesLazyQueryHookResult = ReturnType<typeof useMerchantCategoriesLazyQuery>;
export type MerchantCategoriesQueryResult = Apollo.QueryResult<MerchantCategoriesQuery, MerchantCategoriesQueryVariables>;
export const MerchantCategoryDocument = gql`
    query MerchantCategory($id: ID!) {
  merchantCategory(id: $id) {
    ...merchantCategoriesFields
  }
}
    ${MerchantCategoriesFieldsFragmentDoc}`;

/**
 * __useMerchantCategoryQuery__
 *
 * To run a query within a React component, call `useMerchantCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantCategoryQuery(baseOptions: Apollo.QueryHookOptions<MerchantCategoryQuery, MerchantCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCategoryQuery, MerchantCategoryQueryVariables>(MerchantCategoryDocument, options);
      }
export function useMerchantCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCategoryQuery, MerchantCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCategoryQuery, MerchantCategoryQueryVariables>(MerchantCategoryDocument, options);
        }
export type MerchantCategoryQueryHookResult = ReturnType<typeof useMerchantCategoryQuery>;
export type MerchantCategoryLazyQueryHookResult = ReturnType<typeof useMerchantCategoryLazyQuery>;
export type MerchantCategoryQueryResult = Apollo.QueryResult<MerchantCategoryQuery, MerchantCategoryQueryVariables>;
export const MerchantDetailsDocument = gql`
    query MerchantDetails($id: ID!) {
  merchant(id: $id) {
    ...merchantFields
  }
}
    ${MerchantFieldsFragmentDoc}`;

/**
 * __useMerchantDetailsQuery__
 *
 * To run a query within a React component, call `useMerchantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantDetailsQuery(baseOptions: Apollo.QueryHookOptions<MerchantDetailsQuery, MerchantDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantDetailsQuery, MerchantDetailsQueryVariables>(MerchantDetailsDocument, options);
      }
export function useMerchantDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantDetailsQuery, MerchantDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantDetailsQuery, MerchantDetailsQueryVariables>(MerchantDetailsDocument, options);
        }
export type MerchantDetailsQueryHookResult = ReturnType<typeof useMerchantDetailsQuery>;
export type MerchantDetailsLazyQueryHookResult = ReturnType<typeof useMerchantDetailsLazyQuery>;
export type MerchantDetailsQueryResult = Apollo.QueryResult<MerchantDetailsQuery, MerchantDetailsQueryVariables>;
export const MerchantDocsInfoDocument = gql`
    query MerchantDocsInfo($id: ID!) {
  merchant(id: $id) {
    merchantType
    merchantDocuments {
      ...merchantDocumentFields
    }
    idType
    idNumber
  }
}
    ${MerchantDocumentFieldsFragmentDoc}`;

/**
 * __useMerchantDocsInfoQuery__
 *
 * To run a query within a React component, call `useMerchantDocsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDocsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDocsInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantDocsInfoQuery(baseOptions: Apollo.QueryHookOptions<MerchantDocsInfoQuery, MerchantDocsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantDocsInfoQuery, MerchantDocsInfoQueryVariables>(MerchantDocsInfoDocument, options);
      }
export function useMerchantDocsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantDocsInfoQuery, MerchantDocsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantDocsInfoQuery, MerchantDocsInfoQueryVariables>(MerchantDocsInfoDocument, options);
        }
export type MerchantDocsInfoQueryHookResult = ReturnType<typeof useMerchantDocsInfoQuery>;
export type MerchantDocsInfoLazyQueryHookResult = ReturnType<typeof useMerchantDocsInfoLazyQuery>;
export type MerchantDocsInfoQueryResult = Apollo.QueryResult<MerchantDocsInfoQuery, MerchantDocsInfoQueryVariables>;
export const MerchantDocumentsDocument = gql`
    query MerchantDocuments($input: MerchantDocumentsInput) {
  merchantDocuments(input: $input) {
    ...merchantDocumentFields
  }
}
    ${MerchantDocumentFieldsFragmentDoc}`;

/**
 * __useMerchantDocumentsQuery__
 *
 * To run a query within a React component, call `useMerchantDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDocumentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantDocumentsQuery, MerchantDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantDocumentsQuery, MerchantDocumentsQueryVariables>(MerchantDocumentsDocument, options);
      }
export function useMerchantDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantDocumentsQuery, MerchantDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantDocumentsQuery, MerchantDocumentsQueryVariables>(MerchantDocumentsDocument, options);
        }
export type MerchantDocumentsQueryHookResult = ReturnType<typeof useMerchantDocumentsQuery>;
export type MerchantDocumentsLazyQueryHookResult = ReturnType<typeof useMerchantDocumentsLazyQuery>;
export type MerchantDocumentsQueryResult = Apollo.QueryResult<MerchantDocumentsQuery, MerchantDocumentsQueryVariables>;
export const MerchantSearchDocument = gql`
    query merchantSearch($text: String) {
  merchantSearch(searchQuery: {text: $text}) {
    merchants {
      ...merchantFields
    }
  }
}
    ${MerchantFieldsFragmentDoc}`;

/**
 * __useMerchantSearchQuery__
 *
 * To run a query within a React component, call `useMerchantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useMerchantSearchQuery(baseOptions?: Apollo.QueryHookOptions<MerchantSearchQuery, MerchantSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantSearchQuery, MerchantSearchQueryVariables>(MerchantSearchDocument, options);
      }
export function useMerchantSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantSearchQuery, MerchantSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantSearchQuery, MerchantSearchQueryVariables>(MerchantSearchDocument, options);
        }
export type MerchantSearchQueryHookResult = ReturnType<typeof useMerchantSearchQuery>;
export type MerchantSearchLazyQueryHookResult = ReturnType<typeof useMerchantSearchLazyQuery>;
export type MerchantSearchQueryResult = Apollo.QueryResult<MerchantSearchQuery, MerchantSearchQueryVariables>;
export const MerchantsWithCursorPaginationDocument = gql`
    query MerchantsWithCursorPagination($input: MerchantCursorInput!) {
  merchantsWithCursorPagination(input: $input) {
    ...merchantCursorFields
  }
}
    ${MerchantCursorFieldsFragmentDoc}`;

/**
 * __useMerchantsWithCursorPaginationQuery__
 *
 * To run a query within a React component, call `useMerchantsWithCursorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsWithCursorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsWithCursorPaginationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantsWithCursorPaginationQuery(baseOptions: Apollo.QueryHookOptions<MerchantsWithCursorPaginationQuery, MerchantsWithCursorPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantsWithCursorPaginationQuery, MerchantsWithCursorPaginationQueryVariables>(MerchantsWithCursorPaginationDocument, options);
      }
export function useMerchantsWithCursorPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantsWithCursorPaginationQuery, MerchantsWithCursorPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantsWithCursorPaginationQuery, MerchantsWithCursorPaginationQueryVariables>(MerchantsWithCursorPaginationDocument, options);
        }
export type MerchantsWithCursorPaginationQueryHookResult = ReturnType<typeof useMerchantsWithCursorPaginationQuery>;
export type MerchantsWithCursorPaginationLazyQueryHookResult = ReturnType<typeof useMerchantsWithCursorPaginationLazyQuery>;
export type MerchantsWithCursorPaginationQueryResult = Apollo.QueryResult<MerchantsWithCursorPaginationQuery, MerchantsWithCursorPaginationQueryVariables>;
export const NestedMerchantCategoryDocument = gql`
    query NestedMerchantCategory($id: ID!, $active: Boolean) {
  merchantCategory(id: $id) {
    ...nestedMerchantCategoryFields
  }
}
    ${NestedMerchantCategoryFieldsFragmentDoc}`;

/**
 * __useNestedMerchantCategoryQuery__
 *
 * To run a query within a React component, call `useNestedMerchantCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNestedMerchantCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNestedMerchantCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useNestedMerchantCategoryQuery(baseOptions: Apollo.QueryHookOptions<NestedMerchantCategoryQuery, NestedMerchantCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NestedMerchantCategoryQuery, NestedMerchantCategoryQueryVariables>(NestedMerchantCategoryDocument, options);
      }
export function useNestedMerchantCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NestedMerchantCategoryQuery, NestedMerchantCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NestedMerchantCategoryQuery, NestedMerchantCategoryQueryVariables>(NestedMerchantCategoryDocument, options);
        }
export type NestedMerchantCategoryQueryHookResult = ReturnType<typeof useNestedMerchantCategoryQuery>;
export type NestedMerchantCategoryLazyQueryHookResult = ReturnType<typeof useNestedMerchantCategoryLazyQuery>;
export type NestedMerchantCategoryQueryResult = Apollo.QueryResult<NestedMerchantCategoryQuery, NestedMerchantCategoryQueryVariables>;
export const ProductDocument = gql`
    query Product($id: ID!) {
  product(id: $id) {
    ...productWithVariantsFields
  }
}
    ${ProductWithVariantsFieldsFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductsWithCursorPaginationDocument = gql`
    query ProductsWithCursorPagination($input: ProductCursorInput!) {
  productsWithCursorPagination(input: $input) {
    ...productCursorFields
  }
}
    ${ProductCursorFieldsFragmentDoc}`;

/**
 * __useProductsWithCursorPaginationQuery__
 *
 * To run a query within a React component, call `useProductsWithCursorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsWithCursorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsWithCursorPaginationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductsWithCursorPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProductsWithCursorPaginationQuery, ProductsWithCursorPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsWithCursorPaginationQuery, ProductsWithCursorPaginationQueryVariables>(ProductsWithCursorPaginationDocument, options);
      }
export function useProductsWithCursorPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsWithCursorPaginationQuery, ProductsWithCursorPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsWithCursorPaginationQuery, ProductsWithCursorPaginationQueryVariables>(ProductsWithCursorPaginationDocument, options);
        }
export type ProductsWithCursorPaginationQueryHookResult = ReturnType<typeof useProductsWithCursorPaginationQuery>;
export type ProductsWithCursorPaginationLazyQueryHookResult = ReturnType<typeof useProductsWithCursorPaginationLazyQuery>;
export type ProductsWithCursorPaginationQueryResult = Apollo.QueryResult<ProductsWithCursorPaginationQuery, ProductsWithCursorPaginationQueryVariables>;
export const GetSearchDocument = gql`
    query GetSearch($text: String) {
  search(searchQuery: {text: $text}) {
    merchants {
      ...merchantFields
    }
  }
}
    ${MerchantFieldsFragmentDoc}`;

/**
 * __useGetSearchQuery__
 *
 * To run a query within a React component, call `useGetSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useGetSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchQuery, GetSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchQuery, GetSearchQueryVariables>(GetSearchDocument, options);
      }
export function useGetSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchQuery, GetSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchQuery, GetSearchQueryVariables>(GetSearchDocument, options);
        }
export type GetSearchQueryHookResult = ReturnType<typeof useGetSearchQuery>;
export type GetSearchLazyQueryHookResult = ReturnType<typeof useGetSearchLazyQuery>;
export type GetSearchQueryResult = Apollo.QueryResult<GetSearchQuery, GetSearchQueryVariables>;
export const TransactionActivityDocument = gql`
    query transactionActivity($input: TransactionActivityInput) {
  transactionActivity(input: $input) {
    ...transactionActivityFields
  }
}
    ${TransactionActivityFieldsFragmentDoc}`;

/**
 * __useTransactionActivityQuery__
 *
 * To run a query within a React component, call `useTransactionActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionActivityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionActivityQuery(baseOptions?: Apollo.QueryHookOptions<TransactionActivityQuery, TransactionActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionActivityQuery, TransactionActivityQueryVariables>(TransactionActivityDocument, options);
      }
export function useTransactionActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionActivityQuery, TransactionActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionActivityQuery, TransactionActivityQueryVariables>(TransactionActivityDocument, options);
        }
export type TransactionActivityQueryHookResult = ReturnType<typeof useTransactionActivityQuery>;
export type TransactionActivityLazyQueryHookResult = ReturnType<typeof useTransactionActivityLazyQuery>;
export type TransactionActivityQueryResult = Apollo.QueryResult<TransactionActivityQuery, TransactionActivityQueryVariables>;
export const TransactionsDocument = gql`
    query transactions($input: TransactionSelectionInput) {
  transactions(input: $input) {
    totalCount
    transactions {
      ...transactionsFields
    }
  }
}
    ${TransactionsFieldsFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes = ResolversObject<{
  Actor: ( Admin ) | ( Courier ) | ( Customer ) | ( Merchant );
}>;

/** Mapping of union parent types */
export type ResolversUnionParentTypes = ResolversObject<{
  Actor: ( Admin ) | ( Courier ) | ( Customer ) | ( Merchant );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AcceptPaymentRequestInput: AcceptPaymentRequestInput;
  Actor: ResolverTypeWrapper<ResolversUnionTypes['Actor']>;
  AddProductToWishlistInput: AddProductToWishlistInput;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  Admin: ResolverTypeWrapper<Admin>;
  Aml: ResolverTypeWrapper<Aml>;
  ApprovalState: ApprovalState;
  AuthProvider: AuthProvider;
  AuthenticationType: AuthenticationType;
  Bill: ResolverTypeWrapper<Bill>;
  BillTransaction: ResolverTypeWrapper<Omit<BillTransaction, 'issuer'> & { issuer?: Maybe<ResolversTypes['Actor']> }>;
  Biller: Biller;
  BillingInfoInput: BillingInfoInput;
  BiometricsTokenInput: BiometricsTokenInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  ByRegistrationNumber: ByRegistrationNumber;
  CardType: CardType;
  CategorizedMerchants: ResolverTypeWrapper<CategorizedMerchants>;
  ChangeMerchantApprovalStateInput: ChangeMerchantApprovalStateInput;
  ChangeMerchantDocumentStatusInput: ChangeMerchantDocumentStatusInput;
  ChangeOrdersStatusInput: ChangeOrdersStatusInput;
  Chat: ResolverTypeWrapper<Omit<Chat, 'members'> & { members: Array<ResolversTypes['Actor']> }>;
  ChatEdge: ResolverTypeWrapper<ChatEdge>;
  ChatType: ChatType;
  ChatsCursor: ResolverTypeWrapper<ChatsCursor>;
  Country: Country;
  Courier: ResolverTypeWrapper<Courier>;
  CourierCount: ResolverTypeWrapper<CourierCount>;
  CourierCursor: ResolverTypeWrapper<CourierCursor>;
  CourierCursorInput: CourierCursorInput;
  CourierEdge: ResolverTypeWrapper<CourierEdge>;
  CourierLastLocationInput: CourierLastLocationInput;
  CourierSelectionInput: CourierSelectionInput;
  CourierType: CourierType;
  CourierUpdateInput: CourierUpdateInput;
  CourierWithDistance: ResolverTypeWrapper<CourierWithDistance>;
  CouriersList: ResolverTypeWrapper<CouriersList>;
  CouriersSearchResult: ResolverTypeWrapper<CouriersSearchResult>;
  CreateInviteInput: CreateInviteInput;
  CreateMerchantDocumentInput: CreateMerchantDocumentInput;
  CreateReelInput: CreateReelInput;
  CreateWishlistInput: CreateWishlistInput;
  CreditCardInput: CreditCardInput;
  CreditCardPaymentMethod: ResolverTypeWrapper<CreditCardPaymentMethod>;
  CurrencyCode: CurrencyCode;
  CursorInput: CursorInput;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerCount: ResolverTypeWrapper<CustomerCount>;
  CustomerCursor: ResolverTypeWrapper<CustomerCursor>;
  CustomerCursorInput: CustomerCursorInput;
  CustomerEdge: ResolverTypeWrapper<CustomerEdge>;
  CustomerSelectionInput: CustomerSelectionInput;
  CustomerUpdateInput: CustomerUpdateInput;
  CustomersList: ResolverTypeWrapper<CustomersList>;
  CustomersSearchResult: ResolverTypeWrapper<CustomersSearchResult>;
  CybersourceDepositInput: CybersourceDepositInput;
  CybersourceDeviceCollectionJwt: ResolverTypeWrapper<CybersourceDeviceCollectionJwt>;
  CybersourceJwt: ResolversTypes['CybersourceDeviceCollectionJwt'] | ResolversTypes['CybersourceStepupJwt'];
  CybersourceStepupJwt: ResolverTypeWrapper<CybersourceStepupJwt>;
  DailySpend: ResolverTypeWrapper<DailySpend>;
  DateInterval: DateInterval;
  DatePreset: DatePreset;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  DebitOrCredit: DebitOrCredit;
  DeliveriesList: ResolverTypeWrapper<DeliveriesList>;
  DeliveriesSearchResult: ResolverTypeWrapper<DeliveriesSearchResult>;
  Delivery: ResolverTypeWrapper<Delivery>;
  DeliveryActivity: ResolverTypeWrapper<DeliveryActivity>;
  DeliveryActivityInput: DeliveryActivityInput;
  DeliveryFilterInput: DeliveryFilterInput;
  DeliveryRequest: ResolverTypeWrapper<DeliveryRequest>;
  DeliveryRequestInput: DeliveryRequestInput;
  DeliverySelectionInput: DeliverySelectionInput;
  DeliveryStatus: DeliveryStatus;
  DeliveryStatusUpdate: ResolverTypeWrapper<DeliveryStatusUpdate>;
  DepositInput: DepositInput;
  DistanceFilterInput: DistanceFilterInput;
  DocumentStatus: DocumentStatus;
  DocumentType: DocumentType;
  EarningsAmount: ResolverTypeWrapper<EarningsAmount>;
  EarningsAmountInput: EarningsAmountInput;
  Error: ResolversTypes['TransactionError'] | ResolversTypes['ValidationError'];
  ErrorTypes: ErrorTypes;
  Event: ResolversTypes['DeliveryStatusUpdate'] | ResolversTypes['PaymentRequestEvent'] | ResolversTypes['SystemNotification'] | ResolversTypes['TransactionEvent'];
  EventType: EventType;
  EventsInput: EventsInput;
  EventsList: ResolverTypeWrapper<EventsList>;
  ExternalAccount: ResolverTypeWrapper<ExternalAccount>;
  ExternalAccountInput: ExternalAccountInput;
  FetchBillInput: FetchBillInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FreeMoneyDevPaymentMethod: ResolverTypeWrapper<FreeMoneyDevPaymentMethod>;
  Fulfillment: Fulfillment;
  GeoCoordinates: ResolverTypeWrapper<GeoCoordinates>;
  GeoCoordinatesInput: GeoCoordinatesInput;
  HighestEver: ResolverTypeWrapper<HighestEver>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IdentificationNumberLog: ResolverTypeWrapper<IdentificationNumberLog>;
  IdentificationNumberLogs: ResolverTypeWrapper<IdentificationNumberLogs>;
  Image: ResolverTypeWrapper<Image>;
  IndividualInput: IndividualInput;
  InformaKyb: ResolverTypeWrapper<InformaKyb>;
  InformaKybInput: InformaKybInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InterswitchBank: ResolverTypeWrapper<InterswitchBank>;
  InterswitchBankAccountInput: InterswitchBankAccountInput;
  InterswitchBankAccountPaymentMethod: ResolverTypeWrapper<InterswitchBankAccountPaymentMethod>;
  Invitation: ResolverTypeWrapper<Invitation>;
  KycVerificationLog: ResolversTypes['IdentificationNumberLog'] | ResolversTypes['LivenessLog'] | ResolversTypes['PhoneNumberLog'];
  KycVerificationStatus: ResolverTypeWrapper<KycVerificationStatus>;
  KycVerificationStatusInput: KycVerificationStatusInput;
  KycVerificationStatusUpdateInput: KycVerificationStatusUpdateInput;
  LimitedCompanyInput: LimitedCompanyInput;
  LivenessLog: ResolverTypeWrapper<LivenessLog>;
  LivenessLogs: ResolverTypeWrapper<LivenessLogs>;
  LoadCreditTransaction: ResolverTypeWrapper<Omit<LoadCreditTransaction, 'receiver'> & { receiver?: Maybe<ResolversTypes['Actor']> }>;
  LoadWalletInput: LoadWalletInput;
  Location: ResolverTypeWrapper<Location>;
  Login: ResolverTypeWrapper<Omit<Login, 'user'> & { user?: Maybe<ResolversTypes['Actor']> }>;
  LoginInput: LoginInput;
  LoginWithCodeInput: LoginWithCodeInput;
  LoginWithProviderInput: LoginWithProviderInput;
  LogoutInput: LogoutInput;
  Media: ResolverTypeWrapper<Media>;
  MemberStatistics: ResolverTypeWrapper<MemberStatistics>;
  Merchant: ResolverTypeWrapper<Merchant>;
  MerchantCategory: ResolverTypeWrapper<MerchantCategory>;
  MerchantCategoryInput: MerchantCategoryInput;
  MerchantCount: ResolverTypeWrapper<MerchantCount>;
  MerchantCursor: ResolverTypeWrapper<MerchantCursor>;
  MerchantCursorInput: MerchantCursorInput;
  MerchantDocument: ResolverTypeWrapper<MerchantDocument>;
  MerchantDocumentsInput: MerchantDocumentsInput;
  MerchantEdge: ResolverTypeWrapper<MerchantEdge>;
  MerchantFilterInput: MerchantFilterInput;
  MerchantOnboardingInput: MerchantOnboardingInput;
  MerchantSelection: MerchantSelection;
  MerchantSelectionInput: MerchantSelectionInput;
  MerchantType: MerchantType;
  MerchantTypeInput: MerchantTypeInput;
  MerchantUpdateInput: MerchantUpdateInput;
  MerchantWithDistance: ResolverTypeWrapper<MerchantWithDistance>;
  MerchantsList: ResolverTypeWrapper<MerchantsList>;
  MerchantsSearchResult: ResolverTypeWrapper<MerchantsSearchResult>;
  Message: ResolverTypeWrapper<Omit<Message, 'author'> & { author: ResolversTypes['Actor'] }>;
  MessageEdge: ResolverTypeWrapper<MessageEdge>;
  MessagesCursor: ResolverTypeWrapper<MessagesCursor>;
  Money: ResolverTypeWrapper<Money>;
  MoneyInput: MoneyInput;
  NewMessage: ResolverTypeWrapper<NewMessage>;
  NotificationChannel: ResolverTypeWrapper<NotificationChannel>;
  NotificationChannelInput: NotificationChannelInput;
  NotificationSettings: ResolverTypeWrapper<NotificationSettings>;
  NotificationSettingsInput: NotificationSettingsInput;
  OperatingTime: ResolverTypeWrapper<OperatingTime>;
  OperatingTimeInput: OperatingTimeInput;
  Order: ResolverTypeWrapper<Order>;
  OrderBatch: ResolverTypeWrapper<OrderBatch>;
  OrderBatchCursor: ResolverTypeWrapper<OrderBatchCursor>;
  OrderBatchEdge: ResolverTypeWrapper<OrderBatchEdge>;
  OrderBatchTransaction: ResolverTypeWrapper<OrderBatchTransaction>;
  OrderBatchesInput: OrderBatchesInput;
  OrderFilterInput: OrderFilterInput;
  OrderFulfillment: OrderFulfillment;
  OrderInput: OrderInput;
  OrderListItem: ResolverTypeWrapper<OrderListItem>;
  OrderListItemInput: OrderListItemInput;
  OrderStatus: OrderStatus;
  OrderTracking: ResolverTypeWrapper<OrderTracking>;
  OwnProductsSearchResult: ResolverTypeWrapper<OwnProductsSearchResult>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Partner: ResolverTypeWrapper<Partner>;
  PartnershipInput: PartnershipInput;
  PayBillInput: PayBillInput;
  PaymentMethod: ResolversTypes['CreditCardPaymentMethod'] | ResolversTypes['FreeMoneyDevPaymentMethod'] | ResolversTypes['InterswitchBankAccountPaymentMethod'] | ResolversTypes['PhoneNumberPaymentMethod'];
  PaymentMethodInput: PaymentMethodInput;
  PaymentMethodType: PaymentMethodType;
  PaymentProvider: PaymentProvider;
  PaymentRequest: ResolverTypeWrapper<Omit<PaymentRequest, 'issuer' | 'receiver'> & { issuer: ResolversTypes['Actor'], receiver: ResolversTypes['Actor'] }>;
  PaymentRequestEvent: ResolverTypeWrapper<PaymentRequestEvent>;
  PhoneNumber: ResolverTypeWrapper<PhoneNumber>;
  PhoneNumberInput: PhoneNumberInput;
  PhoneNumberLog: ResolverTypeWrapper<PhoneNumberLog>;
  PhoneNumberLogs: ResolverTypeWrapper<PhoneNumberLogs>;
  PhoneNumberPaymentMethod: ResolverTypeWrapper<PhoneNumberPaymentMethod>;
  Pickup: ResolverTypeWrapper<Pickup>;
  PickupFilterInput: PickupFilterInput;
  PickupStatus: PickupStatus;
  Platform: Platform;
  Playback: ResolverTypeWrapper<Playback>;
  Product: ResolverTypeWrapper<Product>;
  ProductCategory: ResolverTypeWrapper<ProductCategory>;
  ProductCategoryInput: ProductCategoryInput;
  ProductCursor: ResolverTypeWrapper<ProductCursor>;
  ProductCursorInput: ProductCursorInput;
  ProductEdge: ResolverTypeWrapper<ProductEdge>;
  ProductFilterInput: ProductFilterInput;
  ProductInput: ProductInput;
  ProductList: ResolverTypeWrapper<ProductList>;
  ProductOption: ResolverTypeWrapper<ProductOption>;
  ProductOptionInput: ProductOptionInput;
  ProductSelectionInput: ProductSelectionInput;
  ProductSortOptionsInput: ProductSortOptionsInput;
  ProductVariant: ResolverTypeWrapper<ProductVariant>;
  ProductVariantInput: ProductVariantInput;
  PushNotificationTokenInput: PushNotificationTokenInput;
  ReactToDeliveryRequestInput: ReactToDeliveryRequestInput;
  RecentTransactionsInput: RecentTransactionsInput;
  Reel: ResolverTypeWrapper<Reel>;
  ReelEdge: ResolverTypeWrapper<ReelEdge>;
  ReelStatus: ReelStatus;
  ReelsCursor: ResolverTypeWrapper<ReelsCursor>;
  ReelsSelectionInput: ReelsSelectionInput;
  ReelsSortOptionsInput: ReelsSortOptionsInput;
  RefinitivCase: ResolverTypeWrapper<RefinitivCase>;
  RefinitivScreeningResult: ResolverTypeWrapper<RefinitivScreeningResult>;
  RefreshTokenInput: RefreshTokenInput;
  RefundTransaction: ResolverTypeWrapper<RefundTransaction>;
  RemoveProductFromWishlistInput: RemoveProductFromWishlistInput;
  RequestLoginCodeInput: RequestLoginCodeInput;
  RequestPaymentInput: RequestPaymentInput;
  RequestWalletActivationForMerchantInput: RequestWalletActivationForMerchantInput;
  RequestWalletActivationInput: RequestWalletActivationInput;
  RestrictProductInput: RestrictProductInput;
  Review: ResolverTypeWrapper<Review>;
  ReviewInput: ReviewInput;
  Role: Role;
  RootMutationType: ResolverTypeWrapper<{}>;
  RootQueryType: ResolverTypeWrapper<{}>;
  RootSubscriptionType: ResolverTypeWrapper<{}>;
  SaveBillInput: SaveBillInput;
  SavedBill: ResolverTypeWrapper<SavedBill>;
  SearchOrderInput: SearchOrderInput;
  SearchOrdersResult: ResolverTypeWrapper<SearchOrdersResult>;
  SearchQueryInput: SearchQueryInput;
  SearchReelsInput: SearchReelsInput;
  SearchResult: ResolverTypeWrapper<SearchResult>;
  SelectedOption: ResolverTypeWrapper<SelectedOption>;
  SelectedOptionInput: SelectedOptionInput;
  SendMessageInput: SendMessageInput;
  SendVerificationCodeInput: SendVerificationCodeInput;
  SetWalletPinInput: SetWalletPinInput;
  Settings: ResolverTypeWrapper<Settings>;
  SettingsInput: SettingsInput;
  SignupInput: SignupInput;
  SoleProprietorInput: SoleProprietorInput;
  SortByDirection: SortByDirection;
  String: ResolverTypeWrapper<Scalars['String']>;
  SystemNotification: ResolverTypeWrapper<SystemNotification>;
  Thumbnail: ResolverTypeWrapper<Thumbnail>;
  TimeInHm: ResolverTypeWrapper<Scalars['TimeInHm']>;
  TimeInterval: ResolverTypeWrapper<TimeInterval>;
  TimeIntervalInput: TimeIntervalInput;
  TimeSeriesConfigInput: TimeSeriesConfigInput;
  TimeSeriesInterval: ResolverTypeWrapper<TimeSeriesInterval>;
  TimeSeriesPeriod: TimeSeriesPeriod;
  Transaction: ResolversTypes['BillTransaction'] | ResolversTypes['LoadCreditTransaction'] | ResolversTypes['OrderBatchTransaction'] | ResolversTypes['RefundTransaction'] | ResolversTypes['TransferTransaction'] | ResolversTypes['WithdrawTransaction'];
  TransactionActivity: ResolverTypeWrapper<TransactionActivity>;
  TransactionActivityInput: TransactionActivityInput;
  TransactionChargeInput: TransactionChargeInput;
  TransactionError: ResolverTypeWrapper<TransactionError>;
  TransactionEvent: ResolverTypeWrapper<TransactionEvent>;
  TransactionSelectionInput: TransactionSelectionInput;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  TransactionUpdateInput: TransactionUpdateInput;
  TransactionsList: ResolverTypeWrapper<TransactionsList>;
  TransferCreditInput: TransferCreditInput;
  TransferTransaction: ResolverTypeWrapper<Omit<TransferTransaction, 'issuer' | 'receiver'> & { issuer: ResolversTypes['Actor'], receiver: ResolversTypes['Actor'] }>;
  UpdateChatMembersInput: UpdateChatMembersInput;
  UpdateReelInput: UpdateReelInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPasswordInput: UpdateUserPasswordInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  User: ResolverTypeWrapper<User>;
  UserIdentifier: UserIdentifier;
  UserRegistrationStatusInput: UserRegistrationStatusInput;
  ValidationError: ResolverTypeWrapper<ValidationError>;
  VehicleType: VehicleType;
  VerificationId: VerificationId;
  VerifyPhoneInput: VerifyPhoneInput;
  VerifyPinOrSignatureInput: VerifyPinOrSignatureInput;
  Wallet: ResolverTypeWrapper<Wallet>;
  WalletActivation: ResolverTypeWrapper<WalletActivation>;
  WalletActivationStatus: WalletActivationStatus;
  WalletHold: ResolverTypeWrapper<WalletHold>;
  Wishlist: ResolverTypeWrapper<Wishlist>;
  WithdrawInput: WithdrawInput;
  WithdrawTransaction: ResolverTypeWrapper<Omit<WithdrawTransaction, 'issuer'> & { issuer?: Maybe<ResolversTypes['Actor']> }>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AcceptPaymentRequestInput: AcceptPaymentRequestInput;
  Actor: ResolversUnionParentTypes['Actor'];
  AddProductToWishlistInput: AddProductToWishlistInput;
  Address: Address;
  AddressInput: AddressInput;
  Admin: Admin;
  Aml: Aml;
  Bill: Bill;
  BillTransaction: Omit<BillTransaction, 'issuer'> & { issuer?: Maybe<ResolversParentTypes['Actor']> };
  BillingInfoInput: BillingInfoInput;
  BiometricsTokenInput: BiometricsTokenInput;
  Boolean: Scalars['Boolean'];
  ByRegistrationNumber: ByRegistrationNumber;
  CategorizedMerchants: CategorizedMerchants;
  ChangeMerchantApprovalStateInput: ChangeMerchantApprovalStateInput;
  ChangeMerchantDocumentStatusInput: ChangeMerchantDocumentStatusInput;
  ChangeOrdersStatusInput: ChangeOrdersStatusInput;
  Chat: Omit<Chat, 'members'> & { members: Array<ResolversParentTypes['Actor']> };
  ChatEdge: ChatEdge;
  ChatsCursor: ChatsCursor;
  Courier: Courier;
  CourierCount: CourierCount;
  CourierCursor: CourierCursor;
  CourierCursorInput: CourierCursorInput;
  CourierEdge: CourierEdge;
  CourierLastLocationInput: CourierLastLocationInput;
  CourierSelectionInput: CourierSelectionInput;
  CourierUpdateInput: CourierUpdateInput;
  CourierWithDistance: CourierWithDistance;
  CouriersList: CouriersList;
  CouriersSearchResult: CouriersSearchResult;
  CreateInviteInput: CreateInviteInput;
  CreateMerchantDocumentInput: CreateMerchantDocumentInput;
  CreateReelInput: CreateReelInput;
  CreateWishlistInput: CreateWishlistInput;
  CreditCardInput: CreditCardInput;
  CreditCardPaymentMethod: CreditCardPaymentMethod;
  CursorInput: CursorInput;
  Customer: Customer;
  CustomerCount: CustomerCount;
  CustomerCursor: CustomerCursor;
  CustomerCursorInput: CustomerCursorInput;
  CustomerEdge: CustomerEdge;
  CustomerSelectionInput: CustomerSelectionInput;
  CustomerUpdateInput: CustomerUpdateInput;
  CustomersList: CustomersList;
  CustomersSearchResult: CustomersSearchResult;
  CybersourceDepositInput: CybersourceDepositInput;
  CybersourceDeviceCollectionJwt: CybersourceDeviceCollectionJwt;
  CybersourceJwt: ResolversParentTypes['CybersourceDeviceCollectionJwt'] | ResolversParentTypes['CybersourceStepupJwt'];
  CybersourceStepupJwt: CybersourceStepupJwt;
  DailySpend: DailySpend;
  DateInterval: DateInterval;
  DateTime: Scalars['DateTime'];
  DeliveriesList: DeliveriesList;
  DeliveriesSearchResult: DeliveriesSearchResult;
  Delivery: Delivery;
  DeliveryActivity: DeliveryActivity;
  DeliveryActivityInput: DeliveryActivityInput;
  DeliveryFilterInput: DeliveryFilterInput;
  DeliveryRequest: DeliveryRequest;
  DeliveryRequestInput: DeliveryRequestInput;
  DeliverySelectionInput: DeliverySelectionInput;
  DeliveryStatusUpdate: DeliveryStatusUpdate;
  DepositInput: DepositInput;
  DistanceFilterInput: DistanceFilterInput;
  EarningsAmount: EarningsAmount;
  EarningsAmountInput: EarningsAmountInput;
  Error: ResolversParentTypes['TransactionError'] | ResolversParentTypes['ValidationError'];
  Event: ResolversParentTypes['DeliveryStatusUpdate'] | ResolversParentTypes['PaymentRequestEvent'] | ResolversParentTypes['SystemNotification'] | ResolversParentTypes['TransactionEvent'];
  EventsInput: EventsInput;
  EventsList: EventsList;
  ExternalAccount: ExternalAccount;
  ExternalAccountInput: ExternalAccountInput;
  FetchBillInput: FetchBillInput;
  Float: Scalars['Float'];
  FreeMoneyDevPaymentMethod: FreeMoneyDevPaymentMethod;
  GeoCoordinates: GeoCoordinates;
  GeoCoordinatesInput: GeoCoordinatesInput;
  HighestEver: HighestEver;
  ID: Scalars['ID'];
  IdentificationNumberLog: IdentificationNumberLog;
  IdentificationNumberLogs: IdentificationNumberLogs;
  Image: Image;
  IndividualInput: IndividualInput;
  InformaKyb: InformaKyb;
  InformaKybInput: InformaKybInput;
  Int: Scalars['Int'];
  InterswitchBank: InterswitchBank;
  InterswitchBankAccountInput: InterswitchBankAccountInput;
  InterswitchBankAccountPaymentMethod: InterswitchBankAccountPaymentMethod;
  Invitation: Invitation;
  KycVerificationLog: ResolversParentTypes['IdentificationNumberLog'] | ResolversParentTypes['LivenessLog'] | ResolversParentTypes['PhoneNumberLog'];
  KycVerificationStatus: KycVerificationStatus;
  KycVerificationStatusInput: KycVerificationStatusInput;
  KycVerificationStatusUpdateInput: KycVerificationStatusUpdateInput;
  LimitedCompanyInput: LimitedCompanyInput;
  LivenessLog: LivenessLog;
  LivenessLogs: LivenessLogs;
  LoadCreditTransaction: Omit<LoadCreditTransaction, 'receiver'> & { receiver?: Maybe<ResolversParentTypes['Actor']> };
  LoadWalletInput: LoadWalletInput;
  Location: Location;
  Login: Omit<Login, 'user'> & { user?: Maybe<ResolversParentTypes['Actor']> };
  LoginInput: LoginInput;
  LoginWithCodeInput: LoginWithCodeInput;
  LoginWithProviderInput: LoginWithProviderInput;
  LogoutInput: LogoutInput;
  Media: Media;
  MemberStatistics: MemberStatistics;
  Merchant: Merchant;
  MerchantCategory: MerchantCategory;
  MerchantCategoryInput: MerchantCategoryInput;
  MerchantCount: MerchantCount;
  MerchantCursor: MerchantCursor;
  MerchantCursorInput: MerchantCursorInput;
  MerchantDocument: MerchantDocument;
  MerchantDocumentsInput: MerchantDocumentsInput;
  MerchantEdge: MerchantEdge;
  MerchantFilterInput: MerchantFilterInput;
  MerchantOnboardingInput: MerchantOnboardingInput;
  MerchantSelectionInput: MerchantSelectionInput;
  MerchantTypeInput: MerchantTypeInput;
  MerchantUpdateInput: MerchantUpdateInput;
  MerchantWithDistance: MerchantWithDistance;
  MerchantsList: MerchantsList;
  MerchantsSearchResult: MerchantsSearchResult;
  Message: Omit<Message, 'author'> & { author: ResolversParentTypes['Actor'] };
  MessageEdge: MessageEdge;
  MessagesCursor: MessagesCursor;
  Money: Money;
  MoneyInput: MoneyInput;
  NewMessage: NewMessage;
  NotificationChannel: NotificationChannel;
  NotificationChannelInput: NotificationChannelInput;
  NotificationSettings: NotificationSettings;
  NotificationSettingsInput: NotificationSettingsInput;
  OperatingTime: OperatingTime;
  OperatingTimeInput: OperatingTimeInput;
  Order: Order;
  OrderBatch: OrderBatch;
  OrderBatchCursor: OrderBatchCursor;
  OrderBatchEdge: OrderBatchEdge;
  OrderBatchTransaction: OrderBatchTransaction;
  OrderBatchesInput: OrderBatchesInput;
  OrderFilterInput: OrderFilterInput;
  OrderInput: OrderInput;
  OrderListItem: OrderListItem;
  OrderListItemInput: OrderListItemInput;
  OrderTracking: OrderTracking;
  OwnProductsSearchResult: OwnProductsSearchResult;
  PageInfo: PageInfo;
  Partner: Partner;
  PartnershipInput: PartnershipInput;
  PayBillInput: PayBillInput;
  PaymentMethod: ResolversParentTypes['CreditCardPaymentMethod'] | ResolversParentTypes['FreeMoneyDevPaymentMethod'] | ResolversParentTypes['InterswitchBankAccountPaymentMethod'] | ResolversParentTypes['PhoneNumberPaymentMethod'];
  PaymentMethodInput: PaymentMethodInput;
  PaymentRequest: Omit<PaymentRequest, 'issuer' | 'receiver'> & { issuer: ResolversParentTypes['Actor'], receiver: ResolversParentTypes['Actor'] };
  PaymentRequestEvent: PaymentRequestEvent;
  PhoneNumber: PhoneNumber;
  PhoneNumberInput: PhoneNumberInput;
  PhoneNumberLog: PhoneNumberLog;
  PhoneNumberLogs: PhoneNumberLogs;
  PhoneNumberPaymentMethod: PhoneNumberPaymentMethod;
  Pickup: Pickup;
  PickupFilterInput: PickupFilterInput;
  Playback: Playback;
  Product: Product;
  ProductCategory: ProductCategory;
  ProductCategoryInput: ProductCategoryInput;
  ProductCursor: ProductCursor;
  ProductCursorInput: ProductCursorInput;
  ProductEdge: ProductEdge;
  ProductFilterInput: ProductFilterInput;
  ProductInput: ProductInput;
  ProductList: ProductList;
  ProductOption: ProductOption;
  ProductOptionInput: ProductOptionInput;
  ProductSelectionInput: ProductSelectionInput;
  ProductSortOptionsInput: ProductSortOptionsInput;
  ProductVariant: ProductVariant;
  ProductVariantInput: ProductVariantInput;
  PushNotificationTokenInput: PushNotificationTokenInput;
  ReactToDeliveryRequestInput: ReactToDeliveryRequestInput;
  RecentTransactionsInput: RecentTransactionsInput;
  Reel: Reel;
  ReelEdge: ReelEdge;
  ReelsCursor: ReelsCursor;
  ReelsSelectionInput: ReelsSelectionInput;
  ReelsSortOptionsInput: ReelsSortOptionsInput;
  RefinitivCase: RefinitivCase;
  RefinitivScreeningResult: RefinitivScreeningResult;
  RefreshTokenInput: RefreshTokenInput;
  RefundTransaction: RefundTransaction;
  RemoveProductFromWishlistInput: RemoveProductFromWishlistInput;
  RequestLoginCodeInput: RequestLoginCodeInput;
  RequestPaymentInput: RequestPaymentInput;
  RequestWalletActivationForMerchantInput: RequestWalletActivationForMerchantInput;
  RequestWalletActivationInput: RequestWalletActivationInput;
  RestrictProductInput: RestrictProductInput;
  Review: Review;
  ReviewInput: ReviewInput;
  RootMutationType: {};
  RootQueryType: {};
  RootSubscriptionType: {};
  SaveBillInput: SaveBillInput;
  SavedBill: SavedBill;
  SearchOrderInput: SearchOrderInput;
  SearchOrdersResult: SearchOrdersResult;
  SearchQueryInput: SearchQueryInput;
  SearchReelsInput: SearchReelsInput;
  SearchResult: SearchResult;
  SelectedOption: SelectedOption;
  SelectedOptionInput: SelectedOptionInput;
  SendMessageInput: SendMessageInput;
  SendVerificationCodeInput: SendVerificationCodeInput;
  SetWalletPinInput: SetWalletPinInput;
  Settings: Settings;
  SettingsInput: SettingsInput;
  SignupInput: SignupInput;
  SoleProprietorInput: SoleProprietorInput;
  String: Scalars['String'];
  SystemNotification: SystemNotification;
  Thumbnail: Thumbnail;
  TimeInHm: Scalars['TimeInHm'];
  TimeInterval: TimeInterval;
  TimeIntervalInput: TimeIntervalInput;
  TimeSeriesConfigInput: TimeSeriesConfigInput;
  TimeSeriesInterval: TimeSeriesInterval;
  Transaction: ResolversParentTypes['BillTransaction'] | ResolversParentTypes['LoadCreditTransaction'] | ResolversParentTypes['OrderBatchTransaction'] | ResolversParentTypes['RefundTransaction'] | ResolversParentTypes['TransferTransaction'] | ResolversParentTypes['WithdrawTransaction'];
  TransactionActivity: TransactionActivity;
  TransactionActivityInput: TransactionActivityInput;
  TransactionChargeInput: TransactionChargeInput;
  TransactionError: TransactionError;
  TransactionEvent: TransactionEvent;
  TransactionSelectionInput: TransactionSelectionInput;
  TransactionUpdateInput: TransactionUpdateInput;
  TransactionsList: TransactionsList;
  TransferCreditInput: TransferCreditInput;
  TransferTransaction: Omit<TransferTransaction, 'issuer' | 'receiver'> & { issuer: ResolversParentTypes['Actor'], receiver: ResolversParentTypes['Actor'] };
  UpdateChatMembersInput: UpdateChatMembersInput;
  UpdateReelInput: UpdateReelInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPasswordInput: UpdateUserPasswordInput;
  Upload: Scalars['Upload'];
  User: User;
  UserIdentifier: UserIdentifier;
  UserRegistrationStatusInput: UserRegistrationStatusInput;
  ValidationError: ValidationError;
  VerifyPhoneInput: VerifyPhoneInput;
  VerifyPinOrSignatureInput: VerifyPinOrSignatureInput;
  Wallet: Wallet;
  WalletActivation: WalletActivation;
  WalletHold: WalletHold;
  Wishlist: Wishlist;
  WithdrawInput: WithdrawInput;
  WithdrawTransaction: Omit<WithdrawTransaction, 'issuer'> & { issuer?: Maybe<ResolversParentTypes['Actor']> };
}>;

export type ActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Actor'] = ResolversParentTypes['Actor']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Admin' | 'Courier' | 'Customer' | 'Merchant', ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  estateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  pickup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  remark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['Admin'] = ResolversParentTypes['Admin']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmlResolvers<ContextType = any, ParentType extends ResolversParentTypes['Aml'] = ResolversParentTypes['Aml']> = ResolversObject<{
  refinitivCase?: Resolver<ResolversTypes['RefinitivCase'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BillResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bill'] = ResolversParentTypes['Bill']> = ResolversObject<{
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BillTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillTransaction'] = ResolversParentTypes['BillTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  biller?: Resolver<ResolversTypes['Biller'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CategorizedMerchantsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategorizedMerchants'] = ResolversParentTypes['CategorizedMerchants']> = ResolversObject<{
  category?: Resolver<ResolversTypes['MerchantCategory'], ParentType, ContextType>;
  merchants?: Resolver<Maybe<Array<ResolversTypes['Merchant']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chat'] = ResolversParentTypes['Chat']> = ResolversObject<{
  chatType?: Resolver<ResolversTypes['ChatType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Actor']>, ParentType, ContextType>;
  unreadMessagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatEdge'] = ResolversParentTypes['ChatEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatsCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatsCursor'] = ResolversParentTypes['ChatsCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['ChatEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CourierResolvers<ContextType = any, ParentType extends ResolversParentTypes['Courier'] = ResolversParentTypes['Courier']> = ResolversObject<{
  addresses?: Resolver<Maybe<Array<ResolversTypes['Address']>>, ParentType, ContextType>;
  agreedToTerms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  assignedDeliveries?: Resolver<Maybe<Array<ResolversTypes['Delivery']>>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  courierType?: Resolver<Maybe<ResolversTypes['CourierType']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currentDelivery?: Resolver<Maybe<ResolversTypes['Delivery']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['GeoCoordinates']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  licensePlate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  online?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  onlineStatusChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  requireBiometrics?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  vehicleType?: Resolver<Maybe<ResolversTypes['VehicleType']>, ParentType, ContextType>;
  wallet?: Resolver<Maybe<ResolversTypes['Wallet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CourierCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourierCount'] = ResolversParentTypes['CourierCount']> = ResolversObject<{
  all?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  drivers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  riders?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CourierCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourierCursor'] = ResolversParentTypes['CourierCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['CourierEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CourierEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourierEdge'] = ResolversParentTypes['CourierEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Courier'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CourierWithDistanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourierWithDistance'] = ResolversParentTypes['CourierWithDistance']> = ResolversObject<{
  courier?: Resolver<ResolversTypes['Courier'], ParentType, ContextType>;
  distanceToPickUpInMeters?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CouriersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouriersList'] = ResolversParentTypes['CouriersList']> = ResolversObject<{
  couriers?: Resolver<Array<ResolversTypes['Courier']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CouriersSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouriersSearchResult'] = ResolversParentTypes['CouriersSearchResult']> = ResolversObject<{
  couriers?: Resolver<Array<ResolversTypes['Courier']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreditCardPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditCardPaymentMethod'] = ResolversParentTypes['CreditCardPaymentMethod']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  last4Digits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['PaymentProvider']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = ResolversObject<{
  addresses?: Resolver<Maybe<Array<ResolversTypes['Address']>>, ParentType, ContextType>;
  agreedToTerms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currentAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  requireBiometrics?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['Settings'], ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  wallet?: Resolver<Maybe<ResolversTypes['Wallet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerCount'] = ResolversParentTypes['CustomerCount']> = ResolversObject<{
  all?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inProgress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerCursor'] = ResolversParentTypes['CustomerCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['CustomerEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerEdge'] = ResolversParentTypes['CustomerEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomersList'] = ResolversParentTypes['CustomersList']> = ResolversObject<{
  customers?: Resolver<Array<ResolversTypes['Customer']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomersSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomersSearchResult'] = ResolversParentTypes['CustomersSearchResult']> = ResolversObject<{
  customers?: Resolver<Array<ResolversTypes['Customer']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CybersourceDeviceCollectionJwtResolvers<ContextType = any, ParentType extends ResolversParentTypes['CybersourceDeviceCollectionJwt'] = ResolversParentTypes['CybersourceDeviceCollectionJwt']> = ResolversObject<{
  jwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ref?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CybersourceJwtResolvers<ContextType = any, ParentType extends ResolversParentTypes['CybersourceJwt'] = ResolversParentTypes['CybersourceJwt']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CybersourceDeviceCollectionJwt' | 'CybersourceStepupJwt', ParentType, ContextType>;
  jwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ref?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type CybersourceStepupJwtResolvers<ContextType = any, ParentType extends ResolversParentTypes['CybersourceStepupJwt'] = ResolversParentTypes['CybersourceStepupJwt']> = ResolversObject<{
  jwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  md?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ref?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DailySpendResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailySpend'] = ResolversParentTypes['DailySpend']> = ResolversObject<{
  highestEver?: Resolver<ResolversTypes['HighestEver'], ParentType, ContextType>;
  spentToday?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeliveriesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveriesList'] = ResolversParentTypes['DeliveriesList']> = ResolversObject<{
  deliveries?: Resolver<Array<ResolversTypes['Delivery']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveriesSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveriesSearchResult'] = ResolversParentTypes['DeliveriesSearchResult']> = ResolversObject<{
  deliveries?: Resolver<Array<ResolversTypes['Delivery']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Delivery'] = ResolversParentTypes['Delivery']> = ResolversObject<{
  courier?: Resolver<Maybe<ResolversTypes['Courier']>, ParentType, ContextType>;
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  dropOff?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderBatch?: Resolver<ResolversTypes['OrderBatch'], ParentType, ContextType>;
  pickUp?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DeliveryStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveryActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryActivity'] = ResolversParentTypes['DeliveryActivity']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeSeriesInterval?: Resolver<ResolversTypes['TimeSeriesInterval'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveryRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryRequest'] = ResolversParentTypes['DeliveryRequest']> = ResolversObject<{
  admin?: Resolver<ResolversTypes['Admin'], ParentType, ContextType>;
  availableUntil?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  courier?: Resolver<ResolversTypes['Courier'], ParentType, ContextType>;
  delivery?: Resolver<ResolversTypes['Delivery'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveryStatusUpdateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryStatusUpdate'] = ResolversParentTypes['DeliveryStatusUpdate']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderBatch?: Resolver<ResolversTypes['OrderBatch'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EarningsAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarningsAmount'] = ResolversParentTypes['EarningsAmount']> = ResolversObject<{
  failed?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error']> = ResolversObject<{
  __resolveType: TypeResolveFn<'TransactionError' | 'ValidationError', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ErrorTypes'], ParentType, ContextType>;
}>;

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DeliveryStatusUpdate' | 'PaymentRequestEvent' | 'SystemNotification' | 'TransactionEvent', ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
}>;

export type EventsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventsList'] = ResolversParentTypes['EventsList']> = ResolversObject<{
  events?: Resolver<Array<ResolversTypes['Event']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExternalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccount'] = ResolversParentTypes['ExternalAccount']> = ResolversObject<{
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FreeMoneyDevPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeMoneyDevPaymentMethod'] = ResolversParentTypes['FreeMoneyDevPaymentMethod']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoCoordinatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeoCoordinates'] = ResolversParentTypes['GeoCoordinates']> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  long?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HighestEverResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighestEver'] = ResolversParentTypes['HighestEver']> = ResolversObject<{
  totalAmount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentificationNumberLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentificationNumberLog'] = ResolversParentTypes['IdentificationNumberLog']> = ResolversObject<{
  citizenship?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentificationNumberLogsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentificationNumberLogs'] = ResolversParentTypes['IdentificationNumberLogs']> = ResolversObject<{
  logs?: Resolver<Array<Maybe<ResolversTypes['IdentificationNumberLog']>>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InformaKybResolvers<ContextType = any, ParentType extends ResolversParentTypes['InformaKyb'] = ResolversParentTypes['InformaKyb']> = ResolversObject<{
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  informaStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kraPin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partners?: Resolver<Maybe<Array<Maybe<ResolversTypes['Partner']>>>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  physicalAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InterswitchBankResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterswitchBank'] = ResolversParentTypes['InterswitchBank']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InterswitchBankAccountPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterswitchBankAccountPaymentMethod'] = ResolversParentTypes['InterswitchBankAccountPaymentMethod']> = ResolversObject<{
  bankAccountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interswitchBank?: Resolver<Maybe<ResolversTypes['InterswitchBank']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invitation'] = ResolversParentTypes['Invitation']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type KycVerificationLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycVerificationLog'] = ResolversParentTypes['KycVerificationLog']> = ResolversObject<{
  __resolveType: TypeResolveFn<'IdentificationNumberLog' | 'LivenessLog' | 'PhoneNumberLog', ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type KycVerificationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycVerificationStatus'] = ResolversParentTypes['KycVerificationStatus']> = ResolversObject<{
  aml?: Resolver<Maybe<ResolversTypes['Aml']>, ParentType, ContextType>;
  identificationNumberLogs?: Resolver<Maybe<ResolversTypes['IdentificationNumberLogs']>, ParentType, ContextType>;
  livenessLogs?: Resolver<Maybe<ResolversTypes['LivenessLogs']>, ParentType, ContextType>;
  matchScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phoneNumberLogs?: Resolver<Maybe<ResolversTypes['PhoneNumberLogs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LivenessLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['LivenessLog'] = ResolversParentTypes['LivenessLog']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LivenessLogsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LivenessLogs'] = ResolversParentTypes['LivenessLogs']> = ResolversObject<{
  logs?: Resolver<Array<Maybe<ResolversTypes['LivenessLog']>>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoadCreditTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoadCreditTransaction'] = ResolversParentTypes['LoadCreditTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  receiver?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  coordinates?: Resolver<ResolversTypes['GeoCoordinates'], ParentType, ContextType>;
  formattedAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResolvers<ContextType = any, ParentType extends ResolversParentTypes['Login'] = ResolversParentTypes['Login']> = ResolversObject<{
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = ResolversObject<{
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MemberStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberStatistics'] = ResolversParentTypes['MemberStatistics']> = ResolversObject<{
  courierCount?: Resolver<ResolversTypes['CourierCount'], ParentType, ContextType>;
  customerCount?: Resolver<ResolversTypes['CustomerCount'], ParentType, ContextType>;
  merchantCount?: Resolver<ResolversTypes['MerchantCount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Merchant'] = ResolversParentTypes['Merchant']> = ResolversObject<{
  addresses?: Resolver<Maybe<Array<ResolversTypes['Address']>>, ParentType, ContextType>;
  agreedToTerms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowPayingDirectly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  applicantsName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvalMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvalState?: Resolver<Maybe<ResolversTypes['ApprovalState']>, ParentType, ContextType>;
  coverImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  favorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idType?: Resolver<Maybe<ResolversTypes['VerificationId']>, ParentType, ContextType>;
  informaKyb?: Resolver<Maybe<ResolversTypes['InformaKyb']>, ParentType, ContextType, Partial<MerchantInformaKybArgs>>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  merchantCategories?: Resolver<Maybe<Array<ResolversTypes['MerchantCategory']>>, ParentType, ContextType>;
  merchantDocuments?: Resolver<Maybe<Array<ResolversTypes['MerchantDocument']>>, ParentType, ContextType>;
  merchantType?: Resolver<Maybe<ResolversTypes['MerchantType']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatingTime?: Resolver<Maybe<ResolversTypes['OperatingTime']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  productCategories?: Resolver<Maybe<Array<ResolversTypes['ProductCategory']>>, ParentType, ContextType>;
  products?: Resolver<ResolversTypes['ProductList'], ParentType, ContextType, Partial<MerchantProductsArgs>>;
  rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reviews?: Resolver<Maybe<Array<Maybe<ResolversTypes['Review']>>>, ParentType, ContextType>;
  selection?: Resolver<Maybe<Array<ResolversTypes['MerchantSelection']>>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['Settings'], ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTutorial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  wallet?: Resolver<Maybe<ResolversTypes['Wallet']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCategory'] = ResolversParentTypes['MerchantCategory']> = ResolversObject<{
  children?: Resolver<Maybe<Array<ResolversTypes['MerchantCategory']>>, ParentType, ContextType, Partial<MerchantCategoryChildrenArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['MerchantCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCount'] = ResolversParentTypes['MerchantCount']> = ResolversObject<{
  all?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  approved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCursor'] = ResolversParentTypes['MerchantCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['MerchantEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantDocument'] = ResolversParentTypes['MerchantDocument']> = ResolversObject<{
  documentType?: Resolver<Maybe<ResolversTypes['DocumentType']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  mediaId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DocumentStatus']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantEdge'] = ResolversParentTypes['MerchantEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Merchant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantWithDistanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantWithDistance'] = ResolversParentTypes['MerchantWithDistance']> = ResolversObject<{
  distanceInMeters?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  merchant?: Resolver<ResolversTypes['Merchant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantsList'] = ResolversParentTypes['MerchantsList']> = ResolversObject<{
  merchants?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantsSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantsSearchResult'] = ResolversParentTypes['MerchantsSearchResult']> = ResolversObject<{
  merchants?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = ResolversObject<{
  author?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  edited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEdge'] = ResolversParentTypes['MessageEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessagesCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagesCursor'] = ResolversParentTypes['MessagesCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['MessageEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = ResolversObject<{
  amountInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NewMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewMessage'] = ResolversParentTypes['NewMessage']> = ResolversObject<{
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationChannel'] = ResolversParentTypes['NotificationChannel']> = ResolversObject<{
  email?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneCall?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pushNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  textMessage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationSettings'] = ResolversParentTypes['NotificationSettings']> = ResolversObject<{
  account?: Resolver<ResolversTypes['NotificationChannel'], ParentType, ContextType>;
  general?: Resolver<ResolversTypes['NotificationChannel'], ParentType, ContextType>;
  promotionalMessages?: Resolver<ResolversTypes['NotificationChannel'], ParentType, ContextType>;
  reminders?: Resolver<ResolversTypes['NotificationChannel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OperatingTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperatingTime'] = ResolversParentTypes['OperatingTime']> = ResolversObject<{
  fr?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  mo?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  sa?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  su?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  th?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  tu?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  we?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeInterval']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = ResolversObject<{
  batches?: Resolver<Array<ResolversTypes['OrderBatch']>, ParentType, ContextType>;
  buyer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deliveryDeadline?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fulfillment?: Resolver<ResolversTypes['OrderFulfillment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderBatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBatch'] = ResolversParentTypes['OrderBatch']> = ResolversObject<{
  buyer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['Delivery']>, ParentType, ContextType>;
  deliveryDeadline?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fulfillment?: Resolver<ResolversTypes['OrderFulfillment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderListItem']>, ParentType, ContextType>;
  merchant?: Resolver<ResolversTypes['Merchant'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['OrderBatchTransaction']>, ParentType, ContextType>;
  pickup?: Resolver<Maybe<ResolversTypes['Pickup']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderStatus'], ParentType, ContextType>;
  totalCost?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  tracking?: Resolver<Array<ResolversTypes['OrderTracking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderBatchCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBatchCursor'] = ResolversParentTypes['OrderBatchCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['OrderBatchEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderBatchEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBatchEdge'] = ResolversParentTypes['OrderBatchEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OrderBatch'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderBatchTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBatchTransaction'] = ResolversParentTypes['OrderBatchTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderBatch?: Resolver<ResolversTypes['OrderBatch'], ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderListItem'] = ResolversParentTypes['OrderListItem']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['ProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderTracking'] = ResolversParentTypes['OrderTracking']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['DeliveryStatus']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OwnProductsSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OwnProductsSearchResult'] = ResolversParentTypes['OwnProductsSearchResult']> = ResolversObject<{
  products?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  entries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPrevPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startCursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Partner'] = ResolversParentTypes['Partner']> = ResolversObject<{
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethod'] = ResolversParentTypes['PaymentMethod']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CreditCardPaymentMethod' | 'FreeMoneyDevPaymentMethod' | 'InterswitchBankAccountPaymentMethod' | 'PhoneNumberPaymentMethod', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type PaymentRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentRequest'] = ResolversParentTypes['PaymentRequest']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuer?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  remark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revoked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentRequestEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentRequestEvent'] = ResolversParentTypes['PaymentRequestEvent']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentRequest?: Resolver<ResolversTypes['PaymentRequest'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumber'] = ResolversParentTypes['PhoneNumber']> = ResolversObject<{
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneNumberLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberLog'] = ResolversParentTypes['PhoneNumberLog']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  personSearchType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneNumberLogsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberLogs'] = ResolversParentTypes['PhoneNumberLogs']> = ResolversObject<{
  logs?: Resolver<Array<Maybe<ResolversTypes['PhoneNumberLog']>>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneNumberPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberPaymentMethod'] = ResolversParentTypes['PhoneNumberPaymentMethod']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PickupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pickup'] = ResolversParentTypes['Pickup']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PickupStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaybackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Playback'] = ResolversParentTypes['Playback']> = ResolversObject<{
  dash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hls?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  categories?: Resolver<Array<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fulfillment?: Resolver<Maybe<ResolversTypes['Fulfillment']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['Image']>>>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductOption']>>>, ParentType, ContextType>;
  restricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variants?: Resolver<Maybe<Array<ResolversTypes['ProductVariant']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategory'] = ResolversParentTypes['ProductCategory']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  children?: Resolver<Maybe<Array<ResolversTypes['ProductCategory']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['ProductList']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCursor'] = ResolversParentTypes['ProductCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['ProductEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductEdge'] = ResolversParentTypes['ProductEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductList'] = ResolversParentTypes['ProductList']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['Product']>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductOption'] = ResolversParentTypes['ProductOption']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductVariantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariant'] = ResolversParentTypes['ProductVariant']> = ResolversObject<{
  default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<ResolversTypes['Image']>>, ParentType, ContextType>;
  option?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedOption']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reel'] = ResolversParentTypes['Reel']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  likes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['Playback'], ParentType, ContextType>;
  merchant?: Resolver<ResolversTypes['Merchant'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReelStatus'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['Thumbnail'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReelEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReelEdge'] = ResolversParentTypes['ReelEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Reel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReelsCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReelsCursor'] = ResolversParentTypes['ReelsCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['ReelEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefinitivCaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefinitivCase'] = ResolversParentTypes['RefinitivCase']> = ResolversObject<{
  caseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  caseSystemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['RefinitivScreeningResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefinitivScreeningResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefinitivScreeningResult'] = ResolversParentTypes['RefinitivScreeningResult']> = ResolversObject<{
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  matchScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nationality?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  resultId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  riskCategories?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefundTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundTransaction'] = ResolversParentTypes['RefundTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderBatch?: Resolver<ResolversTypes['OrderBatch'], ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['Review'] = ResolversParentTypes['Review']> = ResolversObject<{
  author?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RootMutationTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootMutationType'] = ResolversParentTypes['RootMutationType']> = ResolversObject<{
  acceptPaymentRequest?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<RootMutationTypeAcceptPaymentRequestArgs, 'input'>>;
  addOrUpdateAddresses?: Resolver<Array<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<RootMutationTypeAddOrUpdateAddressesArgs, 'input'>>;
  addOrUpdateBiometricsToken?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeAddOrUpdateBiometricsTokenArgs, 'input'>>;
  addOrUpdateMerchantCategory?: Resolver<ResolversTypes['MerchantCategory'], ParentType, ContextType, Partial<RootMutationTypeAddOrUpdateMerchantCategoryArgs>>;
  addOrUpdateProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, Partial<RootMutationTypeAddOrUpdateProductArgs>>;
  addOrUpdateProductCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType, Partial<RootMutationTypeAddOrUpdateProductCategoryArgs>>;
  addOrUpdatePushNotificationToken?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeAddOrUpdatePushNotificationTokenArgs, 'input'>>;
  addPaymentMethod?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType, RequireFields<RootMutationTypeAddPaymentMethodArgs, 'input'>>;
  addProductToWishlist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeAddProductToWishlistArgs, 'input'>>;
  addReview?: Resolver<Maybe<ResolversTypes['Review']>, ParentType, ContextType, RequireFields<RootMutationTypeAddReviewArgs, 'input'>>;
  changeCustomerWalletState?: Resolver<Maybe<ResolversTypes['WalletActivation']>, ParentType, ContextType, RequireFields<RootMutationTypeChangeCustomerWalletStateArgs, 'reason'>>;
  changeMerchantApprovalState?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType, Partial<RootMutationTypeChangeMerchantApprovalStateArgs>>;
  changeMerchantDocumentStatus?: Resolver<ResolversTypes['MerchantDocument'], ParentType, ContextType, RequireFields<RootMutationTypeChangeMerchantDocumentStatusArgs, 'input'>>;
  changeMultipleMerchantsApprovalState?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootMutationTypeChangeMultipleMerchantsApprovalStateArgs, 'ids'>>;
  changeOrdersStatus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeChangeOrdersStatusArgs, 'input'>>;
  checkCardEnrollment?: Resolver<ResolversTypes['CybersourceStepupJwt'], ParentType, ContextType, RequireFields<RootMutationTypeCheckCardEnrollmentArgs, 'ref'>>;
  createChat?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<RootMutationTypeCreateChatArgs, 'memberIds'>>;
  createInvite?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootMutationTypeCreateInviteArgs, 'input'>>;
  createMerchantDocument?: Resolver<ResolversTypes['MerchantDocument'], ParentType, ContextType, RequireFields<RootMutationTypeCreateMerchantDocumentArgs, 'input'>>;
  createOrder?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType, RequireFields<RootMutationTypeCreateOrderArgs, 'input'>>;
  createReel?: Resolver<ResolversTypes['Reel'], ParentType, ContextType, RequireFields<RootMutationTypeCreateReelArgs, 'input'>>;
  createWishlist?: Resolver<Maybe<ResolversTypes['Wishlist']>, ParentType, ContextType, RequireFields<RootMutationTypeCreateWishlistArgs, 'input'>>;
  deleteMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteMessageArgs, 'messageId'>>;
  deleteReel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteReelArgs, 'id'>>;
  deleteWishlist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeDeleteWishlistArgs, 'id'>>;
  deposit?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, Partial<RootMutationTypeDepositArgs>>;
  depositWithCybersource?: Resolver<ResolversTypes['CybersourceDeviceCollectionJwt'], ParentType, ContextType, RequireFields<RootMutationTypeDepositWithCybersourceArgs, 'input'>>;
  editMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<RootMutationTypeEditMessageArgs, 'messageId' | 'text'>>;
  favoriteMerchant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeFavoriteMerchantArgs, 'favorite' | 'merchantId'>>;
  inviteCouriers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeInviteCouriersArgs, 'emails'>>;
  loadWallet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeLoadWalletArgs, 'input' | 'userId'>>;
  lockUsers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeLockUsersArgs, 'ids' | 'locked'>>;
  login?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginArgs>>;
  loginWithCode?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginWithCodeArgs>>;
  loginWithCodeForCourier?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginWithCodeForCourierArgs>>;
  loginWithCodeForMerchant?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginWithCodeForMerchantArgs>>;
  loginWithProvider?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginWithProviderArgs>>;
  logout?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<RootMutationTypeLogoutArgs>>;
  merchantLoginWithProvider?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeMerchantLoginWithProviderArgs>>;
  merchantOnboarding?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootMutationTypeMerchantOnboardingArgs, 'input'>>;
  merchantSignup?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType, Partial<RootMutationTypeMerchantSignupArgs>>;
  payBill?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<RootMutationTypePayBillArgs, 'input'>>;
  reactToDeliveryRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeReactToDeliveryRequestArgs, 'input'>>;
  readMessages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<RootMutationTypeReadMessagesArgs, 'messageIds'>>;
  refreshToken?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeRefreshTokenArgs>>;
  removeAddresses?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveAddressesArgs, 'ids'>>;
  removeMerchantCategory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeRemoveMerchantCategoryArgs, 'id'>>;
  removePaymentMethod?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemovePaymentMethodArgs, 'id'>>;
  removeProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveProductArgs, 'id'>>;
  removeProductCategory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveProductCategoryArgs, 'id'>>;
  removeProductFromWishlist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveProductFromWishlistArgs, 'input'>>;
  removeReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveReviewArgs, 'id'>>;
  requestLoginCode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<RootMutationTypeRequestLoginCodeArgs>>;
  requestLoginCodeForCourier?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<RootMutationTypeRequestLoginCodeForCourierArgs>>;
  requestLoginCodeForMerchant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<RootMutationTypeRequestLoginCodeForMerchantArgs>>;
  requestOtpForWithdraw?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestPayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRequestPaymentArgs, 'input'>>;
  requestWalletActivation?: Resolver<Maybe<ResolversTypes['WalletActivation']>, ParentType, ContextType, RequireFields<RootMutationTypeRequestWalletActivationArgs, 'input'>>;
  requestWalletActivationForMerchant?: Resolver<Maybe<ResolversTypes['WalletActivation']>, ParentType, ContextType, RequireFields<RootMutationTypeRequestWalletActivationForMerchantArgs, 'input'>>;
  restrictProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, Partial<RootMutationTypeRestrictProductArgs>>;
  revokeRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeRevokeRequestArgs, 'id'>>;
  saveBill?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeSaveBillArgs, 'input'>>;
  sendDeliveryRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeSendDeliveryRequestArgs, 'input'>>;
  sendMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<RootMutationTypeSendMessageArgs, 'input'>>;
  sendVerificationCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<RootMutationTypeSendVerificationCodeArgs>>;
  setWalletPin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeSetWalletPinArgs, 'input'>>;
  shareReel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeShareReelArgs, 'id'>>;
  signup?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType, Partial<RootMutationTypeSignupArgs>>;
  startDelivery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeStartDeliveryArgs, 'id'>>;
  toggleLikeReel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeToggleLikeReelArgs, 'id'>>;
  transferCredit?: Resolver<ResolversTypes['TransferTransaction'], ParentType, ContextType, RequireFields<RootMutationTypeTransferCreditArgs, 'input'>>;
  updateChatMembers?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateChatMembersArgs, 'input'>>;
  updateCourierLastLocation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateCourierLastLocationArgs, 'input'>>;
  updateCourierOnlineStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateCourierOnlineStatusArgs, 'online'>>;
  updateDeliveryStatus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateDeliveryStatusArgs, 'id' | 'status'>>;
  updateMerchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateMerchantArgs, 'id' | 'input'>>;
  updateMultipleMerchantsSelections?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateMultipleMerchantsSelectionsArgs, 'ids' | 'selections'>>;
  updatePaymentMethod?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdatePaymentMethodArgs, 'id'>>;
  updatePickupStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeUpdatePickupStatusArgs, 'id' | 'status'>>;
  updateReel?: Resolver<ResolversTypes['Reel'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateReelArgs, 'id' | 'input'>>;
  updateReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateReviewArgs, 'id' | 'input'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType, Partial<RootMutationTypeUpdateUserArgs>>;
  updateUserPassword?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType, RequireFields<RootMutationTypeUpdateUserPasswordArgs, 'input'>>;
  uploadMedia?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<RootMutationTypeUploadMediaArgs, 'file'>>;
  uploadReel?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<RootMutationTypeUploadReelArgs, 'file'>>;
  verifyPhone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeVerifyPhoneArgs, 'input'>>;
  verifyPinOrSignature?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RootMutationTypeVerifyPinOrSignatureArgs, 'input'>>;
  viewReel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeViewReelArgs, 'id'>>;
  withdraw?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, Partial<RootMutationTypeWithdrawArgs>>;
}>;

export type RootQueryTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootQueryType'] = ResolversParentTypes['RootQueryType']> = ResolversObject<{
  balance?: Resolver<Array<Maybe<ResolversTypes['Money']>>, ParentType, ContextType>;
  chats?: Resolver<ResolversTypes['ChatsCursor'], ParentType, ContextType, Partial<RootQueryTypeChatsArgs>>;
  courier?: Resolver<ResolversTypes['Courier'], ParentType, ContextType, RequireFields<RootQueryTypeCourierArgs, 'id'>>;
  courierSearch?: Resolver<Maybe<ResolversTypes['CouriersSearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeCourierSearchArgs, 'searchQuery'>>;
  couriers?: Resolver<ResolversTypes['CouriersList'], ParentType, ContextType, Partial<RootQueryTypeCouriersArgs>>;
  couriersNearDelivery?: Resolver<Array<ResolversTypes['CourierWithDistance']>, ParentType, ContextType, RequireFields<RootQueryTypeCouriersNearDeliveryArgs, 'deliveryId' | 'radiusInMeters'>>;
  couriersWithCursorPagination?: Resolver<ResolversTypes['CourierCursor'], ParentType, ContextType, RequireFields<RootQueryTypeCouriersWithCursorPaginationArgs, 'input'>>;
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType, RequireFields<RootQueryTypeCustomerArgs, 'id'>>;
  customerSearch?: Resolver<Maybe<ResolversTypes['CustomersSearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeCustomerSearchArgs, 'searchQuery'>>;
  customers?: Resolver<Maybe<ResolversTypes['CustomersList']>, ParentType, ContextType, Partial<RootQueryTypeCustomersArgs>>;
  customersWithCursorPagination?: Resolver<ResolversTypes['CustomerCursor'], ParentType, ContextType, RequireFields<RootQueryTypeCustomersWithCursorPaginationArgs, 'input'>>;
  deliveries?: Resolver<ResolversTypes['DeliveriesList'], ParentType, ContextType, Partial<RootQueryTypeDeliveriesArgs>>;
  delivery?: Resolver<ResolversTypes['Delivery'], ParentType, ContextType, RequireFields<RootQueryTypeDeliveryArgs, 'id'>>;
  deliveryActivity?: Resolver<Array<ResolversTypes['DeliveryActivity']>, ParentType, ContextType, Partial<RootQueryTypeDeliveryActivityArgs>>;
  deliveryByOrderId?: Resolver<ResolversTypes['Delivery'], ParentType, ContextType, RequireFields<RootQueryTypeDeliveryByOrderIdArgs, 'id'>>;
  deliveryRequests?: Resolver<Array<ResolversTypes['DeliveryRequest']>, ParentType, ContextType>;
  deliverySearch?: Resolver<Maybe<ResolversTypes['DeliveriesSearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeDeliverySearchArgs, 'searchQuery'>>;
  duePaymentRequests?: Resolver<Array<ResolversTypes['PaymentRequest']>, ParentType, ContextType>;
  earnings?: Resolver<ResolversTypes['EarningsAmount'], ParentType, ContextType, Partial<RootQueryTypeEarningsArgs>>;
  error?: Resolver<Maybe<ResolversTypes['ValidationError']>, ParentType, ContextType>;
  events?: Resolver<ResolversTypes['EventsList'], ParentType, ContextType, Partial<RootQueryTypeEventsArgs>>;
  fetchBill?: Resolver<ResolversTypes['Bill'], ParentType, ContextType, RequireFields<RootQueryTypeFetchBillArgs, 'input'>>;
  fetchSavedBills?: Resolver<Array<Maybe<ResolversTypes['SavedBill']>>, ParentType, ContextType>;
  geoCoordinatesToLocation?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<RootQueryTypeGeoCoordinatesToLocationArgs, 'input'>>;
  getKycVerificationStatus?: Resolver<ResolversTypes['KycVerificationStatus'], ParentType, ContextType, Partial<RootQueryTypeGetKycVerificationStatusArgs>>;
  interswitchBankProviders?: Resolver<Array<ResolversTypes['InterswitchBank']>, ParentType, ContextType>;
  invitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootQueryTypeInvitationArgs, 'code'>>;
  isBiometricsValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootQueryTypeIsBiometricsValidArgs, 'input'>>;
  isCashtagAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootQueryTypeIsCashtagAvailableArgs, 'cashtag'>>;
  isWalletRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootQueryTypeIsWalletRegisteredArgs, 'phone'>>;
  issuedPaymentRequests?: Resolver<Array<Maybe<ResolversTypes['PaymentRequest']>>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  memberStatistics?: Resolver<ResolversTypes['MemberStatistics'], ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootQueryTypeMerchantArgs, 'id'>>;
  merchantCategories?: Resolver<Array<ResolversTypes['MerchantCategory']>, ParentType, ContextType>;
  merchantCategory?: Resolver<Maybe<ResolversTypes['MerchantCategory']>, ParentType, ContextType, RequireFields<RootQueryTypeMerchantCategoryArgs, 'id'>>;
  merchantDocuments?: Resolver<Array<ResolversTypes['MerchantDocument']>, ParentType, ContextType, Partial<RootQueryTypeMerchantDocumentsArgs>>;
  merchantSearch?: Resolver<Maybe<ResolversTypes['MerchantsSearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeMerchantSearchArgs, 'searchQuery'>>;
  merchants?: Resolver<Maybe<ResolversTypes['MerchantsList']>, ParentType, ContextType, Partial<RootQueryTypeMerchantsArgs>>;
  merchantsByCategory?: Resolver<Maybe<Array<ResolversTypes['CategorizedMerchants']>>, ParentType, ContextType, Partial<RootQueryTypeMerchantsByCategoryArgs>>;
  merchantsWithCursorPagination?: Resolver<ResolversTypes['MerchantCursor'], ParentType, ContextType, RequireFields<RootQueryTypeMerchantsWithCursorPaginationArgs, 'input'>>;
  messages?: Resolver<ResolversTypes['MessagesCursor'], ParentType, ContextType, RequireFields<RootQueryTypeMessagesArgs, 'chatId'>>;
  nearbyMerchants?: Resolver<Array<ResolversTypes['MerchantWithDistance']>, ParentType, ContextType, RequireFields<RootQueryTypeNearbyMerchantsArgs, 'currentPosition'>>;
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<RootQueryTypeOrderArgs, 'id'>>;
  orderBatches?: Resolver<ResolversTypes['OrderBatchCursor'], ParentType, ContextType, RequireFields<RootQueryTypeOrderBatchesArgs, 'input'>>;
  orders?: Resolver<Array<Maybe<ResolversTypes['Order']>>, ParentType, ContextType, Partial<RootQueryTypeOrdersArgs>>;
  ownProductsSearch?: Resolver<Maybe<ResolversTypes['OwnProductsSearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeOwnProductsSearchArgs, 'searchQuery'>>;
  paymentMethods?: Resolver<Array<Maybe<ResolversTypes['PaymentMethod']>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<RootQueryTypeProductArgs, 'id'>>;
  productCategories?: Resolver<Array<ResolversTypes['ProductCategory']>, ParentType, ContextType, Partial<RootQueryTypeProductCategoriesArgs>>;
  products?: Resolver<ResolversTypes['ProductList'], ParentType, ContextType, Partial<RootQueryTypeProductsArgs>>;
  productsWithCursorPagination?: Resolver<ResolversTypes['ProductCursor'], ParentType, ContextType, RequireFields<RootQueryTypeProductsWithCursorPaginationArgs, 'input'>>;
  recentTransactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, Partial<RootQueryTypeRecentTransactionsArgs>>;
  recentlyPurchasedFromMerchants?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType, RequireFields<RootQueryTypeRecentlyPurchasedFromMerchantsArgs, 'limit'>>;
  reel?: Resolver<ResolversTypes['Reel'], ParentType, ContextType, RequireFields<RootQueryTypeReelArgs, 'id'>>;
  reels?: Resolver<ResolversTypes['ReelsCursor'], ParentType, ContextType, Partial<RootQueryTypeReelsArgs>>;
  search?: Resolver<Maybe<ResolversTypes['SearchResult']>, ParentType, ContextType, RequireFields<RootQueryTypeSearchArgs, 'searchQuery'>>;
  searchOrders?: Resolver<ResolversTypes['SearchOrdersResult'], ParentType, ContextType, RequireFields<RootQueryTypeSearchOrdersArgs, 'input'>>;
  searchReels?: Resolver<ResolversTypes['ReelsCursor'], ParentType, ContextType, RequireFields<RootQueryTypeSearchReelsArgs, 'searchQuery'>>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<RootQueryTypeTransactionArgs, 'id'>>;
  transactionActivity?: Resolver<Array<ResolversTypes['TransactionActivity']>, ParentType, ContextType, Partial<RootQueryTypeTransactionActivityArgs>>;
  transactionCharge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType, Partial<RootQueryTypeTransactionChargeArgs>>;
  transactions?: Resolver<ResolversTypes['TransactionsList'], ParentType, ContextType, Partial<RootQueryTypeTransactionsArgs>>;
  userRegistrationStatus?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType, RequireFields<RootQueryTypeUserRegistrationStatusArgs, 'input'>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['Actor']>>>, ParentType, ContextType>;
  wishlists?: Resolver<Array<ResolversTypes['Wishlist']>, ParentType, ContextType, Partial<RootQueryTypeWishlistsArgs>>;
}>;

export type RootSubscriptionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootSubscriptionType'] = ResolversParentTypes['RootSubscriptionType']> = ResolversObject<{
  newChat?: SubscriptionResolver<ResolversTypes['ChatsCursor'], "newChat", ParentType, ContextType, Partial<RootSubscriptionTypeNewChatArgs>>;
  newMessage?: SubscriptionResolver<ResolversTypes['MessagesCursor'], "newMessage", ParentType, ContextType, RequireFields<RootSubscriptionTypeNewMessageArgs, 'chatId'>>;
  transactionUpdate?: SubscriptionResolver<ResolversTypes['Transaction'], "transactionUpdate", ParentType, ContextType, RequireFields<RootSubscriptionTypeTransactionUpdateArgs, 'input'>>;
}>;

export type SavedBillResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedBill'] = ResolversParentTypes['SavedBill']> = ResolversObject<{
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  biller?: Resolver<ResolversTypes['Biller'], ParentType, ContextType>;
  dueDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchOrdersResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOrdersResult'] = ResolversParentTypes['SearchOrdersResult']> = ResolversObject<{
  orders?: Resolver<Array<ResolversTypes['Order']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResult'] = ResolversParentTypes['SearchResult']> = ResolversObject<{
  merchants?: Resolver<Array<ResolversTypes['Merchant']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedOption'] = ResolversParentTypes['SelectedOption']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']> = ResolversObject<{
  notifications?: Resolver<Maybe<ResolversTypes['NotificationSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SystemNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemNotification'] = ResolversParentTypes['SystemNotification']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ThumbnailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Thumbnail'] = ResolversParentTypes['Thumbnail']> = ResolversObject<{
  large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface TimeInHmScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TimeInHm'], any> {
  name: 'TimeInHm';
}

export type TimeIntervalResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeInterval'] = ResolversParentTypes['TimeInterval']> = ResolversObject<{
  from?: Resolver<Maybe<ResolversTypes['TimeInHm']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['TimeInHm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimeSeriesIntervalResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeSeriesInterval'] = ResolversParentTypes['TimeSeriesInterval']> = ResolversObject<{
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = ResolversObject<{
  __resolveType: TypeResolveFn<'BillTransaction' | 'LoadCreditTransaction' | 'OrderBatchTransaction' | 'RefundTransaction' | 'TransferTransaction' | 'WithdrawTransaction', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
}>;

export type TransactionActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionActivity'] = ResolversParentTypes['TransactionActivity']> = ResolversObject<{
  sum?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  timeSeriesInterval?: Resolver<ResolversTypes['TimeSeriesInterval'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionError'] = ResolversParentTypes['TransactionError']> = ResolversObject<{
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ErrorTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionEvent'] = ResolversParentTypes['TransactionEvent']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transaction?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionsList'] = ResolversParentTypes['TransactionsList']> = ResolversObject<{
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransferTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferTransaction'] = ResolversParentTypes['TransferTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuer?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  agreedToTerms?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  identificationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identificationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kycVerificationStatus?: Resolver<Maybe<ResolversTypes['KycVerificationStatus']>, ParentType, ContextType>;
  locked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidationError'] = ResolversParentTypes['ValidationError']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ErrorTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['Wallet'] = ResolversParentTypes['Wallet']> = ResolversObject<{
  activation?: Resolver<Maybe<ResolversTypes['WalletActivation']>, ParentType, ContextType>;
  credit?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  dailySpend?: Resolver<ResolversTypes['DailySpend'], ParentType, ContextType>;
  holds?: Resolver<Array<ResolversTypes['WalletHold']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  totalHeld?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  transactionActivity?: Resolver<Array<ResolversTypes['TransactionActivity']>, ParentType, ContextType, Partial<WalletTransactionActivityArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WalletActivationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalletActivation'] = ResolversParentTypes['WalletActivation']> = ResolversObject<{
  cashtag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idPhotos?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  idType?: Resolver<Maybe<ResolversTypes['VerificationId']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WalletActivationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WalletHoldResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalletHold'] = ResolversParentTypes['WalletHold']> = ResolversObject<{
  credit?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  remark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Wishlist'] = ResolversParentTypes['Wishlist']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WithdrawTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawTransaction'] = ResolversParentTypes['WithdrawTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  referenceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  Actor?: ActorResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  Admin?: AdminResolvers<ContextType>;
  Aml?: AmlResolvers<ContextType>;
  Bill?: BillResolvers<ContextType>;
  BillTransaction?: BillTransactionResolvers<ContextType>;
  CategorizedMerchants?: CategorizedMerchantsResolvers<ContextType>;
  Chat?: ChatResolvers<ContextType>;
  ChatEdge?: ChatEdgeResolvers<ContextType>;
  ChatsCursor?: ChatsCursorResolvers<ContextType>;
  Courier?: CourierResolvers<ContextType>;
  CourierCount?: CourierCountResolvers<ContextType>;
  CourierCursor?: CourierCursorResolvers<ContextType>;
  CourierEdge?: CourierEdgeResolvers<ContextType>;
  CourierWithDistance?: CourierWithDistanceResolvers<ContextType>;
  CouriersList?: CouriersListResolvers<ContextType>;
  CouriersSearchResult?: CouriersSearchResultResolvers<ContextType>;
  CreditCardPaymentMethod?: CreditCardPaymentMethodResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerCount?: CustomerCountResolvers<ContextType>;
  CustomerCursor?: CustomerCursorResolvers<ContextType>;
  CustomerEdge?: CustomerEdgeResolvers<ContextType>;
  CustomersList?: CustomersListResolvers<ContextType>;
  CustomersSearchResult?: CustomersSearchResultResolvers<ContextType>;
  CybersourceDeviceCollectionJwt?: CybersourceDeviceCollectionJwtResolvers<ContextType>;
  CybersourceJwt?: CybersourceJwtResolvers<ContextType>;
  CybersourceStepupJwt?: CybersourceStepupJwtResolvers<ContextType>;
  DailySpend?: DailySpendResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DeliveriesList?: DeliveriesListResolvers<ContextType>;
  DeliveriesSearchResult?: DeliveriesSearchResultResolvers<ContextType>;
  Delivery?: DeliveryResolvers<ContextType>;
  DeliveryActivity?: DeliveryActivityResolvers<ContextType>;
  DeliveryRequest?: DeliveryRequestResolvers<ContextType>;
  DeliveryStatusUpdate?: DeliveryStatusUpdateResolvers<ContextType>;
  EarningsAmount?: EarningsAmountResolvers<ContextType>;
  Error?: ErrorResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  EventsList?: EventsListResolvers<ContextType>;
  ExternalAccount?: ExternalAccountResolvers<ContextType>;
  FreeMoneyDevPaymentMethod?: FreeMoneyDevPaymentMethodResolvers<ContextType>;
  GeoCoordinates?: GeoCoordinatesResolvers<ContextType>;
  HighestEver?: HighestEverResolvers<ContextType>;
  IdentificationNumberLog?: IdentificationNumberLogResolvers<ContextType>;
  IdentificationNumberLogs?: IdentificationNumberLogsResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  InformaKyb?: InformaKybResolvers<ContextType>;
  InterswitchBank?: InterswitchBankResolvers<ContextType>;
  InterswitchBankAccountPaymentMethod?: InterswitchBankAccountPaymentMethodResolvers<ContextType>;
  Invitation?: InvitationResolvers<ContextType>;
  KycVerificationLog?: KycVerificationLogResolvers<ContextType>;
  KycVerificationStatus?: KycVerificationStatusResolvers<ContextType>;
  LivenessLog?: LivenessLogResolvers<ContextType>;
  LivenessLogs?: LivenessLogsResolvers<ContextType>;
  LoadCreditTransaction?: LoadCreditTransactionResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  Login?: LoginResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MemberStatistics?: MemberStatisticsResolvers<ContextType>;
  Merchant?: MerchantResolvers<ContextType>;
  MerchantCategory?: MerchantCategoryResolvers<ContextType>;
  MerchantCount?: MerchantCountResolvers<ContextType>;
  MerchantCursor?: MerchantCursorResolvers<ContextType>;
  MerchantDocument?: MerchantDocumentResolvers<ContextType>;
  MerchantEdge?: MerchantEdgeResolvers<ContextType>;
  MerchantWithDistance?: MerchantWithDistanceResolvers<ContextType>;
  MerchantsList?: MerchantsListResolvers<ContextType>;
  MerchantsSearchResult?: MerchantsSearchResultResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageEdge?: MessageEdgeResolvers<ContextType>;
  MessagesCursor?: MessagesCursorResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  NewMessage?: NewMessageResolvers<ContextType>;
  NotificationChannel?: NotificationChannelResolvers<ContextType>;
  NotificationSettings?: NotificationSettingsResolvers<ContextType>;
  OperatingTime?: OperatingTimeResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderBatch?: OrderBatchResolvers<ContextType>;
  OrderBatchCursor?: OrderBatchCursorResolvers<ContextType>;
  OrderBatchEdge?: OrderBatchEdgeResolvers<ContextType>;
  OrderBatchTransaction?: OrderBatchTransactionResolvers<ContextType>;
  OrderListItem?: OrderListItemResolvers<ContextType>;
  OrderTracking?: OrderTrackingResolvers<ContextType>;
  OwnProductsSearchResult?: OwnProductsSearchResultResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Partner?: PartnerResolvers<ContextType>;
  PaymentMethod?: PaymentMethodResolvers<ContextType>;
  PaymentRequest?: PaymentRequestResolvers<ContextType>;
  PaymentRequestEvent?: PaymentRequestEventResolvers<ContextType>;
  PhoneNumber?: PhoneNumberResolvers<ContextType>;
  PhoneNumberLog?: PhoneNumberLogResolvers<ContextType>;
  PhoneNumberLogs?: PhoneNumberLogsResolvers<ContextType>;
  PhoneNumberPaymentMethod?: PhoneNumberPaymentMethodResolvers<ContextType>;
  Pickup?: PickupResolvers<ContextType>;
  Playback?: PlaybackResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductCategory?: ProductCategoryResolvers<ContextType>;
  ProductCursor?: ProductCursorResolvers<ContextType>;
  ProductEdge?: ProductEdgeResolvers<ContextType>;
  ProductList?: ProductListResolvers<ContextType>;
  ProductOption?: ProductOptionResolvers<ContextType>;
  ProductVariant?: ProductVariantResolvers<ContextType>;
  Reel?: ReelResolvers<ContextType>;
  ReelEdge?: ReelEdgeResolvers<ContextType>;
  ReelsCursor?: ReelsCursorResolvers<ContextType>;
  RefinitivCase?: RefinitivCaseResolvers<ContextType>;
  RefinitivScreeningResult?: RefinitivScreeningResultResolvers<ContextType>;
  RefundTransaction?: RefundTransactionResolvers<ContextType>;
  Review?: ReviewResolvers<ContextType>;
  RootMutationType?: RootMutationTypeResolvers<ContextType>;
  RootQueryType?: RootQueryTypeResolvers<ContextType>;
  RootSubscriptionType?: RootSubscriptionTypeResolvers<ContextType>;
  SavedBill?: SavedBillResolvers<ContextType>;
  SearchOrdersResult?: SearchOrdersResultResolvers<ContextType>;
  SearchResult?: SearchResultResolvers<ContextType>;
  SelectedOption?: SelectedOptionResolvers<ContextType>;
  Settings?: SettingsResolvers<ContextType>;
  SystemNotification?: SystemNotificationResolvers<ContextType>;
  Thumbnail?: ThumbnailResolvers<ContextType>;
  TimeInHm?: GraphQLScalarType;
  TimeInterval?: TimeIntervalResolvers<ContextType>;
  TimeSeriesInterval?: TimeSeriesIntervalResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionActivity?: TransactionActivityResolvers<ContextType>;
  TransactionError?: TransactionErrorResolvers<ContextType>;
  TransactionEvent?: TransactionEventResolvers<ContextType>;
  TransactionsList?: TransactionsListResolvers<ContextType>;
  TransferTransaction?: TransferTransactionResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  ValidationError?: ValidationErrorResolvers<ContextType>;
  Wallet?: WalletResolvers<ContextType>;
  WalletActivation?: WalletActivationResolvers<ContextType>;
  WalletHold?: WalletHoldResolvers<ContextType>;
  Wishlist?: WishlistResolvers<ContextType>;
  WithdrawTransaction?: WithdrawTransactionResolvers<ContextType>;
}>;

